import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { 
  Receipt, Plus, Minus, Trash2, Printer, Save, Search,
  Gamepad2, Wine, TreePine, Calculator, Clock, User, UserCircle,
  CreditCard, Wallet, CheckCircle, X, Eye, Download,
  BarChart3, TrendingUp, Calendar, Filter, Users, Package,
  Edit2, Settings, LogOut, FileText, ChevronLeft, ChevronRight,
  DollarSign, Banknote, Smartphone, ChevronsUpDown, UserPlus, RefreshCw,
  MessageCircle, Send, PieChart as PieChartIcon, UtensilsCrossed,
  ShoppingCart, AlertCircle, AlertTriangle, Image, ArrowUpDown, Activity, LayoutGrid, Timer,
  Building2, MessageSquare, Bell, BellOff, ClipboardList, ClipboardCheck, QrCode, Share2, Truck, Coins, History, BookOpen, Sunrise, CalendarClock, Sparkles, ChefHat, Globe, Pencil, Lock, KeyRound, Menu, MoreVertical, Percent
} from "lucide-react";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import { format, subDays, startOfMonth, endOfMonth, startOfWeek } from "date-fns";
import { fr } from "date-fns/locale";
import QRCode from "qrcode";

// Offline auth helpers
import { rememberLogin, tryLocalLogin, isNetworkError } from "./caisse/utils/offlineAuth";
import { refillIfLow as refillInvoiceNumbers } from "../lib/offlineInvoiceNumbers";
import OfflinePreallocBadge from "./caisse/components/OfflinePreallocBadge";
import SiteNotificationsBell from "./caisse/components/SiteNotificationsBell";
import SiteNotificationsPanel from "./caisse/components/SiteNotificationsPanel";
import InlinePriceHint from "./caisse/components/InlinePriceHint";

// Extracted components
import TablesTab from "./caisse/components/TablesTab";
import RespOpWelcome from "./caisse/components/RespOpWelcome";
import WeeklyScheduleTab from "./caisse/components/WeeklyScheduleTab";
import FieldStockReportModal from "./caisse/components/FieldStockReportModal";
import DiscountAuthPanel from "./caisse/components/DiscountAuthPanel";
import MomoDailyRecap from "./caisse/components/MomoDailyRecap";
import CustomerReviewsTab from "./caisse/components/CustomerReviewsTab";
import BillettageGlobalCard from "./caisse/components/BillettageGlobalCard";
import LocationsTab from "./caisse/components/LocationsTab";
import InstructionsTab from "./caisse/components/InstructionsTab";
import ProformaTab from "./caisse/components/ProformaTab";
import ConditioningSuggester from "./caisse/components/ConditioningSuggester";
import SubscriptionsTab from "./caisse/components/SubscriptionsTab";
import ShareModal, { ShareButton } from "./caisse/components/ShareModal";
import MonsieurTab from "./caisse/components/MonsieurTab";
import PointFinancierTab from "./caisse/components/PointFinancierTab";
import PointsHistoryTab from "./caisse/components/PointsHistoryTab";
import ActiviteTab from "./caisse/components/ActiviteTab";
import UsersTab from "./caisse/components/UsersTab";
import ClientsTab from "./caisse/components/ClientsTab";
import PointCaisseTab from "./caisse/components/PointCaisseTab";
import JourneeTab from "./caisse/components/JourneeTab";
import QuickProductPicker from "./caisse/components/QuickProductPicker";
import CoursesTab from "./caisse/components/CoursesTab";
import ClosureLockBanner from "./caisse/components/ClosureLockBanner";
import ProductsTab from "./caisse/components/ProductsTab";
import LinkStockModal from "./caisse/components/LinkStockModal";
import MultiLinkStockModal from "./caisse/components/MultiLinkStockModal";
import BonsTab from "./caisse/components/BonsTab";
import StatsTab from "./caisse/components/StatsTab";
import ForecastsTab from "./caisse/components/ForecastsTab";
import JournalTab from "./caisse/components/JournalTab";
import OfflineIndicator from "../components/OfflineIndicator";
import WeakConnectionBanner from "../components/WeakConnectionBanner";
import LockScreen from "../components/LockScreen";
import useInactivityLock from "../hooks/useInactivityLock";
import GuestLoginModal from "../components/GuestLoginModal";
import GuestRequestsBanner from "../components/admin/GuestRequestsBanner";
import GuestCodesManagerPanel from "../components/admin/GuestCodesManagerPanel";
import SalariesTab from "./caisse/components/SalariesTab";
import ValidDemandsTab from "./caisse/components/ValidDemandsTab";
import AdminMegaMenu from "../components/admin/AdminMegaMenu";
import AdminBottomNav from "../components/admin/AdminBottomNav";
import AdminSidebar from "../components/admin/AdminSidebar";
import CaisseVerticalHub from "../components/admin/CaisseVerticalHub";
import MobileMenuHub from "../components/admin/MobileMenuHub";
import CaisseTopNav from "../components/admin/CaisseTopNav";
import { trySync } from "../lib/offlineSync";
import RegularizationModal from "../components/RegularizationModal";
import KitchenTrackerModal from "./caisse/components/KitchenTrackerModal";
import JeuxBonsModal from "./caisse/components/JeuxBonsModal";
import CustomerBonMessageButton from "./caisse/components/CustomerBonMessageButton";
import CuisinePage from "./CuisinePage";
import CoachJeuxPage from "./CoachJeuxPage";
import useReadyNotifications from "../hooks/useReadyNotifications";
import AuditLogsTab from "./caisse/components/AuditLogsTab";
import NeedsTab from "./caisse/components/NeedsTab";
import NotificationsTab from "./caisse/components/NotificationsTab";
import CurrentAccountsTab from "./caisse/components/CurrentAccountsTab";
import TipsTab from "./caisse/components/TipsTab";
import AchatsTab from "./caisse/components/AchatsTab";
import CommandeTab from "./caisse/components/CommandeTab";
import { NotifBadge, NotificationBell, CrossRoleBanner } from "./caisse/components/NotificationCenter";
import { useNotifications } from "./caisse/hooks/useNotifications";
import ExpenseAnalysisBadges from "./caisse/components/ExpenseAnalysisBadges";
import ForgotCodeModal from "./caisse/components/modals/ForgotCodeModal";
import NewTableModal from "./caisse/components/modals/NewTableModal";
import ClientModal from "./caisse/components/modals/ClientModal";
import UserModal from "./caisse/components/modals/UserModal";
import LabelsEditorModal from "./caisse/components/modals/LabelsEditorModal";
import PaymentMethodModal from "./caisse/components/modals/PaymentMethodModal";
import ViewInvoiceModal from "./caisse/components/modals/ViewInvoiceModal";
import MobilePaymentModal from "./caisse/components/modals/MobilePaymentModal";
import FreeAccompModal from "./caisse/components/modals/FreeAccompModal";
import ProductModal from "./caisse/components/modals/ProductModal";
import EditingInvoiceModal from "./caisse/components/modals/EditingInvoiceModal";
import ExpenseModal from "./caisse/components/modals/ExpenseModal";
import ShoppingListModal from "./caisse/components/modals/ShoppingListModal";
// 🆕 (Feb 2026) Refactor Vague 1 — hooks extraits
import { useExpensesHandlers } from "./caisse/hooks/useExpensesHandlers";
import { useTablesHandlers } from "./caisse/hooks/useTablesHandlers";
// 🆕 (Feb 2026) Refactor Vague 2 — utilitaires d'impression extraits
import {
  printKitchenOrder as _printKitchenOrder,
  printBarOrder as _printBarOrder,
  printGamesOrder as _printGamesOrder,
  printTicket as _printTicket,
  downloadPDF,
} from "./caisse/utils/printHelpers";
import { PRODUCTION_LABELS, missingProductionBons } from "./caisse/utils/productionBons";

// Taxonomy (type achat/paiement, destinations, libellés prédéfinis paiements)
import {
  EXPENSE_TYPES,
  DESTINATIONS,
  PREDEFINED_PAYMENTS,
  PAYMENT_GROUPS,
} from "./caisse/constants/expenseTaxonomy";

// Import logo for printing
import { LOGO_BASE64 } from "./caisse/constants_logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Helper — Renvoie le libellé de validation avec rôle (utilisé sur les tickets imprimés)
// Ex: "Mères AHOUANDJINOU — Responsable des Opérations & Logistique"
const formatValidatorLabel = (user) => {
  if (!user) return "Utilisateur";
  const name = user.full_name || user.username || "Utilisateur";
  if (user.role === "manager") return `${name} — Responsable des Opérations & Logistique`;
  if (user.role === "admin") return `${name} — Administrateur`;
  return name;
};

// Default catalog items
const DEFAULT_CATALOG = {
  salle_jardin: [
    // === ENTRÉES ===
    { id: "salade_nicoise", name: "Salade niçoise", price: 4000, unit: "portion", category: "Entrées" },
    { id: "salade_crudites", name: "Salade crudités", price: 2500, unit: "portion", category: "Entrées" },
    { id: "salade_cesar", name: "Salade César", price: 4500, unit: "portion", category: "Entrées" },
    { id: "salade_maxo", name: "Salade Maxo", price: 5000, unit: "portion", category: "Entrées" },
    { id: "salade_avocat_crevettes", name: "Salade Avocat crevettes", price: 4500, unit: "portion", category: "Entrées" },
    { id: "salade_thon", name: "Salade au thon", price: 4000, unit: "portion", category: "Entrées" },
    { id: "salade_verte", name: "Salade verte", price: 1500, unit: "portion", category: "Entrées" },
    { id: "samossas_poulet", name: "Samossas au Poulet", price: 2500, unit: "portion", category: "Entrées" },
    { id: "samossas_viande", name: "Samossas à la viande", price: 2500, unit: "portion", category: "Entrées" },
    { id: "neems", name: "Neems Poulet/Viande", price: 2500, unit: "portion", category: "Entrées" },
    // === PLATS PRINCIPAUX ===
    { id: "poulet_curry", name: "Sauce Poulet au Curry", price: 5000, unit: "plat", category: "Plats" },
    { id: "filet_boeuf_champignons", name: "Filet de Boeuf sauce champignons", price: 6000, unit: "plat", category: "Plats" },
    { id: "steaks_grilles", name: "Steaks Grillés", price: 5000, unit: "plat", category: "Plats" },
    { id: "steak_poivre", name: "Steak au poivre", price: 5500, unit: "plat", category: "Plats" },
    { id: "spaghetti_bolognaise", name: "Spaghetti bolognaise", price: 4000, unit: "plat", category: "Plats" },
    { id: "tagliatelles_crevettes", name: "Tagliatelles crevettes", price: 5000, unit: "plat", category: "Plats" },
    { id: "choukouya_mouton", name: "Choukouya Mouton", price: 5000, unit: "plat", category: "Grillades" },
    { id: "choukouya_bicyclette", name: "Choukouya Poulet Bicyclette", price: 6000, unit: "plat", category: "Grillades" },
    { id: "choukouya_chair", name: "Choukouya Poulet Chair (Demi)", price: 5000, unit: "plat", category: "Grillades" },
    { id: "poulet_demi", name: "Poulet Frit/Grillé/BBQ (Demi)", price: 5000, unit: "plat", category: "Grillades" },
    { id: "poulet_complet", name: "Poulet Frit/Grillé/BBQ (Complet)", price: 9000, unit: "plat", category: "Grillades" },
    { id: "poulet_bicyclette", name: "Poulet Bicyclette Complet", price: 6000, unit: "plat", category: "Grillades" },
    { id: "lapin", name: "Lapin frit/Braisé/Grillé", price: 4000, unit: "portion", category: "Grillades" },
    { id: "mouton", name: "Mouton frit/braisé/Grillé", price: 5000, unit: "plat", category: "Grillades" },
    { id: "langue_boeuf", name: "Langue de Boeuf Braisé/Grillé", price: 5000, unit: "plat", category: "Grillades" },
    { id: "poisson", name: "Poisson frit/Braisé/Grillé", price: 6000, unit: "plat", category: "Grillades" },
    { id: "aileron", name: "Aileron Frit/Braisé/Grillé", price: 5000, unit: "plat", category: "Grillades" },
    { id: "agneau", name: "Agneau Frit/Braisé/Grillé", price: 5000, unit: "plat", category: "Grillades" },
    // === SAUCES AFRICAINES ===
    { id: "sauce_legume", name: "Sauce Légume GBOMA/TCHIAVO", price: 5000, unit: "plat", category: "Sauces" },
    { id: "sauce_legume_mixte", name: "Sauce Légume Mixte", price: 5500, unit: "plat", category: "Sauces" },
    { id: "sauce_vassa", name: "Sauce Vassa", price: 5000, unit: "plat", category: "Sauces" },
    { id: "sauce_assrokouin", name: "Sauce Assrokouin", price: 5000, unit: "plat", category: "Sauces" },
    { id: "sauce_arachide", name: "Sauce Arachide", price: 5000, unit: "plat", category: "Sauces" },
    { id: "agneau_arachide", name: "Agneau en Sauce Arachide", price: 5000, unit: "plat", category: "Sauces" },
    { id: "agneau_tomate", name: "Agneau en sauce Tomate", price: 5000, unit: "plat", category: "Sauces" },
    { id: "sauce_goussi", name: "Sauce Goussi (Sésame)", price: 5000, unit: "plat", category: "Sauces" },
    { id: "moyo_poisson", name: "Moyo Poisson", price: 6000, unit: "plat", category: "Sauces" },
    { id: "dakouin", name: "DAKOUIN", price: 6000, unit: "plat", category: "Sauces" },
    // === BURGERS ===
    { id: "meetburger", name: "MeetBurger", price: 2500, unit: "pièce", category: "Burgers" },
    { id: "cheeseburger", name: "CheeseBurger", price: 3000, unit: "pièce", category: "Burgers" },
    { id: "double_cheese", name: "Double Cheese Burger", price: 5000, unit: "pièce", category: "Burgers" },
    { id: "kingburger", name: "KingBurger", price: 3500, unit: "pièce", category: "Burgers" },
    { id: "burger_maxo", name: "Burger Maxo", price: 4000, unit: "pièce", category: "Burgers" },
    // === SANDWICHS ===
    { id: "chawarma_viande", name: "Chawarma Viande", price: 2000, unit: "pièce", category: "Sandwichs" },
    { id: "chawarma_poulet", name: "Chawarma Poulet", price: 2500, unit: "pièce", category: "Sandwichs" },
    { id: "sandwich_poisson", name: "Sandwich au Poisson/Frite", price: 3000, unit: "pièce", category: "Sandwichs" },
    { id: "sandwich_fajitas", name: "Sandwich Fajitas/Frite", price: 3000, unit: "pièce", category: "Sandwichs" },
    { id: "sandwich_philadelphia", name: "Sandwich Philadelphia/Frite", price: 3000, unit: "pièce", category: "Sandwichs" },
    { id: "sandwich_maxo", name: "Sandwich MAXO/Frite", price: 3000, unit: "pièce", category: "Sandwichs" },
    // === PIZZAS ===
    { id: "pizza_reine", name: "Pizza Reine", price: 5000, unit: "pièce", category: "Pizzas" },
    { id: "pizza_4saisons", name: "Pizza 4 saisons", price: 5000, unit: "pièce", category: "Pizzas" },
    { id: "pizza_margherita", name: "Pizza Margherita", price: 4500, unit: "pièce", category: "Pizzas" },
    { id: "pizza_maxo", name: "Pizza Maxo", price: 6000, unit: "pièce", category: "Pizzas" },
    { id: "pizza_vegetarienne", name: "Pizza Végétarienne", price: 5000, unit: "pièce", category: "Pizzas" },
    { id: "pizza_bolognaise", name: "Pizza Bolognaise", price: 5000, unit: "pièce", category: "Pizzas" },
    // === DESSERTS ===
    { id: "crepe_nature", name: "Crêpe Nature", price: 700, unit: "pièce", category: "Desserts" },
    { id: "crepe_nutella", name: "Crêpe au Nutella", price: 1500, unit: "pièce", category: "Desserts" },
    { id: "salade_fruit", name: "Salade de Fruit", price: 1000, unit: "portion", category: "Desserts" },
    { id: "ananas_pirogue", name: "Ananas Pirogue", price: 1000, unit: "portion", category: "Desserts" },
    { id: "assiette_fruit", name: "Assiette de Fruit", price: 1500, unit: "portion", category: "Desserts" },
    { id: "glace_boule", name: "Glace (Chocolat/Fraise/Vanille)", price: 1000, unit: "boule", category: "Desserts" },
    { id: "coupe_glace", name: "Coupe de glace (3 boules)", price: 2500, unit: "coupe", category: "Desserts" },
  ],
  accompagnements: [
    { id: "riz_blanc", name: "Riz blanc", price: 1000, unit: "portion", category: "Riz" },
    { id: "riz_cantonais", name: "Riz Cantonais", price: 1500, unit: "portion", category: "Riz" },
    { id: "riz_legumes", name: "Riz aux légumes", price: 1500, unit: "portion", category: "Riz" },
    { id: "spaghetti_accomp", name: "Spaghetti (Sauté)", price: 1000, unit: "portion", category: "Pâtes" },
    { id: "pate_rouge_blanc", name: "Pâtes (Rouge/Blanc)", price: 1000, unit: "portion", category: "Pâtes" },
    { id: "couscous", name: "Couscous (au gras/Blanc)", price: 1000, unit: "portion", category: "Féculents" },
    { id: "pomme_saute", name: "Pomme sautée", price: 1500, unit: "portion", category: "Frites" },
    { id: "frite_surgelee", name: "Frite surgelée", price: 1000, unit: "portion", category: "Frites" },
    { id: "frite_nature", name: "Frite Nature", price: 1500, unit: "portion", category: "Frites" },
    { id: "atieke", name: "Atiéké", price: 1000, unit: "portion", category: "Traditionnel" },
    { id: "akassa", name: "Akassa", price: 500, unit: "portion", category: "Traditionnel" },
    { id: "pate_blanche", name: "Pâte Blanche (Maïs)", price: 1000, unit: "portion", category: "Traditionnel" },
    { id: "pate_noire", name: "Pâte Noire (Télibo)", price: 1000, unit: "portion", category: "Traditionnel" },
    { id: "pate_rouge", name: "Pâte Rouge (Amiwo)", price: 1000, unit: "portion", category: "Traditionnel" },
  ],
  jeux: [
    { id: "vr360", name: "VR 360°", price: 2000, unit: "partie", category: "Jeux VR" },
    { id: "simulateur", name: "Simulateur Course", price: 1500, unit: "partie", category: "Simulateur" },
  ],
  bar: [
    // === JUS FRAIS ===
    { id: "jus_orange", name: "Jus d'orange", price: 1000, unit: "verre", category: "Jus Frais" },
    { id: "jus_ananas", name: "Jus d'ananas", price: 1000, unit: "verre", category: "Jus Frais" },
    { id: "jus_pasteque", name: "Jus de pastèque", price: 1000, unit: "verre", category: "Jus Frais" },
    { id: "jus_mixte", name: "Jus Mixte (Mélange)", price: 1500, unit: "verre", category: "Jus Frais" },
    // === SODAS ===
    { id: "world_cola", name: "World Cola", price: 1000, unit: "bouteille", category: "Sodas" },
    { id: "coca", name: "Coca-Cola", price: 500, unit: "bouteille", category: "Sodas" },
    { id: "fanta", name: "Fanta", price: 500, unit: "bouteille", category: "Sodas" },
    { id: "sprite", name: "Sprite", price: 500, unit: "bouteille", category: "Sodas" },
    { id: "eau", name: "Eau minérale", price: 300, unit: "bouteille", category: "Boissons" },
    // === BIÈRES ===
    { id: "beninoise", name: "Béninoise 0,33cl", price: 1000, unit: "bouteille", category: "Bières" },
    { id: "sombrero", name: "Sombrero 0,33cl", price: 1000, unit: "bouteille", category: "Bières" },
    { id: "guinness", name: "Guinness 0,33cl", price: 1500, unit: "bouteille", category: "Bières" },
    { id: "chill", name: "Chill 0,33cl", price: 1000, unit: "bouteille", category: "Bières" },
    // === CHAUD ===
    { id: "cafe", name: "Café", price: 500, unit: "tasse", category: "Chaud" },
    { id: "the", name: "Thé", price: 400, unit: "tasse", category: "Chaud" },
  ],
  location: [
    { id: "salle_complete", name: "Location salle complète", price: 50000, unit: "journée", category: "Location" },
    { id: "salle_demi", name: "Location demi-journée", price: 30000, unit: "demi-journée", category: "Location" },
    { id: "espace_vip", name: "Espace VIP", price: 25000, unit: "soirée", category: "Location" },
  ],
  autres: []
};

const DEPARTMENT_CONFIG = {
  salle_jardin: { label: "Plats", icon: UtensilsCrossed, color: "text-green-400", bgColor: "bg-green-500/10", borderColor: "border-green-500/30" },
  accompagnements: { label: "Accomp.", icon: Package, color: "text-yellow-400", bgColor: "bg-yellow-500/10", borderColor: "border-yellow-500/30" },
  jeux: { label: "Jeux", icon: Gamepad2, color: "text-blue-400", bgColor: "bg-blue-500/10", borderColor: "border-blue-500/30" },
  bar: { label: "Bar", icon: Wine, color: "text-orange-400", bgColor: "bg-orange-500/10", borderColor: "border-orange-500/30" },
  location: { label: "Location", icon: Calendar, color: "text-purple-400", bgColor: "bg-purple-500/10", borderColor: "border-purple-500/30" },
  autres: { label: "Autres", icon: Package, color: "text-slate-400", bgColor: "bg-slate-500/10", borderColor: "border-slate-500/30" }
};

const PAYMENT_METHODS = [
  { value: "cash", label: "Espèces", icon: Banknote },
  { value: "card", label: "Carte bancaire", icon: CreditCard },
  { value: "mobile", label: "Mobile Money", icon: Smartphone },
  { value: "kkiapay", label: "KKiapay", icon: Wallet },
  { value: "wallet", label: "Porte-monnaie", icon: Wallet },
  { value: "check", label: "Chèque", icon: FileText },
];

const CaissePage = () => {
  // Auth state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loginForm, setLoginForm] = useState({ pin: "", password: "" });
  const [loginMode, setLoginMode] = useState("pin"); // pin or admin
  const [showForgotCodeModal, setShowForgotCodeModal] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const megaMenuRef = useRef(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // ============== VERROUILLAGE CAISSE (auto 5min + bouton manuel + override admin) ==============
  // ⚠️ Désactivé pour les sessions invité (currentUser.is_guest = true)
  const inactivityLock = useInactivityLock({ disabled: !isAuthenticated || !!currentUser?.is_guest });
  const { locked: caisseLocked, lock: lockCaisse, unlock: unlockCaisse } = inactivityLock;
  // Handler de déverrouillage : si admin override → met à jour la session
  const handleUnlock = (newUser) => {
    if (newUser && currentUser && newUser.id !== currentUser.id && newUser.role === "admin") {
      // Admin a pris la main — on remplace l'utilisateur courant
      setCurrentUser(newUser);
    }
    unlockCaisse();
  };

  // Audit actor query string (added to mutation URLs so the audit log knows
  // which user performed the action — visible only to admins).
  const actorQs = () => {
    if (!currentUser) return "";
    const name = encodeURIComponent(currentUser.full_name || currentUser.username || "—");
    const role = encodeURIComponent(currentUser.role || "manager");
    return `actor_name=${name}&actor_role=${role}`;
  };
  
  // Main state
  const [activeTab, setActiveTab] = useState("tables");
  // 🆕 (Fév 2026) Autorisation Remises
  const [discountAuthOpen, setDiscountAuthOpen] = useState(false);
  const [discountAuthActive, setDiscountAuthActive] = useState(false);
  const [activeDepartment, setActiveDepartment] = useState("salle_jardin");
  const [productSearch, setProductSearch] = useState("");

  // ============== NOTIFICATIONS (extracted to hook) ==============
  
  // Catalog/Products
  const [products, setProducts] = useState([]);
  const [catalog, setCatalog] = useState(DEFAULT_CATALOG);
  
  // Multi-table system
  const [openTables, setOpenTables] = useState([]);
  // 🆕 (Fév 2026) Map des états cuisine par table_id — { [caisse_table_id]: {status, cook_name, ...} }
  const [kitchenStatusByTable, setKitchenStatusByTable] = useState({});

  // Fetch régulier de l'état cuisine (30s) pour afficher un badge par table
  useEffect(() => {
    const fetchKitchenStatus = async () => {
      try {
        const r = await axios.get(`${API}/kitchen-orders/by-table`);
        setKitchenStatusByTable(r.data?.by_table || {});
      } catch { /* silent */ }
    };
    fetchKitchenStatus();
    const t = setInterval(fetchKitchenStatus, 30000);
    return () => clearInterval(t);
  }, []); // All open tables from DB
  const [activeTableId, setActiveTableId] = useState(null); // Currently active table ID
  // ── Notifications "Plats prêts" depuis la cuisine ──
  const readyNotif = useReadyNotifications(currentUser);
  // ── Régularisation rétroactive (Admin + Resp. Op.) ──
  const [showRegularizationModal, setShowRegularizationModal] = useState(false);
  const [regularizationMode, setRegularizationMode] = useState("create"); // "create" | "update-date"
  const [regularizationTargetInvoice, setRegularizationTargetInvoice] = useState(null);
  const [showNewTableModal, setShowNewTableModal] = useState(false);
  const [availableTableNumbers, setAvailableTableNumbers] = useState([]);
  
  // Current bill (derived from active table)
  const [currentBill, setCurrentBill] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [discount, setDiscount] = useState(0);
  const [notes, setNotes] = useState("");
  
  // Custom item form (for "Autres" department)
  const [customItem, setCustomItem] = useState({ name: "", price: 0 });
  
  // Data
  const [invoices, setInvoices] = useState([]);
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState(null);
  const [monthlyStats, setMonthlyStats] = useState(null);
  
  // Notification sound for validated invoices
  const [lastValidatedCount, setLastValidatedCount] = useState(0);
  const audioRef = useRef(null);
  
  // Filters
  const [filterDate, setFilterDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [filterMonth, setFilterMonth] = useState(format(new Date(), "yyyy-MM"));
  const [filterValidation, setFilterValidation] = useState("all"); // all, pending, validated

  // Force la Responsable Op. & Log à n'avoir que la date du jour (pas d'historique factures)
  useEffect(() => {
    if (currentUser && currentUser.role !== 'admin') {
      const today = format(new Date(), "yyyy-MM-dd");
      if (filterDate !== today) setFilterDate(today);
    }
  }, [currentUser, filterDate]);
  
  // Modals
  const [viewInvoice, setViewInvoice] = useState(null);
  const [editInvoice, setEditInvoice] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  // Libellés personnalisables du modal "Ajouter un produit" (Admin uniquement)
  const [productLabels, setProductLabels] = useState({
    title_create: "Ajouter un produit",
    title_edit: "Modifier le produit",
    description: "",
    is_custom: false,
  });
  const [showLabelsEditor, setShowLabelsEditor] = useState(false);
  const [labelsForm, setLabelsForm] = useState({ title_create: "", title_edit: "", description: "" });
  const [savingLabels, setSavingLabels] = useState(false);
  const [stockSuggestions, setStockSuggestions] = useState([]);
  const [showLinkStockModal, setShowLinkStockModal] = useState(false);
  const [linkStockTarget, setLinkStockTarget] = useState(null);
  const [showMultiLinkModal, setShowMultiLinkModal] = useState(false);
  const [showClientModal, setShowClientModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showMobilePaymentModal, setShowMobilePaymentModal] = useState(false);
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [pendingValidationInvoice, setPendingValidationInvoice] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("cash");
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
  const [pendingInvoiceData, setPendingInvoiceData] = useState(null);
  const [editProduct, setEditProduct] = useState(null);
  const [editClient, setEditClient] = useState(null);
  const [editUser, setEditUser] = useState(null);
  
  // Forms
  const [productForm, setProductForm] = useState({ name: "", price: 0, department: "bar", unit: "unité", category: "" });
  const [clientForm, setClientForm] = useState({ name: "", phone: "", email: "", notes: "" });
  const [userForm, setUserForm] = useState({ username: "", email: "", password: "", pin: "", role: "server", full_name: "" });
  
  // Rapport Journalier
  const [rapportDate, setRapportDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [rapportData, setRapportData] = useState(null);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatureData, setSignatureData] = useState(null);
  const [signature, setSignature] = useState("");
  const [selectedServerDetail, setSelectedServerDetail] = useState(null);
  const [serverInvoices, setServerInvoices] = useState([]);
  
  // Historique des factures
  const [historyDate, setHistoryDate] = useState(format(subDays(new Date(), 1), "yyyy-MM-dd"));
  const [historyInvoices, setHistoryInvoices] = useState([]);
  
  // Cancellation requests
  const [cancellationRequests, setCancellationRequests] = useState([]);
  const [lastCancellationCount, setLastCancellationCount] = useState(0);
  
  // Modification requests
  const [modificationRequests, setModificationRequests] = useState([]);
  const [lastModificationCount, setLastModificationCount] = useState(0);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editingItems, setEditingItems] = useState([]);
  
  // Pending orders count for servers
  const [lastPendingCount, setLastPendingCount] = useState(0);

  // ============== MENU NOTIFICATIONS (for Admin) ==============
  const [menuNotifications, setMenuNotifications] = useState([]);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [showNotificationsPanel, setShowNotificationsPanel] = useState(false);

  // ============== SERVER DAILY POINT ==============
  const [serverDailyReport, setServerDailyReport] = useState(null);
  const [serverReportDate, setServerReportDate] = useState(format(new Date(), "yyyy-MM-dd"));

  // ============== END OF SERVICE (for servers) ==============
  const [showEndOfServiceModal, setShowEndOfServiceModal] = useState(false);
  const [endOfServiceObservation, setEndOfServiceObservation] = useState("");
  const [isSubmittingEndOfService, setIsSubmittingEndOfService] = useState(false);

  // ============== SERVICE REPORTS (for Manager) ==============
  const [serviceReports, setServiceReports] = useState([]);
  const [unreadServiceReportsCount, setUnreadServiceReportsCount] = useState(0);
  const [showServiceReportsPanel, setShowServiceReportsPanel] = useState(false);
  
  // ============== SHARE MODAL ==============
  const [showShareModal, setShowShareModal] = useState(false);

  // ============== KITCHEN TRACKER MODAL (Resp. Op./Admin) ==============
  const [showKitchenTracker, setShowKitchenTracker] = useState(false);
  const [kitchenUnreadCount, setKitchenUnreadCount] = useState(0);
  const [kitchenPendingCount, setKitchenPendingCount] = useState(0);
  const kitchenLastIdsRef = useRef(new Set());

  // ============== JEUX BONS MODAL (Resp. Op./Admin) ==============
  const [showJeuxBonsModal, setShowJeuxBonsModal] = useState(false);
  const [jeuxPendingCount, setJeuxPendingCount] = useState(0);
  const jeuxLastIdsRef = useRef(new Set());

  // ============== FIELD STOCK REPORT (Resp. Op./Admin) ==============
  // Point de stock terrain indépendant du stock système — accessible via l'onglet
  // "Point de stock". L'admin reçoit un badge avec le nombre de rapports en attente.
  const [fieldStockPendingCount, setFieldStockPendingCount] = useState(0);
  
  // ============== NOTES/INSTRUCTIONS NOTIFICATIONS ==============
  const [unreadNotesCount, setUnreadNotesCount] = useState(0);
  
  // Detailed view of a server's point (for Manager)
  const [viewingServerReport, setViewingServerReport] = useState(null);
  const [viewingServerDetailedReport, setViewingServerDetailedReport] = useState(null);
  const [loadingServerDetail, setLoadingServerDetail] = useState(false);

  // ============== EXPENSES (Achats/Dépenses) ==============
  const [expenses, setExpenses] = useState([]);
  const [expenseAnalyses, setExpenseAnalyses] = useState({}); // { [expenseId]: analysis }
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [editingExpense, setEditingExpense] = useState(null);
  const [expenseForm, setExpenseForm] = useState({
    category: "cuisine",
    description: "",
    quantity: 1,
    unit_price: 0,
    amount: 0,
    supplier: "",
    planned_date: format(new Date(), "yyyy-MM-dd"),
    receipt_image: null,
    funded_by_account_id: "",
    funded_by_account_name: "",
    funded_affects_ca: true,
    // Type & destination (29/04/2026)
    expense_type: "achat",
    destination: "cuisine",
    // Stock flow (21/05/2026) — toggle global "Passer en stock"
    to_stock: false,
  });
  // Available current accounts (for funding-source selector)
  const [availableAccounts, setAvailableAccounts] = useState([]);
  
  // Achats communs - multi-items
  const [commonItems, setCommonItems] = useState([]);
  const [commonNewItem, setCommonNewItem] = useState({ category: "cuisine", description: "", quantity: 0, unit_price: 0, expense_type: "achat", destination: "cuisine", passer_en_stock: null });

  // Admin revision modal (modify expense before sending back to manager)
  const [showReviseModal, setShowReviseModal] = useState(false);
  const [revisingExpense, setRevisingExpense] = useState(null);
  const [reviseItems, setReviseItems] = useState([]);
  const [reviseSupplier, setReviseSupplier] = useState("");
  const [reviseNote, setReviseNote] = useState("");
  const [reviseNewItem, setReviseNewItem] = useState({ category: "cuisine", description: "", quantity: 1, unit_price: 0 });

  // Revision notifications for Manager
  const [revisionExpensesCount, setRevisionExpensesCount] = useState(0);
  const [showRevisionPanel, setShowRevisionPanel] = useState(false);
  
  // Liste d'achats multiple
  const [shoppingList, setShoppingList] = useState([]);
  const [showShoppingListModal, setShowShoppingListModal] = useState(false);
  const [shoppingListSupplier, setShoppingListSupplier] = useState("");
  const [shoppingListDate, setShoppingListDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [newListItem, setNewListItem] = useState({ category: "cuisine", description: "", quantity: 1, unit_price: 0, supplier: "" });
  const [showAllExpenses, setShowAllExpenses] = useState(false);
  // Sub-view filter for Achats tab: 'en_cours' (pending/revision/approved) or 'valides' (approved+completed)
  const [achatsSubView, setAchatsSubView] = useState('en_cours');
  
  // Expense week assignment
  const [showWeekAssignModal, setShowWeekAssignModal] = useState(false);
  const [expenseToAssign, setExpenseToAssign] = useState(null);

  // ============== FAIRE LE POINT (Rapport période : jour / semaine / personnalisé) ==============
  const [weeklyReport, setWeeklyReport] = useState(null);
  const [weekStartDate, setWeekStartDate] = useState(format(startOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd"));
  // Sub-tab active inside the "Faire le point" tab ("reversement" | "point-history")
  const [hebdoSubTab, setHebdoSubTab] = useState("reversement");
  // Sub-sub-tab active inside the "Reversement" sub-menu ("bar" | "menu_combos" | "jeux" | "locations")
  const [reversementSubTab, setReversementSubTab] = useState("bar");
  // Date du billettage global (par défaut : aujourd'hui)
  const [billettageDate, setBillettageDate] = useState(format(new Date(), "yyyy-MM-dd"));
  // Force la Resp. Op. sur la date du jour pour le billettage
  useEffect(() => {
    if (currentUser && currentUser.role !== 'admin') {
      const today = format(new Date(), "yyyy-MM-dd");
      if (billettageDate !== today) setBillettageDate(today);
    }
  }, [currentUser, billettageDate]);

  // Chargement des libellés personnalisés du modal "Ajouter un produit"
  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/admin/ui-labels/caisse_product_add`);
        if (!cancelled && r.data) {
          setProductLabels({
            title_create: r.data.title_create || "Ajouter un produit",
            title_edit: r.data.title_edit || "Modifier le produit",
            description: r.data.description || "",
            is_custom: !!r.data.is_custom,
          });
        }
      } catch (_) {
        /* fallback aux défauts déjà en state */
      }
    })();
    return () => { cancelled = true; };
  }, [isAuthenticated]);

  // ============== Surveillance session Invité ==============
  // Si l'admin révoque la session ou si l'expiration est atteinte, on déconnecte.
  useEffect(() => {
    if (!isAuthenticated || !currentUser?.is_guest || !currentUser?.guest_request_id) return undefined;
    const reqId = currentUser.guest_request_id;
    let cancelled = false;
    const check = async () => {
      try {
        const r = await axios.get(`${API}/guest/request-status/${reqId}`, { timeout: 6000 });
        if (cancelled) return;
        const s = r.data?.status;
        if (s && s !== "approved") {
          const reasons = {
            revoked: "Ta session a été révoquée par l'Administrateur.",
            expired: "Ta session invité a expiré (fin de journée).",
            logged_out: "Tu as été déconnecté.",
            rejected: "Accès refusé par l'Administrateur.",
          };
          toast.error(reasons[s] || "Session invité terminée");
          setTimeout(() => {
            setIsAuthenticated(false);
            setCurrentUser(null);
          }, 600);
        }
      } catch {
        /* silent */
      }
    };
    check();
    const id = setInterval(check, 8000);
    return () => { cancelled = true; clearInterval(id); };
  }, [isAuthenticated, currentUser]);

  // Ouverture du modal d'édition des libellés (admin uniquement)
  const openLabelsEditor = () => {
    setLabelsForm({
      title_create: productLabels.title_create,
      title_edit: productLabels.title_edit,
      description: productLabels.description,
    });
    setShowLabelsEditor(true);
  };

  // Sauvegarde des libellés personnalisés
  const saveLabels = async () => {
    setSavingLabels(true);
    try {
      const r = await axios.put(`${API}/admin/ui-labels/caisse_product_add`, {
        key: "caisse_product_add",
        title_create: labelsForm.title_create,
        title_edit: labelsForm.title_edit,
        description: labelsForm.description,
        actor_name: currentUser?.full_name || currentUser?.username || "Admin",
      });
      setProductLabels({
        title_create: r.data.title_create,
        title_edit: r.data.title_edit,
        description: r.data.description || "",
        is_custom: true,
      });
      toast.success("Libellés mis à jour");
      setShowLabelsEditor(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors de l'enregistrement");
    } finally {
      setSavingLabels(false);
    }
  };

  // Restauration des libellés par défaut
  const resetLabels = async () => {
    if (!confirm("Restaurer les libellés par défaut ?")) return;
    setSavingLabels(true);
    try {
      const r = await axios.delete(`${API}/admin/ui-labels/caisse_product_add`);
      setProductLabels({
        title_create: r.data.title_create,
        title_edit: r.data.title_edit,
        description: r.data.description || "",
        is_custom: false,
      });
      toast.success("Libellés restaurés aux valeurs par défaut");
      setShowLabelsEditor(false);
    } catch (_) {
      toast.error("Erreur lors de la restauration");
    } finally {
      setSavingLabels(false);
    }
  };
  // End date (inclusive). Par défaut = dimanche de la semaine courante (preset "Cette semaine").
  const [weekEndDate, setWeekEndDate] = useState(() => {
    const d = startOfWeek(new Date(), { weekStartsOn: 1 });
    d.setDate(d.getDate() + 6);
    return format(d, "yyyy-MM-dd");
  });
  const [expenseRatioAlert, setExpenseRatioAlert] = useState(null);

  // ============== TABLE STATUS (Suivi Tables) ==============
  const [tablesStatus, setTablesStatus] = useState({ tables: [], stats: { total_tables: 20, occupied: 0, free: 20 } });
  // Statut de la journée courante (utilisé par le welcome banner Resp. Op.)
  const [dayOpening, setDayOpening] = useState(null);
  useEffect(() => {
    if (!isAuthenticated) return;
    const today = format(new Date(), 'yyyy-MM-dd');
    axios.get(`${API}/day-openings/${today}`)
      .then((r) => setDayOpening(r.data || null))
      .catch(() => setDayOpening(null));
  }, [isAuthenticated, activeTab]);

  const formatPrice = (price) => new Intl.NumberFormat('fr-FR').format(price);

  // ============== NOTIFICATION SOUND ==============
  const playNotificationSound = () => {
    try {
      // Create a pleasant "ding" notification sound using Web Audio API
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // Create oscillator for the main tone
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      // Pleasant bell-like sound (C5 note = 523.25 Hz)
      oscillator.frequency.setValueAtTime(523.25, audioContext.currentTime);
      oscillator.type = 'sine';
      
      // Fade in and out for a nice bell effect
      gainNode.gain.setValueAtTime(0, audioContext.currentTime);
      gainNode.gain.linearRampToValueAtTime(0.5, audioContext.currentTime + 0.05);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.8);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.8);
      
      // Second tone for a richer sound (E5 = 659.25 Hz)
      const oscillator2 = audioContext.createOscillator();
      const gainNode2 = audioContext.createGain();
      
      oscillator2.connect(gainNode2);
      gainNode2.connect(audioContext.destination);
      
      oscillator2.frequency.setValueAtTime(659.25, audioContext.currentTime + 0.1);
      oscillator2.type = 'sine';
      
      gainNode2.gain.setValueAtTime(0, audioContext.currentTime + 0.1);
      gainNode2.gain.linearRampToValueAtTime(0.3, audioContext.currentTime + 0.15);
      gainNode2.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.9);
      
      oscillator2.start(audioContext.currentTime + 0.1);
      oscillator2.stop(audioContext.currentTime + 0.9);
    } catch (error) {
      console.log("Audio notification not available");
    }
  };

  // ============== AUTH ==============
  const handleLogin = async () => {
    const enteredPin = (loginForm?.pin || "").trim();
    const enteredPwd = (loginForm?.password || "").trim();
    try {
      const payload = { pin: enteredPin, password: enteredPwd };
      const response = await axios.post(`${API}/caisse/login`, payload, { timeout: 8000 });
      if (response.data.success) {
        setIsAuthenticated(true);
        setCurrentUser(response.data.user);
        toast.success(`Bienvenue ${response.data.user.full_name || response.data.user.username}`);
        // Stocke un hash du code pour permettre une connexion offline ultérieure
        rememberLogin({
          pin: enteredPin,
          password: enteredPwd,
          user: response.data.user,
        }).catch(() => {});
        // Phase 3 — recharge silencieusement le pool de numéros pré-alloués
        refillInvoiceNumbers({
          apiBase: API.replace(/\/api$/, ""),
          user: response.data.user,
          threshold: 10,
          batchSize: 30,
        }).catch(() => {});
        fetchAllData();
      }
    } catch (error) {
      // Fallback mode offline : si erreur réseau, on tente une validation locale
      if (isNetworkError(error)) {
        try {
          const local = await tryLocalLogin({ pin: enteredPin, password: enteredPwd });
          if (local.success) {
            setIsAuthenticated(true);
            setCurrentUser({ ...local.user, _offline: true });
            toast.success(
              `Bienvenue ${local.user.full_name || local.user.username} · Mode hors-ligne`,
              { duration: 4500 }
            );
            // Pas de fetchAllData en offline — l'app fonctionne sur cache local.
            return;
          }
        } catch (_) { /* ignore */ }
        toast.error("Pas de connexion Internet — code inconnu en local. Connecte-toi une première fois en ligne.");
        return;
      }
      toast.error(error.response?.data?.detail || "Identifiants incorrects");
    }
  };

  // 🆕 (Fév 2026) Polling léger de l'autorisation Remises (rafraîchit le pastille en header)
  useEffect(() => {
    if (!isAuthenticated) return;
    const check = async () => {
      try {
        const r = await axios.get(`${API}/discounts/authorizations/active`);
        setDiscountAuthActive(!!r.data?.active);
      } catch { /* silent */ }
    };
    check();
    const t = setInterval(check, 30000);
    return () => clearInterval(t);
  }, [isAuthenticated]);

  const handleLogout = () => {
    // Si session invité → notifie le backend pour clôturer
    if (currentUser?.is_guest && currentUser?.guest_request_id) {
      axios.post(`${API}/guest/logout/${currentUser.guest_request_id}`).catch(() => {});
    }
    setIsAuthenticated(false);
    setCurrentUser(null);
    setCurrentBill([]);
    setOpenTables([]);
    setActiveTableId(null);
  };

  // ============== MULTI-TABLE MANAGEMENT ==============
  
  // 🆕 (Feb 2026) — Vague 3 refactor : handlers Tables extraits vers useTablesHandlers.js
  //   Le useEffect d'autosave (500ms debounce) est aussi déplacé dans le hook.
  const {
    fetchOpenTables,
    createNewTable,
    selectTable,
    saveCurrentTableToDb,
    closeTable,
    activeTable,
  } = useTablesHandlers({
    currentUser, openTables, activeTableId,
    currentBill, selectedClient, paymentMethod, discount, notes, clients,
    setOpenTables, setAvailableTableNumbers, setActiveTableId,
    setCurrentBill, setSelectedClient, setPaymentMethod, setDiscount, setNotes,
    setShowNewTableModal,
    actorQs,
  });

  // ============== COACH PLAYERS DE LA TABLE (réciprocité avec PlayersTrackerTab) ==============
  // Quand l'agent ouvre une table, on affiche en bas la consommation des joueurs Coach
  // rattachés à cette table. Polling 10s pour suivre les +1 partie en temps réel.
  const [tableCoachPlayers, setTableCoachPlayers] = useState({ count: 0, grand_total: 0, players: [] });
  const fetchTableCoachPlayers = useCallback(async () => {
    if (!activeTable || activeTable.table_number == null) {
      setTableCoachPlayers({ count: 0, grand_total: 0, players: [] });
      return;
    }
    try {
      const r = await axios.get(`${API}/coach/players/by-table/${activeTable.table_number}`);
      setTableCoachPlayers({
        count: r.data.count || 0,
        grand_total: r.data.grand_total || 0,
        players: r.data.players || [],
      });
    } catch {
      setTableCoachPlayers({ count: 0, grand_total: 0, players: [] });
    }
  }, [activeTable?.table_number]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchTableCoachPlayers();
    if (!activeTable?.table_number) return;
    const t = setInterval(fetchTableCoachPlayers, 10000);
    return () => clearInterval(t);
  }, [fetchTableCoachPlayers, activeTable?.table_number]);

  // Notifications "Besoin cuisine" : compteur pour badge sur l'onglet Recoupement
  // (qui contient le CuisineNeedsAdminList) — polling 30s
  const [cuisineNeedsPending, setCuisineNeedsPending] = useState({ pending: 0, urgent: 0 });
  const lastNeedsCountRef = useRef(null);
  const fetchCuisineNeedsCount = useCallback(async () => {
    if (currentUser?.role !== "admin" && currentUser?.role !== "manager") return;
    try {
      const r = await axios.get(`${API}/cuisine/needs`, { params: { status: "pending", limit: 1 } });
      const pending = r.data.pending_count || 0;
      const urgent = r.data.urgent_pending_count || 0;
      // Notification différentielle : on alerte uniquement si le compteur augmente
      // (évite de spammer l'admin à chaque polling).
      if (lastNeedsCountRef.current !== null && pending > lastNeedsCountRef.current) {
        const delta = pending - lastNeedsCountRef.current;
        toast.info(`🍳 ${delta} nouveau${delta > 1 ? "x" : ""} besoin${delta > 1 ? "s" : ""} cuisine`, {
          description: urgent > 0 ? `⚠ ${urgent} marqué(s) urgent` : "Consultez l'onglet Recoupement IA",
          duration: 6000,
        });
        // Son de notification (réutilise la fonction d'alerte existante si dispo)
        try {
          const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          const o = audioCtx.createOscillator();
          const g = audioCtx.createGain();
          o.connect(g); g.connect(audioCtx.destination);
          o.frequency.value = urgent > 0 ? 880 : 660;
          g.gain.value = 0.15;
          o.start(); setTimeout(() => { o.stop(); audioCtx.close(); }, 250);
        } catch {}
      }
      lastNeedsCountRef.current = pending;
      setCuisineNeedsPending({ pending, urgent });
    } catch {}
  }, [currentUser?.role]);

  useEffect(() => {
    fetchCuisineNeedsCount();
    const t = setInterval(fetchCuisineNeedsCount, 30000);
    return () => clearInterval(t);
  }, [fetchCuisineNeedsCount]);

  // One-click : transmet tous les joueurs Coach de la table active et ajoute leurs
  // articles directement à la commande en cours. Évite à l'agent de passer par le Coach.
  const transmitCoachPlayersOnTable = useCallback(async () => {
    if (!activeTableId || !activeTable?.table_number) {
      toast.error("Aucune table active");
      return;
    }
    if (!tableCoachPlayers.count) {
      toast.info("Aucun joueur Coach à transmettre");
      return;
    }
    if (!window.confirm(
      `Facturer maintenant ${tableCoachPlayers.count} joueur(s) Coach sur la table ${activeTable.table_number} ?\n\n` +
      `Total à ajouter : ${tableCoachPlayers.grand_total.toLocaleString("fr-FR")} F\n\n` +
      `Les articles jeux seront ajoutés à la commande en cours et les joueurs marqués comme transmis.`
    )) return;
    try {
      const r = await axios.post(`${API}/coach/players/transmit-to-table`, {
        table_id: activeTableId,
        actor_name: currentUser?.full_name || currentUser?.username || "Caisse",
        actor_role: currentUser?.role || "server",
      });
      toast.success(
        `${r.data.transmitted_players} joueur(s) facturé(s) · ${r.data.items_added} article(s) ajouté(s)`,
        { description: `Total : ${r.data.total.toLocaleString("fr-FR")} F` }
      );
      // Rafraîchir tout l'écran : table active + panneau coach + commande
      fetchTableCoachPlayers();
      await fetchAllData();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur lors de la transmission");
    }
  }, [activeTableId, activeTable?.table_number, tableCoachPlayers, currentUser]); // eslint-disable-line react-hooks/exhaustive-deps

  // ============== DATA FETCHING ==============
  const fetchAllData = async () => {
    try {
      // Build query params for invoices based on user role
      const invoiceParams = { date: filterDate };
      if (currentUser?.role === 'server') {
        invoiceParams.role = 'server';
        invoiceParams.created_by = currentUser?.full_name || currentUser?.username;
      }

      const [invoicesRes, clientsRes, usersRes, productsRes, statsRes] = await Promise.all([
        axios.get(`${API}/invoices`, { params: invoiceParams }),
        axios.get(`${API}/caisse/clients`),
        axios.get(`${API}/caisse/users`),
        axios.get(`${API}/caisse/products`),
        axios.get(`${API}/invoices/stats`, { params: { date: filterDate } })
      ]);
      
      // 🆕 Fév 2026 — Les bons personnel (autorisés par l'admin, NON-ENCAISSÉ)
      // ne doivent PAS apparaître dans le menu Factures ni dans aucune liste globale
      // de factures. Ils restent visibles uniquement dans "Faire mon point" (via
      // l'endpoint dédié `/reversements/auto-fill`).
      const rawInvoices = invoicesRes.data.invoices || [];
      const visibleInvoices = rawInvoices.filter(
        (i) => !i.is_personnel_bon && !i.non_encaisse
      );
      setInvoices(visibleInvoices);
      setClients(clientsRes.data.clients || []);
      setUsers(usersRes.data.users || []);
      setStats(statsRes.data);
      
      // Check for new validated invoices (for servers)
      const newInvoices = visibleInvoices;
      const myValidatedInvoices = newInvoices.filter(i => 
        i.validation_status === 'validated' && 
        (currentUser?.role !== 'server' || i.created_by === (currentUser?.full_name || currentUser?.username))
      );
      
      if (myValidatedInvoices.length > lastValidatedCount && lastValidatedCount > 0) {
        // New invoice validated! Play sound and show notification
        playNotificationSound();
        if (currentUser?.role === 'server') {
          toast.success("🧾 Votre commande est devenue une facture définitif !", {
            duration: 5000,
            style: { background: '#166534', color: 'white' }
          });
        } else {
          toast.success("🔔 Bon de commande créé avec succès !", {
            duration: 5000,
            style: { background: '#166534', color: 'white' }
          });
        }
      }
      setLastValidatedCount(myValidatedInvoices.length);
      
      // Check for new pending invoices (for managers/admins)
      if (currentUser?.role === 'manager' || currentUser?.role === 'admin') {
        const pendingInvoices = newInvoices.filter(i => i.validation_status === 'pending');
        if (pendingInvoices.length > lastPendingCount && lastPendingCount > 0) {
          playNotificationSound();
          toast.info("🔔 Nouvelle commande à valider !", {
            duration: 5000,
            style: { background: '#f59e0b', color: 'white' }
          });
        }
        setLastPendingCount(pendingInvoices.length);
      }
      
      // Sync default products to database if needed
      const customProducts = productsRes.data.products || [];
      
      // Check if we need to sync default products (check if plats/accomp/jeux are missing)
      const hasPlats = customProducts.some(p => p.department === 'salle_jardin');
      const hasAccomp = customProducts.some(p => p.department === 'accompagnements');
      const hasJeux = customProducts.some(p => p.department === 'jeux');
      const hasBar = customProducts.some(p => p.department === 'bar');
      
      if (!hasPlats || !hasAccomp || !hasJeux || !hasBar) {
        console.log("Syncing missing default products to database...");
        const allDefaultProducts = [];
        
        // Add salle_jardin (Plats) products if missing
        if (!hasPlats) {
          DEFAULT_CATALOG.salle_jardin.forEach(p => {
            allDefaultProducts.push({ ...p, department: "salle_jardin", isDefault: true });
          });
        }
        
        // Add accompagnements products if missing
        if (!hasAccomp) {
          DEFAULT_CATALOG.accompagnements.forEach(p => {
            allDefaultProducts.push({ ...p, department: "accompagnements", isDefault: true });
          });
        }
        
        // Add jeux products if missing
        if (!hasJeux) {
          DEFAULT_CATALOG.jeux.forEach(p => {
            allDefaultProducts.push({ ...p, department: "jeux", isDefault: true });
          });
        }
        
        // Add bar products if missing
        if (!hasBar) {
          DEFAULT_CATALOG.bar.forEach(p => {
            allDefaultProducts.push({ ...p, department: "bar", isDefault: true });
          });
        }
        
        if (allDefaultProducts.length > 0) {
          try {
            await axios.post(`${API}/caisse/products/sync-defaults`, allDefaultProducts);
            console.log(`Synced ${allDefaultProducts.length} default products!`);
            // Fetch again to get the updated products from DB
            const refreshRes = await axios.get(`${API}/caisse/products`);
            const dbProducts = refreshRes.data.products || [];
            buildCatalogFromProducts(dbProducts);
            setProducts(dbProducts);
          } catch (err) {
            console.error("Error syncing products:", err);
            // Fallback: merge custom products with defaults
            const merged = [...customProducts];
            allDefaultProducts.forEach(dp => {
              if (!merged.find(p => p.id === dp.id)) merged.push(dp);
            });
            buildCatalogFromProducts(merged);
            setProducts(merged);
          }
        } else {
          buildCatalogFromProducts(customProducts);
          setProducts(customProducts);
        }
      } else {
        // All departments have products, use them
        buildCatalogFromProducts(customProducts);
        setProducts(customProducts);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  // Helper function to build catalog from database products
  const buildCatalogFromProducts = (dbProducts) => {
    const newCatalog = {
      salle_jardin: [],
      accompagnements: [],
      jeux: [],
      bar: [],
      location: [],
      autres: []
    };
    
    dbProducts.forEach(p => {
      const dept = p.department || 'autres';
      if (!newCatalog[dept]) newCatalog[dept] = [];
      newCatalog[dept].push(p);
    });
    
    setCatalog(newCatalog);
  };

  // Lightweight refresh of the caisse products catalog (used after bulk auto-link)
  const refreshCatalog = async () => {
    try {
      const r = await axios.get(`${API}/caisse/products`);
      const dbProducts = r.data.products || [];
      buildCatalogFromProducts(dbProducts);
      setProducts(dbProducts);
    } catch (e) {
      console.error("refreshCatalog failed", e);
    }
  };

  const fetchMonthlyStats = async () => {
    try {
      const [year, month] = filterMonth.split("-");
      const response = await axios.get(`${API}/invoices/stats/monthly`, {
        params: { year: parseInt(year), month: parseInt(month) }
      });
      setMonthlyStats(response.data);
    } catch (error) {
      console.error("Error fetching monthly stats:", error);
    }
  };

  const initialTabSet = useRef(false);
  useEffect(() => {
    if (isAuthenticated) {
      fetchAllData();
      fetchOpenTables();

      // Set default tab ONLY on initial auth, not on every filterDate change
      if (!initialTabSet.current && (currentUser?.role === 'manager' || currentUser?.role === 'admin')) {
        setActiveTab("commande");
        initialTabSet.current = true;
      }
    } else {
      // Reset so the default tab applies again after re-login
      initialTabSet.current = false;
    }
  }, [filterDate, isAuthenticated]);

  // Auto-refresh every 5 seconds for ALL users to see updates in real-time
  useEffect(() => {
    if (isAuthenticated) {
      const interval = setInterval(() => {
        // Refresh invoices and tables for everyone
        fetchAllData();
        fetchOpenTables();
        
        // Refresh cancellation requests for admin
        if (currentUser?.role === 'admin') {
          fetchCancellationRequests();
        }
        
        // Refresh modification requests for managers/admin
        if (currentUser?.role === 'manager' || currentUser?.role === 'admin') {
          fetchModificationRequests();
        }
        
        // Refresh rapport data if on rapport tab
        if (activeTab === 'rapport') {
          fetchRapportData();
        }

        // Refresh expenses list when on the purchases tab (sync admin <-> manager)
        if (activeTab === 'achats') {
          fetchExpenses();
        }
      }, 5000); // Refresh every 5 seconds
      
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, currentUser, activeTab, rapportDate, filterDate]);

  useEffect(() => {
    if (isAuthenticated && activeTab === "stats") {
      fetchMonthlyStats();
    }
  }, [filterMonth, activeTab, isAuthenticated]);

  // Fetch cancellation requests for admin
  useEffect(() => {
    if (isAuthenticated && currentUser?.role === 'admin') {
      fetchCancellationRequests();
    }
  }, [isAuthenticated, currentUser]);

  // Fetch modification requests for managers
  useEffect(() => {
    if (isAuthenticated && (currentUser?.role === 'manager' || currentUser?.role === 'admin')) {
      fetchModificationRequests();
    }
  }, [isAuthenticated, currentUser]);

  // Fetch rapport data when rapport tab is active
  useEffect(() => {
    if (isAuthenticated && activeTab === "rapport") {
      fetchRapportData();
    }
  }, [rapportDate, activeTab, isAuthenticated]);

  // Fetch history invoices when history tab is active
  useEffect(() => {
    if (isAuthenticated && activeTab === "historique") {
      fetchHistoryInvoices();
    }
  }, [historyDate, activeTab, isAuthenticated]);

  // Fetch menu notifications for admin
  useEffect(() => {
    if (isAuthenticated && currentUser?.role === 'admin') {
      fetchMenuNotifications();
      // Refresh notifications every 30 seconds
      const interval = setInterval(fetchMenuNotifications, 30000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, currentUser]);

  // Fetch server daily report when "mon_point" tab is active
  useEffect(() => {
    if (isAuthenticated && activeTab === "mon_point" && currentUser?.role === 'server') {
      const serverName = currentUser?.full_name || currentUser?.username;
      if (serverName) {
        fetchServerDailyReport(serverName, serverReportDate);
      }
    }
  }, [serverReportDate, activeTab, isAuthenticated, currentUser]);

  // Fetch service reports for manager
  useEffect(() => {
    if (isAuthenticated && currentUser?.role === 'manager') {
      fetchServiceReports();
      // Refresh service reports every 30 seconds
      const interval = setInterval(fetchServiceReports, 30000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, currentUser]);

  const fetchHistoryInvoices = async () => {
    try {
      const res = await axios.get(`${API}/invoices`, { params: { date: historyDate } });
      // Only show validated invoices in history
      // 🆕 Fév 2026 — Exclut aussi les bons personnel (NON-ENCAISSÉ, hors CA)
      const validated = (res.data.invoices || []).filter(
        (i) => i.validation_status === 'validated' && !i.is_personnel_bon && !i.non_encaisse
      );
      setHistoryInvoices(validated);
    } catch (error) {
      console.error("Error fetching history invoices:", error);
    }
  };

  // ============== NOTIFICATIONS (extracted to hook) ==============
  const {
    notifLatest,
    effectiveCounts,
    effectiveTotal,
    effectiveCrossRole,
    showNotifCenter,
    setShowNotifCenter,
    notifEnabled,
    notifPermission,
    toggleNotifEnabled,
    markAllNotifsRead,
    openNotifAndNavigate,
    openCrossRoleLatest,
    dismissCrossRoleBanner,
  } = useNotifications({
    isAuthenticated,
    currentUser,
    apiBase: API,
    onNavigateTab: setActiveTab,
  });

  // ============== EXPENSES FUNCTIONS ==============
  
  const fetchExpenses = async () => {
    try {
      // 🆕 Fév 2026 — Inclut les achats archivés (auto-archivage désactivé mais
      // les archives historiques existent en DB — les afficher partout pour ne
      // pas cacher les achats des mois passés).
      const res = await axios.get(`${API}/expenses`, { params: { include_archived: true } });
      const expensesList = res.data.expenses || [];
      setExpenses(expensesList);
      // Update revision count for manager
      setRevisionExpensesCount(expensesList.filter(e => e.status === 'revision_requested').length);
      // Fetch admin analysis for pending/approved expenses
      if (currentUser?.role === 'admin') {
        try {
          const ares = await axios.get(`${API}/expenses/analysis`);
          const map = {};
          (ares.data.analyses || []).forEach(a => { map[a.expense_id] = a; });
          setExpenseAnalyses(map);
        } catch (err) {
          console.error("Error fetching expense analysis:", err);
        }
      }
    } catch (error) {
      console.error("Error fetching expenses:", error);
    }
  };

  // ============== MENU NOTIFICATIONS FUNCTIONS (Admin) ==============
  
  const fetchMenuNotifications = async () => {
    try {
      const res = await axios.get(`${API}/menu-notifications`);
      setMenuNotifications(res.data.notifications || []);
      setUnreadNotificationCount(res.data.unread_count || 0);
    } catch (error) {
      console.error("Error fetching menu notifications:", error);
    }
  };

  const markNotificationRead = async (notificationId) => {
    try {
      await axios.put(`${API}/menu-notifications/${notificationId}/read`);
      fetchMenuNotifications();
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const markAllNotificationsRead = async () => {
    try {
      await axios.put(`${API}/menu-notifications/mark-all-read`);
      fetchMenuNotifications();
      toast.success("Toutes les notifications marquées comme lues");
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  };

  // ============== NOTES/INSTRUCTIONS NOTIFICATIONS ==============
  
  const fetchUnreadNotesCount = async () => {
    if (!currentUser?.role) return;
    try {
      const res = await axios.get(`${API}/instructions/unread-count`, {
        params: { reader_role: currentUser.role }
      });
      const newCount = res.data.unread_count || 0;
      
      // Play sound if new notes arrived
      if (newCount > unreadNotesCount && unreadNotesCount > 0) {
        playNotificationSound();
        toast.info(`${newCount - unreadNotesCount} nouvelle(s) note(s) reçue(s)`);
      }
      
      setUnreadNotesCount(newCount);
    } catch (error) {
      console.error("Error fetching unread notes count:", error);
    }
  };

  const markAllNotesRead = async () => {
    if (!currentUser?.role) return;
    try {
      await axios.put(`${API}/instructions/mark-all-read`, { reader_role: currentUser.role });
      setUnreadNotesCount(0);
    } catch (error) {
      console.error("Error marking all notes as read:", error);
    }
  };

  // Fetch unread notes count periodically for manager/admin
  useEffect(() => {
    if (isAuthenticated && (currentUser?.role === 'manager' || currentUser?.role === 'admin')) {
      fetchUnreadNotesCount();
      const interval = setInterval(fetchUnreadNotesCount, 15000); // Check every 15 seconds
      return () => clearInterval(interval);
    }
  }, [isAuthenticated, currentUser?.role]);

  // ============== KITCHEN TRACKER — Background polling (badge + bip) ==============
  useEffect(() => {
    if (!isAuthenticated) return;
    if (!(currentUser?.role === 'manager' || currentUser?.role === 'admin')) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const [oRes, mRes] = await Promise.all([
          axios.get(`${API}/cuisine/orders`, { params: { actor_role: currentUser.role }, timeout: 8000 }),
          axios.get(`${API}/cuisine/messages`, { params: { actor_role: currentUser.role, since_minutes: 240 }, timeout: 8000 }),
        ]);
        if (cancelled) return;
        const pending = (oRes.data?.orders || []).filter((o) => !o.all_served).length;
        const msgs = mRes.data?.messages || [];
        const unread = mRes.data?.unread || 0;
        setKitchenPendingCount(pending);
        setKitchenUnreadCount(unread);
        // bip on new unread
        const currIds = new Set(msgs.filter((m) => !m.read_at).map((m) => m.id));
        const incoming = [...currIds].filter((id) => !kitchenLastIdsRef.current.has(id));
        if (kitchenLastIdsRef.current.size > 0 && incoming.length > 0 && !showKitchenTracker) {
          try {
            import('../lib/notificationBeep').then((m) => m.playBeep({ freq: 1500, duration: 0.15, volume: 0.7, count: 2, gap: 0.08 }));
          } catch {}
          const fresh = msgs.find((m) => m.id === incoming[0]);
          if (fresh) toast.info(`Cuisinier: ${fresh.label}`);
        }
        kitchenLastIdsRef.current = currIds;
      } catch {}
    };
    tick();
    const id = setInterval(tick, 7000);
    return () => { cancelled = true; clearInterval(id); };
  }, [isAuthenticated, currentUser?.role, showKitchenTracker]);

  // ============== JEUX BONS — Background polling (badge + bip) ==============
  useEffect(() => {
    if (!isAuthenticated) return;
    if (!(currentUser?.role === 'manager' || currentUser?.role === 'admin')) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await axios.get(`${API}/jeux/bons`, {
          params: { actor_role: currentUser.role, status: 'pending', limit: 100 },
          timeout: 8000,
        });
        if (cancelled) return;
        const list = r.data?.bons || [];
        setJeuxPendingCount(list.length);
        const currIds = new Set(list.map((b) => b.id));
        const incoming = [...currIds].filter((id) => !jeuxLastIdsRef.current.has(id));
        if (jeuxLastIdsRef.current.size > 0 && incoming.length > 0 && !showJeuxBonsModal) {
          try {
            import('../lib/notificationBeep').then((m) => m.playBeep({ freq: 1100, duration: 0.18, volume: 0.7, count: 2, gap: 0.08 }));
          } catch {}
          toast.info(`Nouveau bon de jeu reçu (${incoming.length})`);
        }
        jeuxLastIdsRef.current = currIds;
      } catch {}
    };
    tick();
    const id = setInterval(tick, 8000);
    return () => { cancelled = true; clearInterval(id); };
  }, [isAuthenticated, currentUser?.role, showJeuxBonsModal]);

  // ============== FIELD STOCK pending poll (admin only) ==============
  useEffect(() => {
    if (!isAuthenticated || currentUser?.role !== 'admin') {
      setFieldStockPendingCount(0);
      return;
    }
    let cancelled = false;
    const tick = async () => {
      if (cancelled) return;
      try {
        const r = await axios.get(`${API}/field-stock/reports/summary`);
        if (!cancelled) setFieldStockPendingCount(r.data?.pending || 0);
      } catch {}
    };
    tick();
    const id = setInterval(tick, 20000);
    return () => { cancelled = true; clearInterval(id); };
  }, [isAuthenticated, currentUser?.role]);

  // ============== SERVER DAILY REPORT FUNCTIONS ==============
  
  const fetchServerDailyReport = async (serverName, date) => {
    try {
      const targetDate = date || serverReportDate;
      const res = await axios.get(`${API}/server-daily-report/${encodeURIComponent(serverName)}?date=${targetDate}`);
      setServerDailyReport(res.data);
    } catch (error) {
      console.error("Error fetching server daily report:", error);
    }
  };

  // ============== CURRENT ACCOUNTS (for expense funding source) ==============
  const fetchAvailableAccounts = async () => {
    try {
      const res = await axios.get(`${API}/current-accounts`, { params: { include_closed: false, auto_run: false } });
      setAvailableAccounts(res.data.accounts || []);
    } catch (err) {
      console.error("Error fetching accounts:", err);
    }
  };


  // 🆕 (Feb 2026) — Vague 1 refactor : handlers Expenses extraits vers useExpensesHandlers.js
  const [expenseSubmitLoading, setExpenseSubmitLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated && (currentUser?.role === "admin" || currentUser?.role === "manager")) {
      fetchAvailableAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, currentUser]);

  const {
    allocateExpenseToAccount, createExpense,
    addCommonItem, removeCommonItem, getCommonTotal,
    openReviseModal, addReviseItem, removeReviseItem, updateReviseItem, getReviseTotal, submitRevision,
    updateExpense, receiveExpenseStock, deleteExpense, convertExpenseToPO, assignExpenseToWeek,
  } = useExpensesHandlers({
    currentUser, availableAccounts,
    expenseForm, setExpenseForm,
    expenseSubmitLoading, setExpenseSubmitLoading,
    setShowExpenseModal,
    commonItems, setCommonItems,
    commonNewItem, setCommonNewItem,
    revisingExpense, setRevisingExpense,
    reviseItems, setReviseItems,
    reviseSupplier, setReviseSupplier,
    reviseNote, setReviseNote,
    reviseNewItem, setReviseNewItem,
    setShowReviseModal,
    setEditingExpense,
    fetchExpenses, fetchAvailableAccounts,
    actorQs,
  });


  // ============== END OF SERVICE FUNCTIONS (Server) ==============

  const submitEndOfService = async () => {
    try {
      setIsSubmittingEndOfService(true);
      const serverName = currentUser?.full_name || currentUser?.username;
      if (!serverName) {
        toast.error("Impossible d'identifier le agent connecté.");
        setIsSubmittingEndOfService(false);
        return;
      }
      
      await axios.post(`${API}/server-end-of-service`, {
        server_name: serverName,
        server_id: currentUser?.id,
        date: format(new Date(), "yyyy-MM-dd"),
        observation: endOfServiceObservation
      });
      
      toast.success("Votre point journalier a été envoyé à la responsable op. & log !");
      setShowEndOfServiceModal(false);
      setEndOfServiceObservation("");
    } catch (error) {
      console.error("Error submitting end of service:", error);
      const detail = error?.response?.data?.detail || error?.message || "Erreur réseau";
      toast.error(`Échec de l'envoi : ${detail}`);
    } finally {
      setIsSubmittingEndOfService(false);
    }
  };

  // ============== SERVICE REPORTS FUNCTIONS (Manager) ==============

  const fetchServiceReports = async () => {
    try {
      const res = await axios.get(`${API}/server-end-of-service-reports`);
      setServiceReports(res.data.reports || []);
      setUnreadServiceReportsCount(res.data.unread_count || 0);
    } catch (error) {
      console.error("Error fetching service reports:", error);
    }
  };

  const markServiceReportRead = async (reportId) => {
    try {
      await axios.put(`${API}/server-end-of-service-reports/${reportId}/read`);
      fetchServiceReports();
    } catch (error) {
      console.error("Error marking service report as read:", error);
    }
  };

  const markAllServiceReportsRead = async () => {
    try {
      await axios.put(`${API}/server-end-of-service-reports/mark-all-read`);
      fetchServiceReports();
      toast.success("Tous les points marqués comme lus");
    } catch (error) {
      console.error("Error marking all service reports as read:", error);
    }
  };

  // Compare server report with actual data
  const compareServerReport = async (report) => {
    try {
      const res = await axios.get(`${API}/server-end-of-service-reports/${report.id}/compare`);
      return res.data;
    } catch (error) {
      console.error("Error comparing report:", error);
      toast.error("Erreur lors de la comparaison");
      return null;
    }
  };

  // Validate, request revision, or reject a report
  const handleReportValidation = async (reportId, action, comment = "") => {
    try {
      await axios.put(`${API}/server-end-of-service-reports/${reportId}/validate`, {
        action,
        comment,
        validated_by: currentUser?.full_name || "Responsable Op. & Log"
      });
      
      const messages = {
        validate: "Point validé avec succès",
        request_revision: "Demande de révision envoyée",
        reject: "Point rejeté"
      };
      
      toast.success(messages[action] || "Action effectuée");
      fetchServiceReports();
      setViewingServerReport(null);
      setViewingServerDetailedReport(null);
      setReportComparison(null);
    } catch (error) {
      console.error("Error validating report:", error);
      toast.error("Erreur lors de la validation");
    }
  };

  // State for report comparison
  const [reportComparison, setReportComparison] = useState(null);
  const [validationComment, setValidationComment] = useState("");
  const [deleteReportCode, setDeleteReportCode] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedReports, setSelectedReports] = useState([]);
  const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false);
  const [bulkDeleteCode, setBulkDeleteCode] = useState("");

  // Delete a server report with confirmation code
  const handleDeleteServerReport = async (reportId) => {
    const CORRECT_CODE = "0631";
    
    if (deleteReportCode !== CORRECT_CODE) {
      toast.error("Code de suppression incorrect");
      return;
    }
    
    try {
      await axios.delete(`${API}/server-end-of-service-reports/${reportId}`);
      toast.success("Point supprimé avec succès");
      fetchServiceReports();
      setViewingServerReport(null);
      setViewingServerDetailedReport(null);
      setReportComparison(null);
      setDeleteReportCode("");
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error("Error deleting report:", error);
      toast.error("Erreur lors de la suppression");
    }
  };

  // Toggle selection of a report
  const toggleReportSelection = (reportId) => {
    setSelectedReports(prev => 
      prev.includes(reportId) 
        ? prev.filter(id => id !== reportId)
        : [...prev, reportId]
    );
  };

  // Select/Deselect all reports
  const toggleSelectAllReports = () => {
    if (selectedReports.length === serviceReports.length) {
      setSelectedReports([]);
    } else {
      setSelectedReports(serviceReports.map(r => r.id));
    }
  };

  // Bulk delete selected reports
  const handleBulkDeleteReports = async () => {
    const CORRECT_CODE = "0631";
    
    if (bulkDeleteCode !== CORRECT_CODE) {
      toast.error("Code de suppression incorrect");
      return;
    }
    
    if (selectedReports.length === 0) {
      toast.error("Aucun point sélectionné");
      return;
    }
    
    try {
      let successCount = 0;
      let errorCount = 0;
      
      for (const reportId of selectedReports) {
        try {
          await axios.delete(`${API}/server-end-of-service-reports/${reportId}`);
          successCount++;
        } catch (error) {
          errorCount++;
          console.error(`Error deleting report ${reportId}:`, error);
        }
      }
      
      if (successCount > 0) {
        toast.success(`${successCount} point(s) supprimé(s) avec succès`);
      }
      if (errorCount > 0) {
        toast.error(`${errorCount} point(s) n'ont pas pu être supprimés`);
      }
      
      fetchServiceReports();
      setSelectedReports([]);
      setBulkDeleteCode("");
      setShowBulkDeleteConfirm(false);
    } catch (error) {
      console.error("Error in bulk delete:", error);
      toast.error("Erreur lors de la suppression");
    }
  };

  // Open detailed view of a server's daily report with comparison
  const openServerReportDetail = async (report) => {
    try {
      setLoadingServerDetail(true);
      setViewingServerReport(report);
      setShowServiceReportsPanel(false);
      setValidationComment("");
      
      // Fetch the detailed daily report for this server
      const res = await axios.get(`${API}/server-daily-report/${encodeURIComponent(report.server_name)}?date=${report.date}`);
      setViewingServerDetailedReport(res.data);
      
      // Fetch comparison with actual data
      const comparison = await compareServerReport(report);
      setReportComparison(comparison);
      
      // Mark as read
      if (!report.is_read) {
        markServiceReportRead(report.id);
      }
    } catch (error) {
      console.error("Error fetching server detail report:", error);
      toast.error("Erreur lors du chargement du rapport détaillé");
    } finally {
      setLoadingServerDetail(false);
    }
  };

  // ============== SHOPPING LIST FUNCTIONS ==============
  
  const addToShoppingList = () => {
    if (!newListItem.description || newListItem.quantity <= 0) {
      toast.error("Description et quantité requises");
      return;
    }
    const totalAmount = (newListItem.quantity || 1) * (newListItem.unit_price || 0);
    const supplier = (newListItem.supplier || shoppingListSupplier || "").trim();
    setShoppingList([...shoppingList, { ...newListItem, supplier, amount: totalAmount, id: Date.now() }]);
    setNewListItem({ category: "cuisine", description: "", quantity: 1, unit_price: 0, supplier: "" });
    toast.success("Article ajouté à la liste");
  };

  const removeFromShoppingList = (itemId) => {
    setShoppingList(shoppingList.filter(item => item.id !== itemId));
  };

  const submitShoppingList = async () => {
    if (shoppingList.length === 0) {
      toast.error("La liste est vide");
      return;
    }

    try {
      // Group items by supplier. An item without supplier falls into "__NO_SUPPLIER__"
      const groups = {};
      shoppingList.forEach((item) => {
        const key = (item.supplier || "").trim() || "__NO_SUPPLIER__";
        if (!groups[key]) groups[key] = [];
        groups[key].push(item);
      });

      const groupKeys = Object.keys(groups);
      const now = format(new Date(), "dd/MM/yyyy HH:mm");
      const createdFor = [];

      for (const supKey of groupKeys) {
        const items = groups[supKey];
        const supplierName = supKey === "__NO_SUPPLIER__" ? "" : supKey;
        const groupId = `GRP-${Date.now()}-${supKey.slice(0, 8).replace(/\s/g, "")}`;
        const groupTotal = items.reduce((sum, it) => sum + (it.amount || 0), 0);
        const groupName = supplierName
          ? `Liste ${supplierName} - ${now}`
          : `Liste sans fournisseur - ${now}`;

        await axios.post(`${API}/expenses?${actorQs()}`, {
          category: items[0].category,
          description: groupName,
          quantity: items.length,
          unit_price: groupTotal,
          amount: groupTotal,
          supplier: supplierName || null,
          planned_date: shoppingListDate,
          requested_by: currentUser?.full_name || currentUser?.username || "Responsable Op. & Log",
          is_group: true,
          group_id: groupId,
          items: items.map((it) => ({
            category: it.category,
            description: it.description,
            quantity: it.quantity,
            unit_price: it.unit_price,
            amount: it.amount,
          })),
        });
        createdFor.push(supplierName || "sans fournisseur");
      }

      toast.success(
        createdFor.length === 1
          ? `Demande créée pour ${createdFor[0]} (${shoppingList.length} article(s))`
          : `${createdFor.length} demandes créées — ${createdFor.join(", ")}`
      );
      setShoppingList([]);
      setShoppingListSupplier("");
      setShowShoppingListModal(false);
      fetchExpenses();
    } catch (error) {
      console.error("Error submitting shopping list:", error);
      toast.error("Erreur lors de la soumission");
    }
  };

  const getShoppingListTotal = () => {
    return shoppingList.reduce((sum, item) => sum + item.amount, 0);
  };

  // ============== PRINT EXPENSE PDF ==============
  
  const printExpensePDF = (expense) => {
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    const categoryLabels = {
      cuisine: 'Cuisine',
      bar: 'Bar',
      paiement: 'Paiement',
      autres: 'Autres'
    };
    
    const catColor = (c) => c === 'cuisine' ? '#22c55e' : c === 'bar' ? '#f97316' : c === 'paiement' ? '#3b82f6' : '#64748b';
    // Hide struck items from PDF preview (consistency with printed approved list)
    const visibleItems = (expense.is_group && Array.isArray(expense.items))
      ? expense.items.filter(it => !it.struck)
      : (expense.items || []);
    const visibleAmount = (expense.is_group && Array.isArray(expense.items))
      ? visibleItems.reduce((s, it) => s + (it.amount || 0), 0) || expense.amount
      : expense.amount;
    const itemsBlock = (expense.is_group && visibleItems.length > 0)
      ? `
        <div class="details">
          <div class="details-title">Détail des articles (${visibleItems.length})</div>
          <table style="width:100%;border-collapse:collapse;margin-top:6px;font-size:9pt;">
            <thead>
              <tr style="background:#f3f4f6;">
                <th style="padding:5px;text-align:left;border-bottom:1px solid #ccc;">#</th>
                <th style="padding:5px;text-align:left;border-bottom:1px solid #ccc;">Catégorie</th>
                <th style="padding:5px;text-align:left;border-bottom:1px solid #ccc;">Description</th>
                <th style="padding:5px;text-align:right;border-bottom:1px solid #ccc;">Qté</th>
                <th style="padding:5px;text-align:right;border-bottom:1px solid #ccc;">PU</th>
                <th style="padding:5px;text-align:right;border-bottom:1px solid #ccc;">Total</th>
              </tr>
            </thead>
            <tbody>
              ${visibleItems.map((it, idx) => `
                <tr>
                  <td style="padding:4px 5px;border-bottom:1px solid #eee;">${idx + 1}</td>
                  <td style="padding:4px 5px;border-bottom:1px solid #eee;"><span style="background:${catColor(it.category)};color:white;padding:1px 6px;border-radius:8px;font-size:8pt;">${categoryLabels[it.category] || it.category}</span></td>
                  <td style="padding:4px 5px;border-bottom:1px solid #eee;">${it.description}</td>
                  <td style="padding:4px 5px;border-bottom:1px solid #eee;text-align:right;">${it.quantity}</td>
                  <td style="padding:4px 5px;border-bottom:1px solid #eee;text-align:right;">${formatPrice(it.unit_price)} F</td>
                  <td style="padding:4px 5px;border-bottom:1px solid #eee;text-align:right;font-weight:600;">${formatPrice(it.amount)} F</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `
      : (expense.quantity && expense.unit_price ? `
        <div class="details">
          <div class="details-title">Quantité & Prix</div>
          <div>Qté ${expense.quantity} × ${formatPrice(expense.unit_price)} F</div>
        </div>
      ` : '');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Bon d'Achat - ${expense.description}</title>
          <meta charset="UTF-8">
          <style>
            @page { size: A5; margin: 10mm; }
            @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: Arial, sans-serif; padding: 20px; background: #fff; color: #333; font-size: 10pt; }
            .header { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #333; padding-bottom: 10px; margin-bottom: 15px; }
            .logo { width: 70px; height: 70px; }
            .logo img { width: 100%; height: 100%; object-fit: contain; }
            .header-right { text-align: right; font-size: 9pt; }
            .doc-title { text-align: center; font-size: 14pt; font-weight: bold; margin: 15px 0; text-transform: uppercase; }
            .badge { display: inline-block; background: #22c55e; color: #fff; padding: 3px 10px; border-radius: 10px; font-size: 9pt; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin: 15px 0; }
            .info-box { padding: 8px; border: 1px solid #ddd; }
            .info-label { font-size: 8pt; color: #666; text-transform: uppercase; }
            .info-value { font-size: 10pt; font-weight: 600; margin-top: 2px; }
            .amount-box { border: 2px solid #333; padding: 15px; text-align: center; margin: 15px 0; }
            .amount-label { font-size: 9pt; color: #666; }
            .amount-value { font-size: 24pt; font-weight: bold; }
            .details { border: 1px solid #ddd; padding: 10px; margin: 10px 0; }
            .details-title { font-size: 8pt; color: #666; text-transform: uppercase; margin-bottom: 5px; }
            .signatures { display: flex; justify-content: space-between; margin-top: 25px; }
            .signature-box { text-align: center; width: 45%; }
            .signature-line { border-bottom: 1px solid #333; height: 30px; margin-bottom: 3px; }
            .signature-label { font-size: 8pt; color: #666; }
            .print-date { text-align: center; font-size: 8pt; color: #999; margin-top: 15px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo"><img src="${LOGO_BASE64}" alt="Logo" /></div>
            <div class="header-right">
              <p>Tél: +229 01 4147 0000</p>
              <p>Fidjrossè, Cotonou</p>
            </div>
          </div>

          <div class="doc-title">
            Bon d'Achat <span class="badge" style="background:${expense.status === 'admin_review' ? '#f59e0b' : '#22c55e'};">${expense.status === 'admin_review' ? '⏳ APERÇU (en cours de validation)' : '✓ APPROUVÉ'}</span>
          </div>

          <div class="info-grid">
            <div class="info-box">
              <div class="info-label">Catégorie</div>
              <div class="info-value">${categoryLabels[expense.category] || expense.category}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Date prévue</div>
              <div class="info-value">${expense.planned_date || 'Non spécifiée'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Demandé par</div>
              <div class="info-value">${expense.requested_by || 'N/A'}</div>
            </div>
            <div class="info-box">
              <div class="info-label">Approuvé par</div>
              <div class="info-value">${expense.approved_by || 'Administrateur'}</div>
            </div>
          </div>

          <div class="details">
            <div class="details-title">Description</div>
            <div>${expense.description}</div>
          </div>

          ${expense.supplier ? `
          <div class="details">
            <div class="details-title">Fournisseur</div>
            <div>${expense.supplier}</div>
          </div>
          ` : ''}

          ${itemsBlock}

          <div class="amount-box">
            <div class="amount-label">${expense.status === 'admin_review' ? 'MONTANT PROVISOIRE (corrigé)' : 'MONTANT APPROUVÉ'}</div>
            <div class="amount-value">${formatPrice(visibleAmount)} F CFA</div>
          </div>

          <div class="signatures">
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Signature Responsable Op. & Log</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Signature Admin</div>
            </div>
          </div>

          <div class="print-date">
            Imprimé le ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
          </div>

          <script>window.onload = function() { setTimeout(function() { window.print(); }, 300); }</script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Print all approved expenses as a summary PDF
  const printAllApprovedExpenses = () => {
    const approved = expenses.filter(e => e.status === 'approved');
    if (approved.length === 0) {
      toast.error("Aucune demande approuvée à imprimer");
      return;
    }

    const printWindow = window.open('', '_blank', 'width=800,height=600');
    // Helper: keep only non-struck items for grouped expenses
    const keptItems = (e) => (e.items || []).filter(it => !it.struck);
    const expenseAmount = (e) => {
      if (e.is_group && Array.isArray(e.items)) {
        return keptItems(e).reduce((s, it) => s + (it.amount || 0), 0) || e.amount;
      }
      return e.amount;
    };
    const total = approved.reduce((sum, e) => sum + expenseAmount(e), 0);
    
    const categoryLabels = {
      cuisine: 'Cuisine',
      bar: 'Bar',
      paiement: 'Paiement',
      autres: 'Autres'
    };
    
    const catColor = (c) => c === 'cuisine' ? '#22c55e' : c === 'bar' ? '#f97316' : c === 'paiement' ? '#3b82f6' : '#64748b';

    // Compute brief audit summary (counts only — struck motifs deliberately excluded from print)
    const norm = (s) => String(s || '').trim().toLowerCase();
    const briefAudit = (e) => {
      if (!e.is_group || !e.original_items) return null;
      const finals = e.items || [];
      const finalsByDesc = new Map();
      finals.forEach((it, i) => {
        const k = norm(it.description);
        if (!finalsByDesc.has(k)) finalsByDesc.set(k, []);
        finalsByDesc.get(k).push({ ...it, _i: i });
      });
      let added = 0, removed = 0, struck = 0, modified = 0;
      const matched = new Set();
      e.original_items.forEach((orig) => {
        const k = norm(orig.description);
        const cands = finalsByDesc.get(k) || [];
        const m = cands.find((c) => !matched.has(c._i));
        if (!m) { removed += 1; return; }
        matched.add(m._i);
        if (m.struck) { struck += 1; return; }
        if (Number(m.quantity) !== Number(orig.quantity) || Number(m.unit_price) !== Number(orig.unit_price)) modified += 1;
      });
      finals.forEach((it, i) => { if (!matched.has(i) && !it.struck) added += 1; });
      const total = added + removed + struck + modified;
      if (total === 0) return null;
      const parts = [];
      if (added) parts.push(`+${added} ajoutée${added > 1 ? 's' : ''}`);
      if (removed) parts.push(`−${removed} supprimée${removed > 1 ? 's' : ''}`);
      if (struck) parts.push(`${struck} rayée${struck > 1 ? 's' : ''}`);
      if (modified) parts.push(`${modified} modifiée${modified > 1 ? 's' : ''}`);
      return parts.join(', ');
    };

    const itemsHtml = approved.map((expense, index) => {
      const visibleItems = (expense.is_group && Array.isArray(expense.items))
        ? expense.items.filter(it => !it.struck)
        : (expense.items || []);
      const headerAmount = expenseAmount(expense);
      const auditSummary = briefAudit(expense);
      const headerRow = `
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 11pt;">${index + 1}</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top;">
            <span style="background: ${catColor(expense.category)}; color: white; padding: 3px 10px; border-radius: 10px; font-size: 11pt; font-weight: 600;">
              ${categoryLabels[expense.category] || expense.category}
            </span>
          </td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 12pt;">
            ${expense.is_group ? '<strong>📦 ' + expense.description + '</strong> <span style="font-size:10pt;color:#666;">(' + visibleItems.length + ' articles)</span>' : expense.description}
            ${auditSummary ? `<div style="margin-top:4px;font-size:9pt;color:#92400e;font-style:italic;">📜 Liste corrigée par admin : ${auditSummary}</div>` : ''}
          </td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 11pt;">${expense.supplier || '-'}</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; text-align: right; font-weight: 700; vertical-align: top; font-size: 12pt;">${formatPrice(headerAmount)} F</td>
        </tr>
      `;
      // Expand sub-items for grouped lists (only non-struck items shown — struck items
      // and their reasons are intentionally hidden from the printed approved list)
      if (expense.is_group && visibleItems.length > 0) {
        const subRows = visibleItems.map((it, sIdx) => `
          <tr style="background: #fafafa;">
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0; text-align: right; font-size: 10pt; color: #666;">${index + 1}.${sIdx + 1}</td>
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0;">
              <span style="background: ${catColor(it.category)}; opacity: 0.75; color: white; padding: 2px 8px; border-radius: 8px; font-size: 10pt;">
                ${categoryLabels[it.category] || it.category}
              </span>
            </td>
            <td style="padding: 6px 8px 6px 24px; border-bottom: 1px solid #f0f0f0; font-size: 11pt; color: #333;">
              ↳ ${it.description}
              <span style="color: #555; font-size: 10pt;"> — Qté ${it.quantity} × ${formatPrice(it.unit_price)} F</span>
            </td>
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0;"></td>
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0; text-align: right; font-size: 11pt; color: #222; font-weight: 600;">${formatPrice(it.amount)} F</td>
          </tr>
        `).join('');
        return headerRow + subRows;
      }
      // Single item: enrich with qty × PU when available
      if (!expense.is_group && expense.quantity && expense.unit_price) {
        const detailRow = `
          <tr style="background: #fafafa;">
            <td></td><td></td>
            <td style="padding: 4px 8px 6px 24px; font-size: 10pt; color: #555; border-bottom: 1px solid #f0f0f0;">
              ↳ Qté ${expense.quantity} × ${formatPrice(expense.unit_price)} F
            </td>
            <td style="border-bottom: 1px solid #f0f0f0;"></td>
            <td style="border-bottom: 1px solid #f0f0f0;"></td>
          </tr>
        `;
        return headerRow + detailRow;
      }
      return headerRow;
    }).join('');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Liste des Achats Approuvés</title>
          <meta charset="UTF-8">
          <style>
            @page { size: A4; margin: 15mm; }
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: Arial, sans-serif; padding: 20px; background: #fff; color: #333; font-size: 12pt; }
            .header { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #333; padding-bottom: 10px; margin-bottom: 15px; }
            .logo { width: 80px; height: 80px; }
            .logo img { width: 100%; height: 100%; object-fit: contain; }
            .header-right { text-align: right; font-size: 11pt; }
            .doc-title { text-align: center; font-size: 18pt; font-weight: bold; margin: 10px 0; text-transform: uppercase; letter-spacing: 1px; }
            .date-line { text-align: center; font-size: 12pt; color: #555; margin-bottom: 15px; }
            table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 11pt; }
            thead tr { border-top: 2px solid #333; border-bottom: 2px solid #333; }
            th { padding: 10px 8px; text-align: left; font-weight: bold; text-transform: uppercase; font-size: 10pt; }
            td { padding: 8px; border-bottom: 1px solid #ddd; }
            .total-row { border-top: 2px solid #333; }
            .total-row td { font-weight: bold; padding: 12px 8px; font-size: 14pt; }
            .footer { display: flex; justify-content: space-between; margin-top: 30px; }
            .signature-box { text-align: center; width: 30%; }
            .signature-line { border-bottom: 1px solid #333; height: 40px; margin-bottom: 5px; }
            .signature-label { font-size: 11pt; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo"><img src="${LOGO_BASE64}" alt="Logo" /></div>
            <div class="header-right">
              <p>Tél: +229 01 4147 0000</p>
              <p>RCCM RB/COT/22 B 32037</p>
              <p>Fidjrossè, Cotonou</p>
            </div>
          </div>
          
          <div class="doc-title">Liste des Achats Approuvés</div>
          <div class="date-line">${new Date().toLocaleDateString('fr-FR')}</div>

          <table>
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 15%;">Catégorie</th>
                <th style="width: 35%;">Description</th>
                <th style="width: 20%;">Fournisseur</th>
                <th style="width: 25%; text-align: right;">Montant</th>
              </tr>
            </thead>
            <tbody>
              ${itemsHtml}
              <tr class="total-row">
                <td colspan="4" style="text-align: right;">TOTAL:</td>
                <td style="text-align: right;">${formatPrice(total)} F CFA</td>
              </tr>
            </tbody>
          </table>

          <div class="footer">
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Responsable Op. & Log</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Administrateur</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Comptable</div>
            </div>
          </div>

          <script>window.onload = function() { setTimeout(function() { window.print(); }, 300); }</script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Print approved expenses — ONE FULL PAGE PER EXPENSE with complete detail
  const printApprovedExpensesDetailed = () => {
    const approved = expenses.filter(e => e.status === 'approved');
    if (approved.length === 0) {
      toast.error("Aucune demande approuvée à imprimer");
      return;
    }
    const categoryLabels = { cuisine: 'Cuisine', bar: 'Bar', paiement: 'Paiement', autres: 'Autres' };
    const catColor = (c) => c === 'cuisine' ? '#22c55e' : c === 'bar' ? '#f97316' : c === 'paiement' ? '#3b82f6' : '#64748b';

    // Brief audit summary (counts only) — used as a small footer note per page.
    const norm = (s) => String(s || '').trim().toLowerCase();
    const briefAudit = (e) => {
      if (!e.is_group || !e.original_items) return null;
      const finals = e.items || [];
      const finalsByDesc = new Map();
      finals.forEach((it, i) => {
        const k = norm(it.description);
        if (!finalsByDesc.has(k)) finalsByDesc.set(k, []);
        finalsByDesc.get(k).push({ ...it, _i: i });
      });
      let added = 0, removed = 0, struck = 0, modified = 0;
      const matched = new Set();
      e.original_items.forEach((orig) => {
        const k = norm(orig.description);
        const cands = finalsByDesc.get(k) || [];
        const m = cands.find((c) => !matched.has(c._i));
        if (!m) { removed += 1; return; }
        matched.add(m._i);
        if (m.struck) { struck += 1; return; }
        if (Number(m.quantity) !== Number(orig.quantity) || Number(m.unit_price) !== Number(orig.unit_price)) modified += 1;
      });
      finals.forEach((it, i) => { if (!matched.has(i) && !it.struck) added += 1; });
      const total = added + removed + struck + modified;
      if (total === 0) return null;
      const parts = [];
      if (added) parts.push(`+${added} ajoutée${added > 1 ? 's' : ''}`);
      if (removed) parts.push(`−${removed} supprimée${removed > 1 ? 's' : ''}`);
      if (struck) parts.push(`${struck} rayée${struck > 1 ? 's' : ''}`);
      if (modified) parts.push(`${modified} modifiée${modified > 1 ? 's' : ''}`);
      return parts.join(', ');
    };

    const pagesHtml = approved.map((e, idx) => {
      // Hide struck items from the printed approved list (per user requirement).
      const visibleItems = (e.is_group && Array.isArray(e.items))
        ? e.items.filter((it) => !it.struck)
        : (e.items || []);
      const visibleAmount = (e.is_group && Array.isArray(e.items))
        ? visibleItems.reduce((s, it) => s + (it.amount || 0), 0) || e.amount
        : e.amount;
      const itemsTable = (e.is_group && visibleItems.length > 0)
        ? `
          <table class="items-table">
            <thead>
              <tr>
                <th style="width:6%">#</th>
                <th style="width:15%">Catégorie</th>
                <th>Description</th>
                <th style="width:10%;text-align:right">Qté</th>
                <th style="width:15%;text-align:right">PU</th>
                <th style="width:18%;text-align:right">Total</th>
              </tr>
            </thead>
            <tbody>
              ${visibleItems.map((it, i) => `
                <tr>
                  <td>${i + 1}</td>
                  <td><span class="cat-badge" style="background:${catColor(it.category)}">${categoryLabels[it.category] || it.category}</span></td>
                  <td>${it.description}</td>
                  <td style="text-align:right">${it.quantity}</td>
                  <td style="text-align:right">${formatPrice(it.unit_price)} F</td>
                  <td style="text-align:right;font-weight:600">${formatPrice(it.amount)} F</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        `
        : (e.quantity && e.unit_price ? `
          <table class="items-table">
            <thead>
              <tr>
                <th>Description</th>
                <th style="width:15%;text-align:right">Qté</th>
                <th style="width:20%;text-align:right">PU</th>
                <th style="width:20%;text-align:right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${e.description}</td>
                <td style="text-align:right">${e.quantity}</td>
                <td style="text-align:right">${formatPrice(e.unit_price)} F</td>
                <td style="text-align:right;font-weight:600">${formatPrice(e.amount)} F</td>
              </tr>
            </tbody>
          </table>
        ` : '');

      return `
        <section class="page ${idx < approved.length - 1 ? 'break-after' : ''}">
          <div class="page-header">
            <div class="logo"><img src="${LOGO_BASE64}" alt="Logo" /></div>
            <div class="header-right">
              <p><strong>ESPACE MAXO</strong></p>
              <p>Tél: +229 01 4147 0000</p>
              <p>RCCM RB/COT/22 B 32037</p>
              <p>Fidjrossè, Cotonou</p>
            </div>
          </div>

          <div class="doc-title">Bon d'Achat Approuvé <span class="badge-approved">✓ APPROUVÉ</span></div>
          <div class="doc-sub">Achat ${idx + 1} / ${approved.length} — ${new Date().toLocaleDateString('fr-FR')}</div>

          <div class="meta-grid">
            <div class="meta-box">
              <div class="meta-label">Catégorie</div>
              <div class="meta-value"><span class="cat-badge" style="background:${catColor(e.category)}">${categoryLabels[e.category] || e.category}</span></div>
            </div>
            <div class="meta-box">
              <div class="meta-label">Date prévue</div>
              <div class="meta-value">${e.planned_date || '—'}</div>
            </div>
            <div class="meta-box">
              <div class="meta-label">Demandé par</div>
              <div class="meta-value">${e.requested_by || '—'}</div>
            </div>
            <div class="meta-box">
              <div class="meta-label">Approuvé par</div>
              <div class="meta-value">${e.approved_by || '—'}</div>
            </div>
            <div class="meta-box">
              <div class="meta-label">Fournisseur</div>
              <div class="meta-value">${e.supplier || '—'}</div>
            </div>
            <div class="meta-box">
              <div class="meta-label">Type</div>
              <div class="meta-value">${e.is_group ? '📦 Liste (' + visibleItems.length + ' articles)' : 'Achat unique'}</div>
            </div>
          </div>

          <div class="desc-block">
            <div class="meta-label">Description</div>
            <div class="desc-text">${e.description}</div>
          </div>

          ${itemsTable}

          <div class="amount-box">
            <div class="amount-label">MONTANT TOTAL APPROUVÉ</div>
            <div class="amount-value">${formatPrice(visibleAmount)} F CFA</div>
          </div>

          ${(() => { const a = briefAudit(e); return a ? `
            <div style="margin-top:10px;padding:8px 12px;border-left:3px solid #f59e0b;background:#fffbeb;color:#92400e;font-size:9pt;font-style:italic;">
              📜 Liste corrigée par ${e.approved_by || 'Admin'} : ${a}.
            </div>` : ''; })()}

          <div class="signatures">
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Responsable Op. & Log</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Administrateur</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Comptable</div>
            </div>
          </div>

          <div class="print-footer">
            Imprimé le ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
          </div>
        </section>
      `;
    }).join('');

    const printWindow = window.open('', '_blank', 'width=900,height=700');
    if (!printWindow) { toast.error("Popup bloqué! Autorisez les popups pour ce site."); return; }
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Détail des Achats Approuvés</title>
          <meta charset="UTF-8">
          <style>
            @page { size: A4; margin: 15mm; }
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: Arial, sans-serif; background: #fff; color: #222; font-size: 12pt; }
            .page { padding: 10px 0; }
            .break-after { page-break-after: always; }
            .page-header { display: flex; align-items: center; justify-content: space-between; border-bottom: 2px solid #333; padding-bottom: 12px; margin-bottom: 18px; }
            .logo { width: 80px; height: 80px; }
            .logo img { width: 100%; height: 100%; object-fit: contain; }
            .header-right { text-align: right; font-size: 11pt; line-height: 1.5; }
            .doc-title { text-align: center; font-size: 20pt; font-weight: bold; margin: 6px 0 2px; text-transform: uppercase; letter-spacing: 1px; }
            .doc-sub { text-align: center; font-size: 12pt; color: #555; margin-bottom: 18px; }
            .badge-approved { display: inline-block; background: #16a34a; color: #fff; padding: 3px 12px; border-radius: 14px; font-size: 12pt; vertical-align: middle; font-weight: 600; }
            .meta-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 18px; }
            .meta-box { border: 1px solid #ddd; padding: 10px 12px; border-radius: 4px; background: #fafafa; }
            .meta-label { font-size: 10pt; color: #666; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 3px; }
            .meta-value { font-size: 13pt; font-weight: 600; color: #222; }
            .cat-badge { display: inline-block; color: white; padding: 3px 12px; border-radius: 12px; font-size: 11pt; font-weight: 600; }
            .desc-block { border-left: 4px solid #4f46e5; padding: 10px 14px; background: #f5f5ff; margin-bottom: 18px; }
            .desc-text { font-size: 14pt; font-weight: 600; color: #1e1b4b; margin-top: 4px; }
            .items-table { width: 100%; border-collapse: collapse; margin-bottom: 18px; font-size: 12pt; }
            .items-table thead tr { background: #1e293b; color: white; }
            .items-table th { padding: 10px; text-align: left; font-weight: 600; font-size: 11pt; text-transform: uppercase; letter-spacing: 0.5px; }
            .items-table tbody td { padding: 10px; border-bottom: 1px solid #e5e7eb; font-size: 12pt; }
            .items-table tbody tr:nth-child(even) { background: #f9fafb; }
            .amount-box { border: 3px solid #333; padding: 18px; text-align: center; margin: 18px 0; background: #fffbeb; border-radius: 6px; }
            .amount-label { font-size: 12pt; color: #666; text-transform: uppercase; letter-spacing: 1px; }
            .amount-value { font-size: 30pt; font-weight: 900; margin-top: 6px; color: #b45309; }
            .signatures { display: flex; justify-content: space-between; margin-top: 30px; }
            .signature-box { text-align: center; width: 28%; }
            .signature-line { border-bottom: 1px solid #333; height: 50px; margin-bottom: 5px; }
            .signature-label { font-size: 11pt; color: #555; font-weight: 600; }
            .print-footer { text-align: center; font-size: 10pt; color: #999; margin-top: 20px; font-style: italic; }
          </style>
        </head>
        <body>
          ${pagesHtml}
          <script>window.onload = function() { setTimeout(function() { window.print(); }, 400); }</script>
        </body>
      </html>
    `);
    printWindow.document.close();
    toast.success(`Préparation de ${approved.length} bon(s) d'achat détaillé(s)...`);
  };

  // Print a SINGLE expense as 80mm thermal ticket (used in completed list)
  const printSingleExpenseTicket = (expense) => {
    const categoryLabels = { cuisine: 'CUIS', bar: 'BAR', paiement: 'PAIE', autres: 'AUTR' };
    if (!expense) return;

    const isGroup = expense.is_group && expense.items && expense.items.length > 0;
    let totalItems = isGroup ? expense.items.length : 1;
    let itemsHtml = '';

    if (isGroup) {
      itemsHtml = expense.items.map((it, idx) => (
        '<div class="sub-item">' +
        '<div class="sub-item-row">' +
        '<span class="sub-num">' + (idx + 1) + '.</span>' +
        '<span class="sub-cat">[' + (categoryLabels[it.category] || (it.category || '').substring(0, 4).toUpperCase()) + ']</span>' +
        '</div>' +
        '<div class="sub-desc">' + it.description + '</div>' +
        '<div class="sub-detail">' +
        '<span>Qte: ' + it.quantity + '</span>' +
        '<span>PU: ' + formatPrice(it.unit_price) + '</span>' +
        '<span class="sub-total">' + formatPrice(it.amount) + ' F</span>' +
        '</div>' +
        '</div>'
      )).join('');
    } else {
      const qty = expense.quantity || 1;
      const unitPrice = expense.unit_price || expense.amount;
      itemsHtml = '<div class="single-item">' +
        '<div class="cat-tag">[' + (categoryLabels[expense.category] || (expense.category || '').substring(0, 4).toUpperCase()) + ']</div>' +
        '<div class="desc">' + expense.description + '</div>' +
        '<div class="detail-row"><span>Qte: ' + qty + '</span><span>PU: ' + formatPrice(unitPrice) + ' F</span></div>' +
        '</div>';
    }

    const supplierLine = expense.supplier ? '<div class="info">Fourn: ' + expense.supplier + '</div>' : '';
    const dateLine = expense.completed_at ? '<div class="info">Termine le ' + expense.completed_at.slice(0, 10) + '</div>' : '';

    const html = '<!DOCTYPE html><html><head><title>Achat ' + (expense.description || '').slice(0, 20) + '</title><meta charset="UTF-8">' +
      '<style>' +
      '@page { size: 80mm auto; margin: 0; }' +
      '@media print { body { -webkit-print-color-adjust: exact; } }' +
      '* { margin: 0; padding: 0; box-sizing: border-box; }' +
      'body { font-family: "Courier New", monospace; width: 80mm; padding: 3mm; font-size: 11px; line-height: 1.3; background: white; color: black; }' +
      '.header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 8px; }' +
      '.title { font-size: 14px; font-weight: 900; letter-spacing: 1px; }' +
      '.subtitle { font-size: 10px; margin-top: 2px; font-style: italic; }' +
      '.date { font-size: 10px; margin-top: 4px; }' +
      '.status-badge { display: inline-block; border: 2px solid #000; padding: 2px 8px; font-size: 11px; font-weight: bold; margin-top: 4px; }' +
      '.info { font-size: 10px; margin: 3px 0; }' +
      '.cat-tag { font-size: 11px; font-weight: bold; }' +
      '.desc { font-size: 14px; font-weight: bold; margin: 4px 0; text-transform: uppercase; }' +
      '.detail-row { display: flex; justify-content: space-between; font-size: 11px; margin-top: 3px; }' +
      '.single-item { border-bottom: 1px dashed #000; padding: 6px 0; }' +
      '.sub-item { border-bottom: 1px dotted #999; padding: 4px 0; }' +
      '.sub-item-row { display: flex; justify-content: space-between; font-size: 9px; }' +
      '.sub-num { font-weight: bold; } .sub-cat { font-size: 8px; font-weight: bold; }' +
      '.sub-desc { font-size: 11px; font-weight: bold; margin: 2px 0; }' +
      '.sub-detail { display: flex; justify-content: space-between; font-size: 10px; }' +
      '.sub-total { font-weight: bold; }' +
      '.grand-total { border-top: 3px solid #000; margin-top: 10px; padding-top: 8px; text-align: center; }' +
      '.grand-total-label { font-size: 12px; }' +
      '.grand-total-value { font-size: 22px; font-weight: 900; }' +
      '.signature { margin-top: 12px; padding-top: 8px; border-top: 1px dashed #000; }' +
      '.signature-line { border-bottom: 1px solid #000; height: 28px; margin: 8px 0 3px; }' +
      '.signature-label { font-size: 10px; text-align: center; }' +
      '.footer { margin-top: 10px; text-align: center; font-size: 9px; border-top: 1px dashed #000; padding-top: 6px; }' +
      '.cut-line { margin-top: 8px; text-align: center; font-size: 10px; }' +
      '</style></head>' +
      '<body>' +
      '<div class="header">' +
      '<div class="title">ACHAT TERMINE</div>' +
      '<div class="subtitle">Bon d\'achat individuel</div>' +
      '<div class="status-badge">✓ ACHETE</div>' +
      '<div class="date">' + new Date().toLocaleDateString('fr-FR') + ' - ' + new Date().toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'}) + '</div>' +
      '</div>' +
      supplierLine + dateLine +
      (isGroup ? '<div class="info" style="font-weight:bold;text-transform:uppercase;font-size:12px;margin:6px 0;">📦 ' + expense.description + ' (' + totalItems + ' articles)</div>' : '') +
      itemsHtml +
      '<div class="grand-total">' +
      '<div class="grand-total-label">MONTANT TOTAL</div>' +
      '<div class="grand-total-value">' + formatPrice(expense.amount) + ' F</div>' +
      '</div>' +
      '<div class="signature">' +
      '<div class="signature-line"></div><div class="signature-label">Acheteur</div>' +
      '</div>' +
      '<div class="footer">Espace Maxo - Caisse Pro<br>- - - - - - - - - - - - - -</div>' +
      '<div class="cut-line">. . . . . . . . . . . . . . .</div>' +
      '<script>window.onload = function() { setTimeout(function() { window.print(); }, 500); }</script>' +
      '</body></html>';

    const printWindow = window.open('', '_blank', 'width=350,height=700');
    if (!printWindow) { toast.error("Popup bloqué! Autorisez les popups."); return; }
    printWindow.document.write(html);
    printWindow.document.close();
    toast.success("Ouverture du ticket d'impression...");
  };

  // Print all expenses (full list)
  const printAllExpensesList = () => {
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    const statusLabels = { pending: 'En attente', approved: 'Approuvée', completed: 'Terminée', revision_requested: 'À réviser', rejected: 'Refusée' };
    const categoryLabels = { cuisine: 'Cuisine', bar: 'Bar', paiement: 'Paiement', autres: 'Autres' };
    const total = expenses.reduce((sum, e) => sum + e.amount, 0);
    
    const rowsHtml = expenses.map((e, i) => {
      const catColor = e.category === 'cuisine' ? '#22c55e' : e.category === 'bar' ? '#f97316' : e.category === 'paiement' ? '#3b82f6' : '#64748b';
      const statusColor = e.status === 'approved' ? '#22c55e' : e.status === 'pending' ? '#f59e0b' : e.status === 'completed' ? '#64748b' : '#ef4444';
      const headerRow = '<tr style="border-bottom: 1px solid #eee;">' +
        '<td style="padding: 8px; text-align: center; vertical-align: top;">' + (i + 1) + '</td>' +
        '<td style="padding: 8px; vertical-align: top;"><span style="background: ' + catColor + '; color: white; padding: 2px 8px; border-radius: 10px; font-size: 11px;">' + (categoryLabels[e.category] || e.category) + '</span></td>' +
        '<td style="padding: 8px; vertical-align: top;">' + (e.is_group ? '<strong>📦 ' + e.description + '</strong> <span style="font-size:9pt;color:#666;">(' + (e.items?.length || 0) + ' art.)</span>' : e.description) + '</td>' +
        '<td style="padding: 8px; vertical-align: top;">' + (e.supplier || '-') + '</td>' +
        '<td style="padding: 8px; text-align: right; font-weight: 600; vertical-align: top;">' + formatPrice(e.amount) + ' F</td>' +
        '<td style="padding: 8px; vertical-align: top;"><span style="background: ' + statusColor + '; color: white; padding: 2px 8px; border-radius: 10px; font-size: 11px;">' + (statusLabels[e.status] || e.status) + '</span></td>' +
        '<td style="padding: 8px; font-size: 11px; color: #666; vertical-align: top;">' + (e.requested_by || '-') + '</td>' +
        '<td style="padding: 8px; font-size: 11px; color: #666; vertical-align: top;">' + (e.created_at?.slice(0, 10) || '-') + '</td>' +
        '</tr>';
      if (e.is_group && Array.isArray(e.items) && e.items.length > 0) {
        const subs = e.items.map((it, sIdx) => (
          '<tr style="background:#fafafa;border-bottom:1px solid #f3f3f3;">' +
          '<td style="padding:3px 8px;text-align:right;font-size:9pt;color:#666;">' + (i + 1) + '.' + (sIdx + 1) + '</td>' +
          '<td style="padding:3px 8px;"><span style="background:' + (it.category === 'cuisine' ? '#22c55e' : it.category === 'bar' ? '#f97316' : it.category === 'paiement' ? '#3b82f6' : '#64748b') + ';opacity:0.75;color:white;padding:1px 6px;border-radius:8px;font-size:9pt;">' + (categoryLabels[it.category] || it.category) + '</span></td>' +
          '<td style="padding:3px 8px 3px 24px;font-size:9pt;color:#333;">↳ ' + it.description + ' <span style="color:#888;font-size:8pt;">— Qté ' + it.quantity + ' × ' + formatPrice(it.unit_price) + ' F</span></td>' +
          '<td></td>' +
          '<td style="padding:3px 8px;text-align:right;font-size:9pt;color:#444;">' + formatPrice(it.amount) + ' F</td>' +
          '<td colspan="3"></td>' +
          '</tr>'
        )).join('');
        return headerRow + subs;
      }
      return headerRow;
    }).join('');

    const html = '<!DOCTYPE html><html><head><title>Liste Complète des Demandes</title>' +
      '<style>@page { size: A4 landscape; margin: 10mm; } body { font-family: Arial, sans-serif; padding: 15px; } ' +
      '.header { text-align: center; margin-bottom: 20px; } .logo { font-size: 20px; font-weight: 800; color: #4f46e5; } ' +
      'table { width: 100%; border-collapse: collapse; font-size: 12px; } th { background: #4f46e5; color: white; padding: 10px; text-align: left; } ' +
      '.total { background: #f8f9fa; font-weight: 800; }</style></head>' +
      '<body><div class="header"><div class="logo">ESPACE MAXO</div>' +
      '<div>Liste Complète des Demandes - ' + new Date().toLocaleDateString('fr-FR') + '</div></div>' +
      '<table><thead><tr><th>#</th><th>Catégorie</th><th>Description</th><th>Fournisseur</th><th>Montant</th><th>Statut</th><th>Demandé par</th><th>Date</th></tr></thead>' +
      '<tbody>' + rowsHtml + '<tr class="total"><td colspan="4" style="padding: 10px; text-align: right;">TOTAL:</td>' +
      '<td style="padding: 10px; color: #4f46e5;">' + formatPrice(total) + ' F</td><td colspan="3"></td></tr></tbody></table>' +
      '<script>window.onload = function() { setTimeout(function() { window.print(); }, 300); }</script></body></html>';
    
    printWindow.document.write(html);
    printWindow.document.close();
  };

  // Print expenses on small thermal printer (80mm) - black & white - APPROVED ONLY for market shopping
  const printExpensesTicket = () => {
    const categoryLabels = { cuisine: 'CUIS', bar: 'BAR', paiement: 'PAIE', autres: 'AUTR' };
    
    // Filter ONLY approved expenses (ready to buy at market)
    const toPrint = expenses.filter(e => e.status === 'approved');
    const total = toPrint.reduce((sum, e) => sum + e.amount, 0);
    
    if (toPrint.length === 0) {
      toast.error("Aucune demande approuvée à imprimer. Approuvez d'abord des demandes.");
      return;
    }
    
    // Count total items including sub-items from grouped lists
    let totalItems = 0;
    
    const itemsHtml = toPrint.map((e, i) => {
      // If it's a grouped list, show all sub-items
      if (e.is_group && e.items && e.items.length > 0) {
        totalItems += e.items.length;
        const subItemsHtml = e.items.map((item, subIdx) => {
          return '<div class="sub-item">' +
            '<div class="sub-item-row">' +
            '<span class="sub-num">' + (subIdx + 1) + '.</span>' +
            '<span class="sub-cat">[' + (categoryLabels[item.category] || item.category.substring(0, 4).toUpperCase()) + ']</span>' +
            '</div>' +
            '<div class="sub-desc">' + item.description + '</div>' +
            '<div class="sub-detail">' +
            '<span>Qte: ' + item.quantity + '</span>' +
            '<span>PU: ' + formatPrice(item.unit_price) + '</span>' +
            '<span class="sub-total">' + formatPrice(item.amount) + ' F</span>' +
            '</div>' +
            '</div>';
        }).join('');
        
        return '<div class="group-item">' +
          '<div class="group-header">' +
          '<span class="group-icon">📦</span>' +
          '<span class="group-title">' + e.description + '</span>' +
          '</div>' +
          (e.supplier ? '<div class="supplier">Fourn: ' + e.supplier + '</div>' : '') +
          '<div class="sub-items">' + subItemsHtml + '</div>' +
          '<div class="group-total">' +
          '<span>TOTAL LISTE:</span>' +
          '<span>' + formatPrice(e.amount) + ' F</span>' +
          '</div>' +
          '</div>';
      } else {
        // Single item
        totalItems += 1;
        const qty = e.quantity || 1;
        const unitPrice = e.unit_price || e.amount;
        const lineTotal = e.amount || (qty * unitPrice);
        return '<div class="item">' +
          '<div class="item-row">' +
          '<span class="num">' + (i + 1) + '.</span>' +
          '<span class="cat">[' + (categoryLabels[e.category] || e.category.substring(0, 4).toUpperCase()) + ']</span>' +
          '</div>' +
          '<div class="desc">' + e.description + '</div>' +
          '<div class="detail-row">' +
          '<span>Qte: ' + qty + '</span>' +
          '<span>PU: ' + formatPrice(unitPrice) + ' F</span>' +
          '</div>' +
          '<div class="total-row">' +
          '<span>TOTAL:</span>' +
          '<span class="line-total">' + formatPrice(lineTotal) + ' F</span>' +
          '</div>' +
          (e.supplier ? '<div class="supplier">Fourn: ' + e.supplier + '</div>' : '') +
          '</div>';
      }
    }).join('');

    const html = '<!DOCTYPE html><html><head><title>Liste Achats Approuves</title><meta charset="UTF-8">' +
      '<style>' +
      '@page { size: 80mm auto; margin: 0; }' +
      '@media print { body { -webkit-print-color-adjust: exact; } }' +
      '* { margin: 0; padding: 0; box-sizing: border-box; }' +
      'body { font-family: "Courier New", monospace; width: 80mm; padding: 3mm; font-size: 11px; line-height: 1.3; background: white; color: black; }' +
      '.header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 8px; }' +
      '.title { font-size: 14px; font-weight: 900; letter-spacing: 1px; }' +
      '.subtitle { font-size: 10px; margin-top: 2px; font-style: italic; }' +
      '.date { font-size: 10px; margin-top: 4px; }' +
      '.count { font-size: 12px; font-weight: bold; margin-top: 4px; border: 1px solid #000; display: inline-block; padding: 2px 8px; }' +
      '.item { border-bottom: 1px dashed #000; padding: 6px 0; }' +
      '.item-row { display: flex; justify-content: space-between; font-size: 10px; margin-bottom: 2px; }' +
      '.num { font-weight: bold; }' +
      '.cat { font-weight: bold; }' +
      '.desc { font-size: 13px; font-weight: bold; margin: 3px 0; text-transform: uppercase; }' +
      '.detail-row { display: flex; justify-content: space-between; font-size: 11px; margin: 2px 0; }' +
      '.total-row { display: flex; justify-content: space-between; font-size: 12px; font-weight: bold; margin-top: 3px; border-top: 1px dotted #000; padding-top: 2px; }' +
      '.line-total { font-size: 13px; }' +
      '.supplier { font-size: 9px; color: #333; margin-top: 2px; }' +
      /* Group styles */
      '.group-item { border: 2px solid #000; padding: 6px; margin-bottom: 8px; }' +
      '.group-header { display: flex; align-items: center; gap: 5px; font-weight: bold; font-size: 12px; border-bottom: 1px solid #000; padding-bottom: 4px; margin-bottom: 4px; }' +
      '.group-icon { font-size: 14px; }' +
      '.group-title { text-transform: uppercase; }' +
      '.sub-items { padding-left: 5px; }' +
      '.sub-item { border-bottom: 1px dotted #999; padding: 3px 0; }' +
      '.sub-item-row { display: flex; justify-content: space-between; font-size: 9px; }' +
      '.sub-num { font-weight: bold; }' +
      '.sub-cat { font-size: 8px; }' +
      '.sub-desc { font-size: 11px; font-weight: bold; margin: 2px 0; }' +
      '.sub-detail { display: flex; justify-content: space-between; font-size: 10px; }' +
      '.sub-total { font-weight: bold; }' +
      '.group-total { display: flex; justify-content: space-between; font-weight: 900; font-size: 12px; border-top: 2px solid #000; margin-top: 4px; padding-top: 4px; }' +
      /* Grand total */
      '.grand-total { border-top: 3px solid #000; margin-top: 10px; padding-top: 8px; text-align: center; }' +
      '.grand-total-label { font-size: 12px; }' +
      '.grand-total-value { font-size: 22px; font-weight: 900; }' +
      '.footer { margin-top: 10px; text-align: center; font-size: 9px; border-top: 1px dashed #000; padding-top: 6px; }' +
      '.cut-line { margin-top: 8px; text-align: center; font-size: 10px; }' +
      '</style></head>' +
      '<body>' +
      '<div class="header">' +
      '<div class="title">LISTE ACHATS</div>' +
      '<div class="subtitle">Demandes Approuvees</div>' +
      '<div class="date">' + new Date().toLocaleDateString('fr-FR') + ' - ' + new Date().toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'}) + '</div>' +
      '<div class="count">' + totalItems + ' article(s)</div>' +
      '</div>' +
      itemsHtml +
      '<div class="grand-total">' +
      '<div class="grand-total-label">TOTAL A DEPENSER</div>' +
      '<div class="grand-total-value">' + formatPrice(total) + ' F</div>' +
      '</div>' +
      '<div class="footer">' +
      'Espace Maxo - Caisse Pro<br>' +
      '- - - - - - - - - - - - - -' +
      '</div>' +
      '<div class="cut-line">. . . . . . . . . . . . . . .</div>' +
      '<script>window.onload = function() { setTimeout(function() { window.print(); }, 500); }</script>' +
      '</body></html>';
    
    const printWindow = window.open('', '_blank', 'width=350,height=700');
    if (!printWindow || printWindow.closed || typeof printWindow.closed === 'undefined') {
      toast.error("Popup bloqué! Autorisez les popups pour ce site.");
      return;
    }
    
    printWindow.document.write(html);
    printWindow.document.close();
    toast.success("Ouverture du ticket d'impression...");
  };

  // Print COMPLETED expenses on 80mm thermal — same layout as printExpensesTicket
  const printCompletedExpensesTicket = () => {
    const categoryLabels = { cuisine: 'CUIS', bar: 'BAR', paiement: 'PAIE', autres: 'AUTR' };
    const toPrint = expenses.filter(e => e.status === 'completed');
    const total = toPrint.reduce((sum, e) => sum + (e.amount || 0), 0);
    if (toPrint.length === 0) {
      toast.error("Aucun achat terminé à imprimer.");
      return;
    }
    let totalItems = 0;
    const itemsHtml = toPrint.map((e, i) => {
      const dateLine = e.completed_at ? ('<div class="supplier">Termine le ' + e.completed_at.slice(0, 10) + '</div>') : '';
      if (e.is_group && e.items && e.items.length > 0) {
        totalItems += e.items.length;
        const subItemsHtml = e.items.map((item, subIdx) => (
          '<div class="sub-item">' +
          '<div class="sub-item-row">' +
          '<span class="sub-num">' + (subIdx + 1) + '.</span>' +
          '<span class="sub-cat">[' + (categoryLabels[item.category] || item.category.substring(0, 4).toUpperCase()) + ']</span>' +
          '</div>' +
          '<div class="sub-desc">' + item.description + '</div>' +
          '<div class="sub-detail">' +
          '<span>Qte: ' + item.quantity + '</span>' +
          '<span>PU: ' + formatPrice(item.unit_price) + '</span>' +
          '<span class="sub-total">' + formatPrice(item.amount) + ' F</span>' +
          '</div>' +
          '</div>'
        )).join('');
        return '<div class="group-item">' +
          '<div class="group-header">' +
          '<span class="group-icon">📦</span>' +
          '<span class="group-title">' + e.description + '</span>' +
          '</div>' +
          (e.supplier ? '<div class="supplier">Fourn: ' + e.supplier + '</div>' : '') +
          dateLine +
          '<div class="sub-items">' + subItemsHtml + '</div>' +
          '<div class="group-total">' +
          '<span>TOTAL LISTE:</span>' +
          '<span>' + formatPrice(e.amount) + ' F</span>' +
          '</div>' +
          '</div>';
      }
      totalItems += 1;
      const qty = e.quantity || 1;
      const unitPrice = e.unit_price || e.amount;
      const lineTotal = e.amount || (qty * unitPrice);
      return '<div class="item">' +
        '<div class="item-row">' +
        '<span class="num">' + (i + 1) + '.</span>' +
        '<span class="cat">[' + (categoryLabels[e.category] || e.category.substring(0, 4).toUpperCase()) + ']</span>' +
        '</div>' +
        '<div class="desc">' + e.description + '</div>' +
        '<div class="detail-row">' +
        '<span>Qte: ' + qty + '</span>' +
        '<span>PU: ' + formatPrice(unitPrice) + ' F</span>' +
        '</div>' +
        '<div class="total-row">' +
        '<span>TOTAL:</span>' +
        '<span class="line-total">' + formatPrice(lineTotal) + ' F</span>' +
        '</div>' +
        (e.supplier ? '<div class="supplier">Fourn: ' + e.supplier + '</div>' : '') +
        dateLine +
        '</div>';
    }).join('');

    const html = '<!DOCTYPE html><html><head><title>Achats Termines</title><meta charset="UTF-8">' +
      '<style>' +
      '@page { size: 80mm auto; margin: 0; }' +
      '@media print { body { -webkit-print-color-adjust: exact; } }' +
      '* { margin: 0; padding: 0; box-sizing: border-box; }' +
      'body { font-family: "Courier New", monospace; width: 80mm; padding: 3mm; font-size: 11px; line-height: 1.3; background: white; color: black; }' +
      '.header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 8px; }' +
      '.title { font-size: 14px; font-weight: 900; letter-spacing: 1px; }' +
      '.subtitle { font-size: 10px; margin-top: 2px; font-style: italic; }' +
      '.date { font-size: 10px; margin-top: 4px; }' +
      '.count { font-size: 12px; font-weight: bold; margin-top: 4px; border: 1px solid #000; display: inline-block; padding: 2px 8px; }' +
      '.item { border-bottom: 1px dashed #000; padding: 6px 0; }' +
      '.item-row { display: flex; justify-content: space-between; font-size: 10px; margin-bottom: 2px; }' +
      '.num { font-weight: bold; } .cat { font-weight: bold; }' +
      '.desc { font-size: 13px; font-weight: bold; margin: 3px 0; text-transform: uppercase; }' +
      '.detail-row { display: flex; justify-content: space-between; font-size: 11px; margin: 2px 0; }' +
      '.total-row { display: flex; justify-content: space-between; font-size: 12px; font-weight: bold; margin-top: 3px; border-top: 1px dotted #000; padding-top: 2px; }' +
      '.line-total { font-size: 13px; }' +
      '.supplier { font-size: 9px; color: #333; margin-top: 2px; }' +
      '.group-item { border: 2px solid #000; padding: 6px; margin-bottom: 8px; }' +
      '.group-header { display: flex; align-items: center; gap: 5px; font-weight: bold; font-size: 12px; border-bottom: 1px solid #000; padding-bottom: 4px; margin-bottom: 4px; }' +
      '.group-icon { font-size: 14px; } .group-title { text-transform: uppercase; }' +
      '.sub-items { padding-left: 5px; }' +
      '.sub-item { border-bottom: 1px dotted #999; padding: 3px 0; }' +
      '.sub-item-row { display: flex; justify-content: space-between; font-size: 9px; }' +
      '.sub-num { font-weight: bold; } .sub-cat { font-size: 8px; }' +
      '.sub-desc { font-size: 11px; font-weight: bold; margin: 2px 0; }' +
      '.sub-detail { display: flex; justify-content: space-between; font-size: 10px; }' +
      '.sub-total { font-weight: bold; }' +
      '.group-total { display: flex; justify-content: space-between; font-weight: 900; font-size: 12px; border-top: 2px solid #000; margin-top: 4px; padding-top: 4px; }' +
      '.grand-total { border-top: 3px solid #000; margin-top: 10px; padding-top: 8px; text-align: center; }' +
      '.grand-total-label { font-size: 12px; }' +
      '.grand-total-value { font-size: 22px; font-weight: 900; }' +
      '.footer { margin-top: 10px; text-align: center; font-size: 9px; border-top: 1px dashed #000; padding-top: 6px; }' +
      '.cut-line { margin-top: 8px; text-align: center; font-size: 10px; }' +
      '</style></head>' +
      '<body>' +
      '<div class="header">' +
      '<div class="title">ACHATS TERMINES</div>' +
      '<div class="subtitle">Historique des achats effectues</div>' +
      '<div class="date">' + new Date().toLocaleDateString('fr-FR') + ' - ' + new Date().toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'}) + '</div>' +
      '<div class="count">' + totalItems + ' article(s)</div>' +
      '</div>' +
      itemsHtml +
      '<div class="grand-total">' +
      '<div class="grand-total-label">TOTAL DEPENSE</div>' +
      '<div class="grand-total-value">' + formatPrice(total) + ' F</div>' +
      '</div>' +
      '<div class="footer">Espace Maxo - Caisse Pro<br>- - - - - - - - - - - - - -</div>' +
      '<div class="cut-line">. . . . . . . . . . . . . . .</div>' +
      '<script>window.onload = function() { setTimeout(function() { window.print(); }, 500); }</script>' +
      '</body></html>';

    const printWindow = window.open('', '_blank', 'width=350,height=700');
    if (!printWindow || printWindow.closed || typeof printWindow.closed === 'undefined') {
      toast.error("Popup bloqué! Autorisez les popups pour ce site.");
      return;
    }
    printWindow.document.write(html);
    printWindow.document.close();
    toast.success("Ouverture du ticket d'impression...");
  };

  // Print all COMPLETED expenses as an A4 summary (same style as printAllApprovedExpenses)
  const printAllCompletedExpenses = () => {
    const completed = expenses.filter(e => e.status === 'completed');
    if (completed.length === 0) {
      toast.error("Aucun achat terminé à imprimer");
      return;
    }
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    const total = completed.reduce((sum, e) => sum + (e.amount || 0), 0);
    const categoryLabels = { cuisine: 'Cuisine', bar: 'Bar', paiement: 'Paiement', autres: 'Autres' };
    const catColor = (c) => c === 'cuisine' ? '#22c55e' : c === 'bar' ? '#f97316' : c === 'paiement' ? '#3b82f6' : '#64748b';

    const itemsHtml = completed.map((expense, index) => {
      const headerRow = `
        <tr>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 11pt;">${index + 1}</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top;">
            <span style="background: ${catColor(expense.category)}; color: white; padding: 3px 10px; border-radius: 10px; font-size: 11pt; font-weight: 600;">
              ${categoryLabels[expense.category] || expense.category}
            </span>
          </td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 12pt;">
            ${expense.is_group ? '<strong>📦 ' + expense.description + '</strong> <span style="font-size:10pt;color:#666;">(' + (expense.items?.length || 0) + ' articles)</span>' : expense.description}
          </td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 11pt;">${expense.supplier || '-'}</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; vertical-align: top; font-size: 11pt; color:#666;">${expense.completed_at?.slice(0, 10) || '-'}</td>
          <td style="padding: 10px 8px; border-bottom: 1px solid #eee; text-align: right; font-weight: 700; vertical-align: top; font-size: 12pt;">${formatPrice(expense.amount)} F</td>
        </tr>
      `;
      if (expense.is_group && Array.isArray(expense.items) && expense.items.length > 0) {
        const subRows = expense.items.map((it, sIdx) => `
          <tr style="background: #fafafa;">
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0; text-align: right; font-size: 10pt; color: #666;">${index + 1}.${sIdx + 1}</td>
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0;">
              <span style="background: ${catColor(it.category)}; opacity: 0.75; color: white; padding: 2px 8px; border-radius: 8px; font-size: 10pt;">
                ${categoryLabels[it.category] || it.category}
              </span>
            </td>
            <td style="padding: 6px 8px 6px 24px; border-bottom: 1px solid #f0f0f0; font-size: 11pt; color: #333;">
              ↳ ${it.description}
              <span style="color: #555; font-size: 10pt;"> — Qté ${it.quantity} × ${formatPrice(it.unit_price)} F</span>
            </td>
            <td colspan="2" style="border-bottom: 1px solid #f0f0f0;"></td>
            <td style="padding: 6px 8px; border-bottom: 1px solid #f0f0f0; text-align: right; font-size: 11pt; color: #222; font-weight: 600;">${formatPrice(it.amount)} F</td>
          </tr>
        `).join('');
        return headerRow + subRows;
      }
      return headerRow;
    }).join('');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Achats Terminés</title>
          <meta charset="UTF-8">
          <style>
            @page { size: A4; margin: 15mm; }
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: Arial, sans-serif; padding: 20px; background: #fff; color: #333; font-size: 12pt; }
            .header { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #333; padding-bottom: 10px; margin-bottom: 15px; }
            .logo { width: 80px; height: 80px; }
            .logo img { width: 100%; height: 100%; object-fit: contain; }
            .header-right { text-align: right; font-size: 11pt; }
            .doc-title { text-align: center; font-size: 18pt; font-weight: bold; margin: 10px 0; text-transform: uppercase; letter-spacing: 1px; }
            .date-line { text-align: center; font-size: 12pt; color: #555; margin-bottom: 15px; }
            table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 11pt; }
            thead tr { border-top: 2px solid #333; border-bottom: 2px solid #333; }
            th { padding: 10px 8px; text-align: left; font-weight: bold; text-transform: uppercase; font-size: 10pt; }
            td { padding: 8px; border-bottom: 1px solid #ddd; }
            .total-row { border-top: 2px solid #333; }
            .total-row td { font-weight: bold; padding: 12px 8px; font-size: 14pt; }
            .footer { display: flex; justify-content: space-between; margin-top: 30px; }
            .signature-box { text-align: center; width: 30%; }
            .signature-line { border-bottom: 1px solid #333; height: 40px; margin-bottom: 5px; }
            .signature-label { font-size: 11pt; color: #666; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo"><img src="${LOGO_BASE64}" alt="Logo" /></div>
            <div class="header-right">
              <p>Tél: +229 01 4147 0000</p>
              <p>RCCM RB/COT/22 B 32037</p>
              <p>Fidjrossè, Cotonou</p>
            </div>
          </div>
          <div class="doc-title">Historique des Achats Terminés</div>
          <div class="date-line">${new Date().toLocaleDateString('fr-FR')}</div>
          <table>
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 12%;">Catégorie</th>
                <th style="width: 33%;">Description</th>
                <th style="width: 18%;">Fournisseur</th>
                <th style="width: 12%;">Terminé le</th>
                <th style="width: 20%; text-align: right;">Montant</th>
              </tr>
            </thead>
            <tbody>
              ${itemsHtml}
              <tr class="total-row">
                <td colspan="5" style="text-align: right;">TOTAL:</td>
                <td style="text-align: right;">${formatPrice(total)} F CFA</td>
              </tr>
            </tbody>
          </table>
          <div class="footer">
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Responsable Op. & Log</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Administrateur</div>
            </div>
            <div class="signature-box">
              <div class="signature-line"></div>
              <div class="signature-label">Comptable</div>
            </div>
          </div>
          <script>window.onload = function() { setTimeout(function() { window.print(); }, 300); }</script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };
  const openExpenseForEdit = (expense) => {
    setExpenseForm({
      category: expense.category,
      description: expense.description,
      quantity: expense.quantity || 1,
      unit_price: expense.unit_price || expense.amount || 0,
      amount: expense.amount,
      supplier: expense.supplier || "",
      planned_date: expense.planned_date || format(new Date(), "yyyy-MM-dd"),
      receipt_image: expense.receipt_image,
      expense_type: expense.expense_type || "achat",
      destination: expense.destination || "cuisine"
    });
    setEditingExpense(expense);
    setShowExpenseModal(true);
  };

  // ============== WEEKLY REPORT FUNCTIONS ==============
  
  const fetchWeeklyReport = async () => {
    try {
      const params = { week_start: weekStartDate };
      if (weekEndDate) params.end_date = weekEndDate;
      const res = await axios.get(`${API}/reports/weekly`, { params });
      setWeeklyReport(res.data);
      
      // Check expense ratio for admin alert (> 40%)
      // Backend /reports/weekly already aggregates ALL expenses of the week
      // (pending + approved + completed + revision_requested), respecting assigned_week.
      // We must NOT add client-side filtered expenses on top (it double-counts the current
      // week and mixes expenses from other weeks against this week's CA).
      if (currentUser?.role === 'admin' && res.data) {
        const weeklyCA = res.data.sales?.total || 0;
        const weeklyExpenses = res.data.expenses?.total || 0;
        
        if (weeklyCA > 0) {
          const ratio = (weeklyExpenses / weeklyCA) * 100;
          setExpenseRatioAlert({
            ratio: ratio.toFixed(1),
            expenses: weeklyExpenses,
            ca: weeklyCA,
            isOverLimit: ratio > 40
          });
        } else {
          // No sales yet → clear the alert
          setExpenseRatioAlert(null);
        }
      }
    } catch (error) {
      console.error("Error fetching weekly report:", error);
    }
  };

  // Generate Weekly Report PDF
  const generateWeeklyPDF = () => {
    if (!weeklyReport) return;
    
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    // Build daily rows
    const dailyRows = Object.entries(weeklyReport.daily || {}).map(([date, data]) => {
      const expenseDetails = data.expenses?.items?.map(exp => 
        `<div class="expense-item">${exp.is_group ? '📦 ' : ''}${exp.description}: ${formatPrice(exp.amount)} F (${exp.status === 'completed' ? '✓' : exp.status === 'approved' ? '→' : '?'})</div>`
      ).join('') || '-';
      
      return `<tr>
        <td><strong>${data.day_name}</strong></td>
        <td>${data.date_formatted}</td>
        <td class="text-green">${formatPrice(data.sales?.total || 0)} F</td>
        <td class="text-red">${formatPrice(data.expenses?.total || 0)} F</td>
        <td class="${data.result >= 0 ? 'text-green' : 'text-red'}">${data.result >= 0 ? '+' : ''}${formatPrice(data.result)} F</td>
        <td class="expense-details">${expenseDetails}</td>
      </tr>`;
    }).join('');
    
    // Build category summary
    const categoryRows = Object.entries(weeklyReport.expenses?.by_category || {}).map(([cat, amount]) => 
      `<tr><td class="capitalize">${cat}</td><td class="text-red">${formatPrice(amount)} F</td></tr>`
    ).join('') || '<tr><td colspan="2">Aucune dépense</td></tr>';
    
    const html = `<!DOCTYPE html>
    <html><head>
      <title>Faire le point - ${weeklyReport.week_label}</title>
      <meta charset="UTF-8">
      <style>
        @page { size: A4; margin: 15mm; }
        body { font-family: Arial, sans-serif; font-size: 11px; color: #333; padding: 20px; }
        .header { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #333; padding-bottom: 10px; margin-bottom: 15px; }
        .logo { width: 80px; height: 80px; }
        .logo img { width: 100%; height: 100%; object-fit: contain; }
        .header-center { text-align: center; flex: 1; }
        .header-title { font-size: 14pt; font-weight: bold; text-transform: uppercase; }
        .header-period { font-size: 11pt; color: #555; margin-top: 5px; }
        .header-right { text-align: right; font-size: 9pt; }
        .summary { display: flex; justify-content: space-around; margin: 20px 0; }
        .summary-box { text-align: center; padding: 12px 20px; border: 1px solid #ddd; min-width: 130px; }
        .summary-box h3 { margin: 0 0 5px 0; font-size: 9pt; text-transform: uppercase; color: #666; }
        .summary-box .value { font-size: 16pt; font-weight: bold; }
        .summary-box.green .value { color: #16a34a; }
        .summary-box.red .value { color: #dc2626; }
        table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 9pt; }
        thead tr { border-top: 2px solid #333; border-bottom: 2px solid #333; }
        th { padding: 8px; text-align: left; font-weight: bold; text-transform: uppercase; font-size: 8pt; }
        td { padding: 6px 8px; border-bottom: 1px solid #ddd; }
        .text-green { color: #16a34a; }
        .text-red { color: #dc2626; }
        .capitalize { text-transform: capitalize; }
        .expense-details { font-size: 8pt; max-width: 180px; }
        .expense-item { background: #f5f5f5; padding: 2px 4px; margin: 1px 0; font-size: 8pt; }
        .total-row { border-top: 2px solid #333; }
        .total-row td { font-weight: bold; padding: 10px 8px; }
        .section-title { font-size: 11pt; font-weight: bold; margin: 20px 0 10px; padding-bottom: 5px; border-bottom: 1px solid #ddd; }
        .footer { margin-top: 20px; text-align: center; font-size: 9pt; color: #666; padding-top: 10px; border-top: 1px solid #ddd; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo"><img src="${LOGO_BASE64}" alt="Logo" /></div>
        <div class="header-center">
          <div class="header-title">Faire le point</div>
          <div class="header-period">${weeklyReport.week_label}</div>
        </div>
        <div class="header-right">
          <p>Tél: +229 01 4147 0000</p>
          <p>Fidjrossè, Cotonou</p>
        </div>
      </div>
      
      <div class="summary">
        <div class="summary-box green">
          <h3>Recettes</h3>
          <div class="value">${formatPrice(weeklyReport.sales?.total || 0)} F</div>
          <div>${weeklyReport.sales?.count || 0} ventes</div>
        </div>
        <div class="summary-box red">
          <h3>Dépenses</h3>
          <div class="value">${formatPrice(weeklyReport.expenses?.total || 0)} F</div>
          <div>${weeklyReport.expenses?.count || 0} achats</div>
        </div>
        <div class="summary-box ${weeklyReport.is_profitable ? 'green' : 'red'}">
          <h3>Résultat</h3>
          <div class="value">${weeklyReport.result >= 0 ? '+' : ''}${formatPrice(weeklyReport.result || 0)} F</div>
          <div>${weeklyReport.is_profitable ? 'Bénéfice' : 'Perte'}</div>
        </div>
      </div>
      
      <div class="section-title">Détail Jour par Jour</div>
      <table>
        <thead>
          <tr>
            <th>Jour</th>
            <th>Date</th>
            <th>Recettes</th>
            <th>Dépenses</th>
            <th>Résultat</th>
            <th>Détails Achats</th>
          </tr>
        </thead>
        <tbody>
          ${dailyRows}
          <tr class="total-row">
            <td colspan="2">TOTAL SEMAINE</td>
            <td class="text-green">${formatPrice(weeklyReport.sales?.total || 0)} F</td>
            <td class="text-red">${formatPrice(weeklyReport.expenses?.total || 0)} F</td>
            <td class="${weeklyReport.is_profitable ? 'text-green' : 'text-red'}">${weeklyReport.result >= 0 ? '+' : ''}${formatPrice(weeklyReport.result || 0)} F</td>
            <td></td>
          </tr>
        </tbody>
      </table>
      
      <div class="section-title">Dépenses par Catégorie</div>
      <table style="width: 50%;">
        <thead>
          <tr>
            <th>Catégorie</th>
            <th>Montant</th>
          </tr>
        </thead>
        <tbody>
          ${categoryRows}
        </tbody>
      </table>
      
      <div class="footer">
        <p>Généré le ${new Date().toLocaleString('fr-FR')}</p>
      </div>
      
      <script>window.onload = function() { setTimeout(function() { window.print(); }, 500); }</script>
    </body></html>`;
    
    printWindow.document.write(html);
    printWindow.document.close();
    toast.success("Génération du PDF en cours...");
  };

  // Send Weekly Report via WhatsApp
  const sendWeeklyWhatsApp = () => {
    if (!weeklyReport) return;
    
    // Build message text
    let message = `📊 *POINT HEBDOMADAIRE*\n`;
    message += `📅 ${weeklyReport.week_label}\n\n`;
    
    message += `💰 *RÉSUMÉ*\n`;
    message += `✅ Recettes: ${formatPrice(weeklyReport.sales?.total || 0)} F (${weeklyReport.sales?.count || 0} ventes)\n`;
    message += `❌ Dépenses: ${formatPrice(weeklyReport.expenses?.total || 0)} F (${weeklyReport.expenses?.count || 0} achats)\n`;
    message += `${weeklyReport.is_profitable ? '📈' : '📉'} Résultat: ${weeklyReport.result >= 0 ? '+' : ''}${formatPrice(weeklyReport.result || 0)} F\n\n`;
    
    message += `📅 *DÉTAIL PAR JOUR*\n`;
    Object.entries(weeklyReport.daily || {}).forEach(([date, data]) => {
      message += `${data.day_name} (${data.date_formatted}):\n`;
      message += `  💵 ${formatPrice(data.sales?.total || 0)} F | 🛒 ${formatPrice(data.expenses?.total || 0)} F\n`;
    });
    
    message += `\n_Espace Maxo - Caisse Pro_`;
    
    // Encode for WhatsApp URL
    const encodedMessage = encodeURIComponent(message);
    
    // Admin phone number (you can customize this)
    const adminPhone = "22991005084"; // Replace with actual admin number
    
    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/${adminPhone}?text=${encodedMessage}`, '_blank');
    toast.success("Ouverture de WhatsApp...");
  };

  // ============== ACTIVITY REPORT FUNCTIONS (Admin) ==============
  // NOTE: Activite tab now computes totals from live invoices/expenses state,
  // no separate fetch needed.

  // Fetch expenses when authenticated
  useEffect(() => {
    if (isAuthenticated && (currentUser?.role === 'manager' || currentUser?.role === 'admin')) {
      fetchExpenses();
    }
  }, [isAuthenticated, currentUser]);

  // Fetch weekly report when tab is active
  useEffect(() => {
    if (isAuthenticated && activeTab === "hebdo") {
      fetchWeeklyReport();
    }
  }, [weekStartDate, weekEndDate, activeTab, isAuthenticated]);

  // Check expense ratio when on Achats tab (admin only)
  useEffect(() => {
    if (isAuthenticated && activeTab === "achats" && currentUser?.role === 'admin') {
      fetchWeeklyReport(); // This will also calculate the ratio
    }
  }, [activeTab, isAuthenticated, currentUser, expenses]);

  // Fetch tables status
  const fetchTablesStatus = async () => {
    try {
      const res = await axios.get(`${API}/caisse/tables/status`);
      setTablesStatus(res.data);
    } catch (error) {
      console.error("Error fetching tables status:", error);
    }
  };

  // Stop table service (Manager action)
  const stopTableService = async (tableId, tableNumber, silent = false) => {
    try {
      const res = await axios.post(`${API}/caisse/tables/${tableId}/stop-service`);
      if (res.data.success) {
        const { duration_minutes, quality_status } = res.data.service_record;
        const qualityText = quality_status === 'excellent' ? 'Excellent' : quality_status === 'acceptable' ? 'Acceptable' : 'Lent';
        if (!silent) {
          toast.success(`Table ${tableNumber} libérée ! Durée: ${duration_minutes}min (${qualityText})`);
        }
        fetchTablesStatus();
        fetchOpenTables();
      }
    } catch (error) {
      console.error("Error stopping table service:", error);
      if (!silent) {
        toast.error("Erreur lors de l'arrêt du service");
      }
    }
  };

  // Auto-refresh tables status every 10 seconds when on tables tab
  useEffect(() => {
    if (isAuthenticated && activeTab === "tables") {
      fetchTablesStatus(); // Fetch immediately when tab opens
      const interval = setInterval(fetchTablesStatus, 10000); // Refresh every 10 seconds
      return () => clearInterval(interval);
    }
  }, [activeTab, isAuthenticated]);

  const fetchRapportData = async () => {
    try {
      const [invoicesRes, statsRes] = await Promise.all([
        axios.get(`${API}/invoices`, { params: { date: rapportDate } }),
        axios.get(`${API}/invoices/stats`, { params: { date: rapportDate } })
      ]);
      
      const dayInvoicesRaw = invoicesRes.data.invoices || [];
      // 🆕 Fév 2026 — Bons personnel exclus du rapport journalier (hors CA)
      const dayInvoices = dayInvoicesRaw.filter(i => !i.is_personnel_bon && !i.non_encaisse);
      const validatedInvoices = dayInvoices.filter(i => i.validation_status === 'validated');
      const pendingInvoices = dayInvoices.filter(i => i.validation_status === 'pending');
      
      // Group by server
      const byServer = {};
      dayInvoices.forEach(inv => {
        const server = inv.created_by || 'Non assigné';
        if (!byServer[server]) {
          byServer[server] = { count: 0, total: 0, validated: 0, pending: 0 };
        }
        byServer[server].count++;
        byServer[server].total += inv.total || 0;
        if (inv.validation_status === 'validated') byServer[server].validated++;
        else byServer[server].pending++;
      });
      
      // Group by payment method
      const byPayment = {};
      validatedInvoices.forEach(inv => {
        const method = inv.payment_method || 'cash';
        if (!byPayment[method]) byPayment[method] = { count: 0, total: 0 };
        byPayment[method].count++;
        byPayment[method].total += inv.total || 0;
      });
      
      setRapportData({
        date: rapportDate,
        totalInvoices: dayInvoices.length,
        validatedInvoices: validatedInvoices.length,
        pendingInvoices: pendingInvoices.length,
        totalRevenue: statsRes.data.total_revenue || 0,
        validatedRevenue: validatedInvoices.reduce((sum, inv) => sum + (inv.total || 0), 0),
        byDepartment: statsRes.data.by_department || {},
        byServer,
        byPayment,
        invoices: dayInvoices
      });
    } catch (error) {
      console.error("Error fetching rapport data:", error);
      toast.error("Erreur lors du chargement du rapport");
    }
  };

  // Generate PDF report with signature - Download from backend
  const generateRapportPDF = async () => {
    if (!rapportData) {
      toast.error("Données du rapport non disponibles");
      return;
    }
    
    try {
      const response = await axios.get(`${API}/rapport/pdf`, {
        params: { 
          date: rapportDate,
          signature: signature || ""
        },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `rapport_journalier_${rapportDate}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Rapport PDF téléchargé !");
    } catch (error) {
      console.error("Error generating rapport PDF:", error);
      toast.error("Erreur lors de la génération du PDF");
    }
  };

  // Send rapport summary via WhatsApp to Marcel HOUNHANOU
  const sendRapportWhatsApp = () => {
    if (!rapportData) {
      toast.error("Données du rapport non disponibles");
      return;
    }
    
    const phoneNumber = "2290162396239"; // Marcel HOUNHANOU
    
    // Build summary message
    const deptSummary = Object.entries(rapportData.byDepartment)
      .filter(([_, v]) => v > 0)
      .map(([dept, amount]) => `• ${DEPARTMENT_CONFIG[dept]?.label || dept}: ${formatPrice(amount)} F`)
      .join('\n');
    
    const message = `📊 *RAPPORT JOURNALIER - ESPACE MAXO*
📅 Date: ${rapportData.date}

*RÉSUMÉ:*
• Factures Total: ${rapportData.totalInvoices}
• ✅ Validées: ${rapportData.validatedInvoices}
• ⏳ En attente: ${rapportData.pendingInvoices}
• 💰 CA Validé: ${formatPrice(rapportData.validatedRevenue)} FCFA

*PAR DÉPARTEMENT:*
${deptSummary}

*Signé par:* ${signature || 'Mères AHOUANDJINOU'}
_Responsable Op. & Log - Espace Maxo_

---
📄 Le rapport PDF complet est disponible sur demande.`;

    // Encode message for URL
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    toast.success("WhatsApp ouvert - Envoyez le message à Marcel HOUNHANOU");
  };

  // View server detail - show all invoices for a specific server
  const viewServerDetail = (serverName) => {
    if (!rapportData) return;
    
    const serverInvs = rapportData.invoices.filter(inv => 
      (inv.created_by || 'Non assigné') === serverName
    );
    
    setSelectedServerDetail(serverName);
    setServerInvoices(serverInvs);
  };

  const closeServerDetail = () => {
    setSelectedServerDetail(null);
    setServerInvoices([]);
  };

  // ============== BILL MANAGEMENT ==============
  const addToBill = (item, department) => {
    const existingIndex = currentBill.findIndex(i => i.id === item.id && i.department === department);
    if (existingIndex >= 0) {
      const updated = [...currentBill];
      updated[existingIndex].quantity += 1;
      setCurrentBill(updated);
    } else {
      setCurrentBill([...currentBill, { ...item, department, quantity: 1 }]);
    }
  };

  const updateQuantity = (index, delta) => {
    const updated = [...currentBill];
    updated[index].quantity += delta;
    if (updated[index].quantity <= 0) {
      updated.splice(index, 1);
    }
    setCurrentBill(updated);
  };

  const removeItem = (index) => {
    const updated = [...currentBill];
    updated.splice(index, 1);
    setCurrentBill(updated);
  };

  // 🆕 (Fév 2026) — Applique une remise ligne sur l'item (avec vérif autorisation via /discounts/log)
  // Formats acceptés :
  //   • "10%"    → 10 % de réduction
  //   • "500"    → 500 F de réduction fixe
  //   • "=1000"  → nouveau prix fixe = 1000 F (au lieu du prix d'origine)
  const applyItemDiscount = async (index, item) => {
    // Toggle : si déjà une remise, on propose de la retirer
    if (item.discount) {
      if (window.confirm(`Retirer la remise sur "${item.name}" ?`)) {
        const updated = [...currentBill];
        updated[index] = { ...updated[index], discount: null };
        setCurrentBill(updated);
      }
      return;
    }
    const unit = Number(item.price) || 0;
    const raw = window.prompt(
      `Remise sur "${item.name}" (prix unitaire actuel : ${unit.toLocaleString('fr-FR')} F)\n\n` +
      `Saisir :\n` +
      `  • "10%"      → 10% de réduction\n` +
      `  • "500"      → 500 F de réduction\n` +
      `  • "=1000"    → prix fixe à 1000 F au lieu de ${unit} F`,
      ""
    );
    if (!raw) return;
    const s = String(raw).trim();
    let type = "amount", value = 0, final = 0;
    if (s.startsWith("=")) {
      type = "fixed_price";
      value = parseFloat(s.slice(1));
      final = value;
    } else if (s.endsWith("%")) {
      type = "percent";
      value = parseFloat(s.slice(0, -1));
      final = unit * (1 - value / 100);
    } else {
      type = "amount";
      value = parseFloat(s);
      final = Math.max(0, unit - value);
    }
    if (!Number.isFinite(value) || value < 0) {
      toast.error("Valeur invalide");
      return;
    }
    if (type === "fixed_price" && value >= unit) {
      toast.error(`Le prix fixe (${value} F) doit être inférieur au prix d'origine (${unit} F)`);
      return;
    }
    try {
      await axios.post(`${API}/discounts/log`, {
        applied_by: currentUser?.full_name || currentUser?.username || "User",
        applied_by_role: currentUser?.role || "manager",
        scope: "item",
        order_id: activeTableId || null,
        item_index: index,
        product_id: item.product_id || item.id || null,
        product_name: item.name,
        category_id: item.category_id || item.category || null,
        department: item.department || null,
        discount_type: type,
        discount_value: value,
        original_price: unit,
        final_price: final,
        reason: "",
      });
      const updated = [...currentBill];
      updated[index] = { ...updated[index], discount: { type, value } };
      setCurrentBill(updated);
      toast.success(`Remise appliquée sur ${item.name}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Remise refusée");
    }
  };

  const clearBill = () => {
    setCurrentBill([]);
    setSelectedClient(null);
    setDiscount(0);
    setNotes("");
  };

  // Calcul du prix effectif d'un item (après remise ligne éventuelle)
  const effectiveUnitPrice = (item) => {
    const p = Number(item.price) || 0;
    if (!item.discount) return p;
    if (item.discount.type === "percent") return p * (1 - Number(item.discount.value || 0) / 100);
    if (item.discount.type === "fixed_price") return Math.max(0, Number(item.discount.value || 0));
    return Math.max(0, p - Number(item.discount.value || 0));
  };
  const lineTotal = (item) => effectiveUnitPrice(item) * (item.quantity || 0);

  // Calculate totals
  const subtotal = currentBill.reduce((sum, item) => sum + lineTotal(item), 0);
  const discountAmount = 0; // (Fév 2026) — plus de remise globale ; remises ligne par ligne uniquement
  const total = subtotal;

  const totalByDepartment = {
    salle_jardin: currentBill.filter(i => i.department === "salle_jardin").reduce((sum, i) => sum + lineTotal(i), 0),
    jeux: currentBill.filter(i => i.department === "jeux").reduce((sum, i) => sum + lineTotal(i), 0),
    bar: currentBill.filter(i => i.department === "bar").reduce((sum, i) => sum + lineTotal(i), 0),
    location: currentBill.filter(i => i.department === "location").reduce((sum, i) => sum + lineTotal(i), 0),
    autres: currentBill.filter(i => i.department === "autres").reduce((sum, i) => sum + lineTotal(i), 0)
  };

  // Add custom item to bill (for "Autres" department)
  const addCustomItem = () => {
    if (!customItem.name || customItem.price <= 0) {
      toast.error("Veuillez saisir un nom et un prix valide");
      return;
    }
    const newItem = {
      id: `custom-${Date.now()}`,
      name: customItem.name,
      price: customItem.price,
      unit: "unité",
      department: "autres",
      quantity: 1
    };
    setCurrentBill([...currentBill, newItem]);
    setCustomItem({ name: "", price: 0 });
    toast.success(`${customItem.name} ajouté`);
  };

  // Add free accompaniment (Accompagnement gratuit)
  const [showFreeAccompModal, setShowFreeAccompModal] = useState(false);
  
  const addFreeAccompaniment = (accompName) => {
    const newItem = {
      id: `free_accomp_${Date.now()}`,
      name: `${accompName} (GRATUIT)`,
      price: 0,
      unit: "portion",
      department: "accompagnements",
      quantity: 1,
      isFree: true
    };
    setCurrentBill([...currentBill, newItem]);
    setShowFreeAccompModal(false);
    toast.success(`${accompName} gratuit ajouté`);
  };

  // ============== INVOICE ACTIONS ==============
  // (22/05/2026) — Nouveau flow : "ENVOYER LA COMMANDE" n'imprime PLUS la facture en BDD.
  // Elle se contente d'enregistrer les items dans la table + lancer les bons cuisine/bar/jeux.
  // La FACTURE est créée UNIQUEMENT au clic "Imprimer le bon client".

  // Génère un numéro de bon temporaire pour les impressions de production (cuisine/bar/jeux)
  // tant que la facture n'est pas encore créée en BDD.
  const _tempBonNumber = () => `TMP-${Date.now().toString().slice(-6)}`;

  const _buildInvoiceData = () => ({
    customer_name: selectedClient?.name || "Client",
    customer_phone: selectedClient?.phone || "",
    items: currentBill,
    subtotal,
    discount,
    discount_amount: discountAmount,
    total,
    payment_method: paymentMethod,
    totals_by_department: totalByDepartment,
    notes,
    created_by: currentUser?.full_name || currentUser?.username || "admin",
    // (Bug fix) — un bon enregistré reste EN ATTENTE (pending). Il ne sera transformé
    // en facture validée qu'au clic « Imprimer le bon client » (table)
    // ou « Bon-Client » (vente directe, file Bons).
    validation_status: "pending",
    table_number: activeTable?.table_number || null,
  });

  const saveInvoice = async () => {
    if (currentBill.length === 0) {
      toast.error("Le bon est vide");
      return;
    }

    // Mobile Money payment → flow d'attente paiement (création facture après paiement)
    if (paymentMethod === "mobile") {
      const invoiceData = _buildInvoiceData();
      setPendingInvoiceData(invoiceData);
      setShowMobilePaymentModal(true);
      return;
    }

    // Cas "PAS DE TABLE ACTIVE" → vente directe : on crée la facture tout de suite (legacy)
    if (!activeTableId) {
      await createInvoice(_buildInvoiceData());
      return;
    }

    // Cas "TABLE ACTIVE" → flow : on stocke dans la table + impressions production
    // ET on crée immédiatement un bon (pending) visible dans BONS. La facture
    // sera validée par "Imprimer le bon client".
    try {
      // 1. Créer le bon (facture en pending) — visible dans BONS
      const invoiceData = _buildInvoiceData();
      const invResp = await axios.post(`${API}/invoices?${actorQs()}`, invoiceData);
      const createdInvoice = invResp.data?.invoice || null;
      const tempBon = createdInvoice
        ? { id: createdInvoice.id, invoice_number: createdInvoice.invoice_number, items: currentBill, table_number: activeTable?.table_number }
        : { invoice_number: _tempBonNumber(), items: currentBill, table_number: activeTable?.table_number };

      // 2. Mettre à jour la table : items + ready_to_invoice + lien vers la facture
      await axios.put(`${API}/caisse/tables/${activeTableId}?${actorQs()}`, {
        items: currentBill,
        status: "ready_to_invoice",
        client_name: selectedClient?.name || activeTable?.client_name || "Client",
        last_order_sent_at: new Date().toISOString(),
        pending_invoice_id: createdInvoice?.id || null,
      });

      // 3. Imprimer les bons de production (cuisine / bar / jeux)
      try { printKitchenOrder(tempBon); } catch {}
      try { printBarOrder(tempBon); } catch {}
      try { printGamesOrder(tempBon); } catch {}

      toast.success("✓ Bon créé et commande envoyée en production. Visible dans l'onglet BONS.", {
        duration: 5000,
      });

      // Nettoyer la zone de saisie (la table garde ses items côté agent)
      selectTable(null);
      clearBill();
      setSelectedClient(null);
      setDiscount(0);
      setNotes("");
      setActiveTableId(null);
      setCurrentBill([]);
      await fetchAllData();
      await fetchOpenTables(true);
    } catch (e) {
      console.error("Error sending order to kitchen:", e);
      const detail = e.response?.data?.detail;
      if (e.response?.status === 423 && detail) {
        toast.error(detail, { duration: 6000 });
      } else {
        toast.error(detail || "Erreur lors de l'envoi en production");
      }
    }
  };

  // Imprime le bon client ET crée la facture en BDD (depuis une table "ready_to_invoice")
  const printClientReceiptAndCreateInvoice = async (table) => {
    if (!table || !table.id) return;
    try {
      // Recharger l'état frais de la table (au cas où)
      const tRes = await axios.get(`${API}/caisse/tables/${table.id}`);
      const fresh = tRes.data?.table || table;
      const items = fresh.items || [];
      if (items.length === 0) {
        toast.error("Cette table n'a pas d'articles");
        return;
      }

      let created = null;

      // Si la table possède déjà un bon pending → on le VALIDE (pas de doublon)
      if (fresh.pending_invoice_id) {
        const pendingInv = invoices.find((i) => i.id === fresh.pending_invoice_id);
        if (pendingInv && blockedByProductionBons(pendingInv)) return;
        try {
          const v = await axios.put(`${API}/invoices/${fresh.pending_invoice_id}?${actorQs()}`, {
            validation_status: "validated",
            validated_by: formatValidatorLabel(currentUser),
            validated_at: new Date().toISOString(),
          });
          created = v.data?.invoice || v.data;
        } catch (_vErr) {
          if (_vErr?.response?.status === 409) {
            toast.error(_vErr.response.data?.detail, { duration: 7000 });
            return;
          }
          console.warn("Validate pending invoice failed, fallback to create:", _vErr?.response?.data);
        }
      }

      // Fallback : créer une nouvelle facture (legacy ou si pending introuvable)
      if (!created) {
        const subtotalT = items.reduce((s, i) => s + (i.price || 0) * (i.quantity || 1), 0);
        const totals_by_department = items.reduce((acc, it) => {
          const dep = it.department || "autres";
          acc[dep] = (acc[dep] || 0) + (it.price || 0) * (it.quantity || 1);
          return acc;
        }, {});
        const invoiceData = {
          customer_name: fresh.client_name || "Client",
          customer_phone: "",
          items,
          subtotal: subtotalT,
          discount: 0,
          discount_amount: 0,
          total: subtotalT,
          payment_method: "cash",
          totals_by_department,
          notes: "",
          created_by: currentUser?.full_name || currentUser?.username || "admin",
          validation_status: "validated",
          validated_by: formatValidatorLabel(currentUser),
          validated_at: new Date().toISOString(),
          table_number: fresh.table_number,
        };
        const r = await axios.post(`${API}/invoices?${actorQs()}`, invoiceData);
        created = r.data?.invoice || r.data;
      }

      // Imprimer le ticket client
      try { printTicket(created); } catch {}
      // Marquer la table : invoiced + items vidés
      try {
        await axios.put(`${API}/caisse/tables/${fresh.id}?${actorQs()}`, {
          status: "invoiced",
          items: [],
          invoice_created_at: new Date().toISOString(),
          pending_invoice_id: null,
        });
      } catch {}
      toast.success("Bon client imprimé · Facture créée");
      await fetchAllData();
      await fetchOpenTables(true);
      await fetchTablesStatus();
    } catch (e) {
      console.error("printClientReceiptAndCreateInvoice failed:", e);
      toast.error(e?.response?.data?.detail || "Erreur lors de l'impression du bon client");
    }
  };

  const createInvoice = async (invoiceData) => {
    try {
      const enriched = {
        ...invoiceData,
        id: invoiceData.id || ((typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `inv_${Date.now()}`),
      };
      // Phase 3 — Si nous sommes hors-ligne, on consomme un numéro pré-alloué
      // pour que la facture porte un numéro propre dès l'émission.
      const isOffline = typeof navigator !== "undefined" && !navigator.onLine;
      if (isOffline && !enriched.invoice_number) {
        try {
          const { consumeNumber } = await import("../lib/offlineInvoiceNumbers");
          const preNumber = await consumeNumber(enriched.id);
          if (preNumber) {
            enriched.invoice_number = preNumber;
            enriched._offline_prealloc_number = true;
          } else {
            toast.warning("Pool de numéros pré-alloués vide — facture en attente d'un numéro serveur");
          }
        } catch (_) {
          /* noop */
        }
      }
      const r = await trySync({
        type: "create_invoice",
        payload: enriched,
        user: { name: currentUser?.full_name || currentUser?.username, role: currentUser?.role },
      });
      if (r.queued) {
        toast.warning(
          enriched.invoice_number
            ? `Facture ${enriched.invoice_number} créée hors-ligne — sera synchronisée au retour de la connexion`
            : "Facture créée hors-ligne — sera synchronisée au retour de la connexion",
          { duration: 5000 }
        );
        // Skip side-effects requiring server (client stats, table mutation)
        return;
      }
      const response = { data: r.data };
      
      // Update client stats if selected
      if (selectedClient) {
        try {
          await axios.put(`${API}/caisse/clients/${selectedClient.id}`, {
            total_spent: (selectedClient.total_spent || 0) + invoiceData.total,
            visit_count: (selectedClient.visit_count || 0) + 1
          });
        } catch {}
      }
      
      toast.success("✓ Bon enregistré · en attente de validation par la responsable op. & log", {
        duration: 4000
      });
      
      // Table active : on garde les items sur la table (visibles Cuisine), on lie le bon
      // et on imprime les bons de production — même comportement que "Envoyer la commande".
      if (activeTableId) {
        const createdInv = r.data?.invoice || null;
        const createdId = createdInv?.id || enriched.id;
        try {
          await axios.put(`${API}/caisse/tables/${activeTableId}?${actorQs()}`, {
            items: invoiceData.items || [],
            status: "ready_to_invoice",
            last_order_sent_at: new Date().toISOString(),
            pending_invoice_id: createdId,
          });
        } catch (e) {
          console.log("Could not update table status:", e);
        }
        const prodBon = { id: createdId, invoice_number: createdInv?.invoice_number || enriched.invoice_number || "", items: invoiceData.items || [], table_number: activeTable?.table_number };
        try { printKitchenOrder(prodBon); } catch {}
        try { printBarOrder(prodBon); } catch {}
        try { printGamesOrder(prodBon); } catch {}
        // Clear current selection but keep table in system for tracking
        selectTable(null);
        clearBill();
      } else {
        clearBill();
      }
      
      // Clear other order-related states
      setSelectedClient(null);
      setDiscount(0);
      setNotes("");
      setActiveTableId(null);
      setCurrentBill([]);
      
      // Refresh data immediately to update invoice lists
      await fetchAllData();
      await fetchOpenTables(true); // Skip auto-select after sending order
      setPendingInvoiceData(null);
      
      // For servers, switch to BONS tab to show them their pending invoice
      if (currentUser?.role === 'server') {
        setActiveTab('bons');
      }
      
    } catch (error) {
      console.error("Error saving invoice:", error);
      const detail = error.response?.data?.detail;
      if (error.response?.status === 423 && detail) {
        toast.error(detail, { duration: 6000 });
      } else {
        toast.error(detail || "Erreur lors de l'enregistrement");
      }
    }
  };

  // Kkiapay payment handler
  const handleKkiapayPayment = () => {
    if (!pendingInvoiceData) return;
    
    // Load Kkiapay widget
    if (window.openKkiapayWidget) {
      window.openKkiapayWidget({
        amount: pendingInvoiceData.total,
        position: "center",
        callback: "",
        data: JSON.stringify({ invoice: pendingInvoiceData }),
        theme: "#d4a500",
        key: "4b3fe59844c0f4291c1b285a9485024a1d668c96",
        sandbox: false
      });
      
      // Listen for payment success
      const successHandler = async (event) => {
        const { transactionId } = event.detail;
        pendingInvoiceData.payment_reference = transactionId;
        pendingInvoiceData.payment_status = "paid";
        await createInvoice(pendingInvoiceData);
        setShowMobilePaymentModal(false);
        toast.success("Paiement Kkiapay réussi !");
        window.removeEventListener('successKkiapay', successHandler);
      };
      
      const failHandler = () => {
        toast.error("Paiement échoué");
        window.removeEventListener('failedKkiapay', failHandler);
      };
      
      window.addEventListener('successKkiapay', successHandler);
      window.addEventListener('failedKkiapay', failHandler);
    } else {
      toast.error("Kkiapay non disponible - Veuillez rafraîchir la page");
    }
    setShowMobilePaymentModal(false);
  };

  // Wallet payment handler
  const handleWalletPayment = async () => {
    if (!pendingInvoiceData || !selectedClient) {
      toast.error("Veuillez sélectionner un client avec un porte-monnaie");
      return;
    }
    
    // Check wallet balance
    try {
      const walletRes = await axios.get(`${API}/wallet/${selectedClient.phone}`);
      const walletBalance = walletRes.data.balance || 0;
      
      if (walletBalance < pendingInvoiceData.total) {
        toast.error(`Solde insuffisant (${formatPrice(walletBalance)} F disponible)`);
        return;
      }
      
      // Deduct from wallet
      await axios.post(`${API}/wallet/debit`, {
        phone: selectedClient.phone,
        amount: pendingInvoiceData.total,
        description: `Facture Caisse - ${pendingInvoiceData.items.length} articles`
      });
      
      pendingInvoiceData.payment_method = "wallet";
      pendingInvoiceData.payment_status = "paid";
      await createInvoice(pendingInvoiceData);
      setShowMobilePaymentModal(false);
      toast.success("Paiement par porte-monnaie réussi !");
    } catch (error) {
      console.error("Wallet payment error:", error);
      toast.error("Erreur lors du paiement par porte-monnaie");
    }
  };

  // Pay later (mark as pending payment)
  const handlePayLater = async () => {
    if (!pendingInvoiceData) return;
    pendingInvoiceData.payment_status = "pending";
    await createInvoice(pendingInvoiceData);
    setShowMobilePaymentModal(false);
    toast.info("Bon créé - Paiement en attente");
  };

  // Open payment method modal before validating invoice
  const validateInvoice = (invoiceId) => {
    const invoice = invoices.find(i => i.id === invoiceId);
    if (!invoice) return;
    if (blockedByProductionBons(invoice)) return;
    setPendingValidationInvoice(invoice);
    setSelectedPaymentMethod(invoice.payment_method || "cash");
    // Set invoice date to the original creation date or today
    const originalDate = invoice.created_at ? invoice.created_at.split('T')[0] : new Date().toISOString().split('T')[0];
    setInvoiceDate(originalDate);
    setShowPaymentMethodModal(true);
  };

  // Actually validate the invoice with selected payment method
  const confirmValidateInvoice = async () => {
    if (!pendingValidationInvoice) return;
    
    try {
      // Create the new date with time from original invoice
      const newCreatedAt = invoiceDate + 'T' + (pendingValidationInvoice.created_at?.split('T')[1] || '12:00:00.000Z');
      
      await axios.put(`${API}/invoices/${pendingValidationInvoice.id}?${actorQs()}`, {
        validation_status: "validated",
        validated_by: formatValidatorLabel(currentUser),
        validated_at: new Date().toISOString(),
        payment_method: selectedPaymentMethod,
        created_at: newCreatedAt // Update the invoice date
      });
      
      const dateFormatted = new Date(invoiceDate).toLocaleDateString('fr-FR');
      toast.success(`Bon ${pendingValidationInvoice?.invoice_number || ''} transformé ! Date: ${dateFormatted}, Mode: ${
        selectedPaymentMethod === 'cash' ? 'Espèces' : 
        selectedPaymentMethod === 'mobile' ? 'Mobile Money' : 
        selectedPaymentMethod === 'card' ? 'Carte Bancaire' :
        selectedPaymentMethod === 'kkiapay' ? 'KKiapay' : selectedPaymentMethod
      }`);
      setShowPaymentMethodModal(false);
      setPendingValidationInvoice(null);
      setSelectedPaymentMethod("cash");
      setInvoiceDate(new Date().toISOString().split('T')[0]);
      fetchAllData();
    } catch (error) {
      console.error("Error validating invoice:", error);
      toast.error(error?.response?.data?.detail || "Erreur lors de la transformation en bon", { duration: 7000 });
    }
  };

  // Delete pending invoice (servers can delete their own pending, managers can delete any pending)
  const deleteInvoice = async (invoiceId) => {
    const invoice = invoices.find(i => i.id === invoiceId);
    if (!invoice) return;
    
    // Only admin can delete validated invoices
    if (invoice.validation_status === 'validated' && currentUser?.role !== 'admin') {
      toast.error("Seul l'administrateur peut supprimer une facture validé");
      return;
    }
    
    if (!confirm("Supprimer cette facture ?")) return;
    try {
      await axios.delete(`${API}/invoices/${invoiceId}?${actorQs()}`);
      toast.success("Bon supprimé");
      fetchAllData();
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    }
  };

  // Cancel validated invoice (admin ONLY) - keeps history
  const cancelValidatedInvoice = async (invoiceId) => {
    const invoice = invoices.find(i => i.id === invoiceId);
    if (!invoice) return;
    
    if (currentUser?.role !== 'admin') {
      toast.error("Seul l'administrateur principal peut annuler une facture validé");
      return;
    }
    
    const reason = prompt("Motif d'annulation de la facture :");
    if (!reason) return;
    
    try {
      await axios.put(`${API}/invoices/${invoiceId}?${actorQs()}`, {
        validation_status: "cancelled",
        cancelled_by: currentUser?.full_name || currentUser?.username || "Admin",
        cancelled_at: new Date().toISOString(),
        cancellation_reason: reason
      });
      toast.success("Bon annulé et archivé");
      fetchAllData();
      fetchCancellationRequests();
    } catch (error) {
      toast.error("Erreur lors de l'annulation");
    }
  };

  // Request cancellation (for managers)
  const requestCancellation = async (invoice) => {
    const reason = prompt("Motif de la demande d'annulation :");
    if (!reason) return;
    
    try {
      await axios.post(`${API}/cancellation-requests`, {
        invoice_id: invoice.id,
        invoice_number: invoice.invoice_number,
        reason: reason,
        requested_by: currentUser?.full_name || currentUser?.username || "Manager"
      });
      toast.success("Demande d'annulation envoyée à l'administrateur");
      fetchCancellationRequests();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi de la demande");
    }
  };

  // Fetch cancellation requests (for admin)
  const fetchCancellationRequests = async () => {
    try {
      const response = await axios.get(`${API}/cancellation-requests`);
      const newRequests = response.data.requests || [];
      
      // Notify admin of new cancellation requests
      if (newRequests.length > lastCancellationCount && lastCancellationCount > 0) {
        playNotificationSound();
        toast.info("🔔 Nouvelle demande d'annulation reçue !", {
          duration: 5000,
          style: { background: '#dc2626', color: 'white' }
        });
      }
      setLastCancellationCount(newRequests.length);
      setCancellationRequests(newRequests);
    } catch (error) {
      console.error("Error fetching cancellation requests:", error);
    }
  };

  // Approve cancellation request (admin only)
  const approveCancellationRequest = async (requestId) => {
    if (!confirm("Approuver cette demande d'annulation ?")) return;
    try {
      await axios.put(`${API}/cancellation-requests/${requestId}/approve?approved_by=${encodeURIComponent(currentUser?.full_name || 'Admin')}`);
      toast.success("Demande approuvée - Bon annulé");
      fetchAllData();
      fetchCancellationRequests();
    } catch (error) {
      toast.error("Erreur lors de l'approbation");
    }
  };

  // Reject cancellation request (admin only)
  const rejectCancellationRequest = async (requestId) => {
    if (!confirm("Rejeter cette demande d'annulation ?")) return;
    try {
      await axios.put(`${API}/cancellation-requests/${requestId}/reject?rejected_by=${encodeURIComponent(currentUser?.full_name || 'Admin')}`);
      toast.success("Demande rejetée");
      fetchCancellationRequests();
    } catch (error) {
      toast.error("Erreur lors du rejet");
    }
  };

  // ============== MODIFICATION REQUESTS ==============
  
  // Request modification (for servers)
  const requestModification = async (invoice) => {
    const reason = prompt("Motif de la demande de modification :");
    if (!reason) return;
    
    try {
      await axios.post(`${API}/modification-requests`, {
        invoice_id: invoice.id,
        invoice_number: invoice.invoice_number,
        reason: reason,
        requested_by: currentUser?.full_name || currentUser?.username || "Agent"
      });
      toast.success("Demande de modification envoyée à la responsable op. & log");
      fetchModificationRequests();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi de la demande");
    }
  };

  // Fetch modification requests (for managers)
  const fetchModificationRequests = async () => {
    try {
      const response = await axios.get(`${API}/modification-requests`);
      const newRequests = response.data.requests || [];
      
      // Notify manager of new modification requests
      if (newRequests.length > lastModificationCount && lastModificationCount > 0) {
        playNotificationSound();
        toast.info("🔔 Nouvelle demande de modification reçue !", {
          duration: 5000,
          style: { background: '#2563eb', color: 'white' }
        });
      }
      setLastModificationCount(newRequests.length);
      setModificationRequests(newRequests);
    } catch (error) {
      console.error("Error fetching modification requests:", error);
    }
  };

  // Approve modification request (manager only)
  const approveModificationRequest = async (requestId) => {
    if (!confirm("Autoriser la modification de cette facture ?")) return;
    try {
      await axios.put(`${API}/modification-requests/${requestId}/approve?approved_by=${encodeURIComponent(currentUser?.full_name || 'Manager')}`);
      toast.success("Modification autorisée - Le agent peut maintenant modifier la facture");
      fetchAllData();
      fetchModificationRequests();
    } catch (error) {
      toast.error("Erreur lors de l'approbation");
    }
  };

  // Reject modification request (manager only)
  const rejectModificationRequest = async (requestId) => {
    if (!confirm("Rejeter cette demande de modification ?")) return;
    try {
      await axios.put(`${API}/modification-requests/${requestId}/reject?rejected_by=${encodeURIComponent(currentUser?.full_name || 'Manager')}`);
      toast.success("Demande rejetée");
      fetchModificationRequests();
    } catch (error) {
      toast.error("Erreur lors du rejet");
    }
  };

  // Start editing invoice (for servers with modification_allowed)
  const startEditingInvoice = (invoice) => {
    setEditingInvoice(invoice);
    setEditingItems([...invoice.items]);
    setEditingDepartment("salle_jardin"); // Reset to default department
  };

  // State for editing modal - which department is selected for adding
  const [editingDepartment, setEditingDepartment] = useState("salle_jardin");

  // Add product to editing items
  const addProductToEditing = (product, department) => {
    const existingIndex = editingItems.findIndex(item => 
      item.name === product.name && item.department === department
    );
    
    if (existingIndex >= 0) {
      // Increment quantity if already exists
      const newItems = [...editingItems];
      newItems[existingIndex].quantity += 1;
      setEditingItems(newItems);
    } else {
      // Add new item
      setEditingItems([...editingItems, {
        id: product.id || `custom-${Date.now()}`,
        name: product.name,
        price: product.price,
        quantity: 1,
        department: department,
        unit: product.unit || "unité"
      }]);
    }
    toast.success(`${product.name} ajouté`);
  };

  // Update item quantity in editing mode
  const updateEditingItemQuantity = (index, delta) => {
    const newItems = [...editingItems];
    newItems[index].quantity = Math.max(1, newItems[index].quantity + delta);
    setEditingItems(newItems);
  };

  // Remove item in editing mode
  const removeEditingItem = (index) => {
    if (editingItems.length <= 1) {
      toast.error("Le bon doit contenir au moins un article");
      return;
    }
    const newItems = editingItems.filter((_, i) => i !== index);
    setEditingItems(newItems);
  };

  // Save modified invoice
  const saveModifiedInvoice = async () => {
    if (!editingInvoice) return;
    
    const newTotal = editingItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    
    try {
      await axios.put(`${API}/invoices/${editingInvoice.id}/update-items?${actorQs()}`, {
        items: editingItems,
        total: newTotal
      });
      toast.success("Bon de commande modifié avec succès");
      setEditingInvoice(null);
      setEditingItems([]);
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de la modification");
    }
  };

  // ============== BON DE COMMANDE CUISINE (80mm) ==============

  // 🆕 (Feb 2026) — Vague 2 refactor : les 4 fonctions d'impression tickets
  //     (printKitchenOrder, printBarOrder, printGamesOrder, printTicket)
  //     ont été extraites vers caisse/utils/printHelpers.js
  //     Le call-site les utilise via une closure qui injecte currentUser.
  const printTicket = (invoice) => _printTicket(invoice, currentUser);

  // Trace l'impression/envoi des bons production → débloque le Bon-Client pour la Resp. Op.
  const markBonPrinted = async (invoice, dept) => {
    if (!invoice?.id) return;
    try {
      await axios.post(`${API}/invoices/${invoice.id}/mark-bon-printed?${actorQs()}`, { department: dept });
      fetchAllData();
    } catch (e) {
      console.warn("mark-bon-printed failed:", e?.response?.data);
    }
  };
  const printKitchenOrder = (invoice) => { _printKitchenOrder(invoice); markBonPrinted(invoice, "cuisine"); };
  const printBarOrder = (invoice) => { _printBarOrder(invoice); markBonPrinted(invoice, "bar"); };
  const printGamesOrder = (invoice) => { _printGamesOrder(invoice); markBonPrinted(invoice, "jeux"); };

  // Resp. Op. : Bon-Client interdit tant que les bons production ne sont pas imprimés
  const blockedByProductionBons = (invoice) => {
    if (currentUser?.role !== "manager") return false;
    const missing = missingProductionBons(invoice);
    if (missing.length === 0) return false;
    toast.error(
      `Bon-Client bloqué : imprimez et envoyez d'abord les bons ${missing.map((d) => PRODUCTION_LABELS[d]).join(", ")} (bon ${invoice?.invoice_number || ""}).`,
      { duration: 7000 }
    );
    return true;
  };

  const saveProduct = async () => {
    try {
      const modifierInfo = {
        modified_by: currentUser?.full_name || currentUser?.username || "Utilisateur",
        modified_by_role: currentUser?.role || "unknown"
      };
      
      // Auto-assign department based on category
      const catToDept = {
        "Plats": "salle_jardin", "Entrees": "salle_jardin", "Grillades": "salle_jardin",
        "Sauces": "salle_jardin", "Desserts": "salle_jardin", "Petit-dejeuner": "salle_jardin",
        "Snacks": "salle_jardin", "Accompagnements": "accompagnements",
        "Boissons": "bar", "Cocktails": "bar"
      };
      const formData = { ...productForm, department: catToDept[productForm.category] || productForm.department || "salle_jardin" };
      
      if (editProduct) {
        await axios.put(`${API}/caisse/products/${editProduct.id}`, {
          ...formData,
          ...modifierInfo
        });
        toast.success("Produit modifié");
      } else {
        const r = await axios.post(`${API}/caisse/products?modified_by=${encodeURIComponent(modifierInfo.modified_by)}&modified_by_role=${modifierInfo.modified_by_role}`, formData);
        if (r.data?.pending) {
          toast.warning(
            "Produit créé · en attente d'approbation par l'administrateur",
            { description: "Il sera visible dans la facturation une fois validé.", duration: 5500 }
          );
        } else {
          toast.success("Produit ajouté");
        }
      }
      setShowProductModal(false);
      setEditProduct(null);
      setProductForm({ name: "", price: 0, department: "bar", unit: "unité", category: "" });
      fetchAllData();
      
      // Refresh notifications if admin
      if (currentUser?.role === 'admin') {
        fetchMenuNotifications();
      }
    } catch (error) {
      toast.error("Erreur");
    }
  };

  const deleteProduct = async (productId) => {
    if (!confirm("Supprimer ce produit ?")) return;
    try {
      const modifierInfo = {
        modified_by: currentUser?.full_name || currentUser?.username || "Utilisateur",
        modified_by_role: currentUser?.role || "unknown"
      };
      
      await axios.delete(`${API}/caisse/products/${productId}?modified_by=${encodeURIComponent(modifierInfo.modified_by)}&modified_by_role=${modifierInfo.modified_by_role}`);
      toast.success("Produit supprimé");
      fetchAllData();
      
      // Refresh notifications if admin
      if (currentUser?.role === 'admin') {
        fetchMenuNotifications();
      }
    } catch (error) {
      toast.error("Erreur");
    }
  };

  const saveClient = async () => {
    try {
      if (editClient) {
        await axios.put(`${API}/caisse/clients/${editClient.id}`, clientForm);
        toast.success("Client modifié");
      } else {
        await axios.post(`${API}/caisse/clients`, clientForm);
        toast.success("Client ajouté");
      }
      setShowClientModal(false);
      setEditClient(null);
      setClientForm({ name: "", phone: "", email: "", notes: "" });
      fetchAllData();
    } catch (error) {
      toast.error("Erreur");
    }
  };

  const deleteClient = async (clientId) => {
    if (!confirm("Supprimer ce client ?")) return;
    try {
      await axios.delete(`${API}/caisse/clients/${clientId}`);
      toast.success("Client supprimé");
      fetchAllData();
    } catch (error) {
      toast.error("Erreur");
    }
  };

  const saveUser = async () => {
    try {
      if (!userForm.username) {
        toast.error("Le nom d'utilisateur est requis");
        return;
      }
      if (!editUser && !userForm.pin) {
        toast.error("Le code PIN est requis");
        return;
      }
      if (userForm.pin && (userForm.pin.length < 4 || userForm.pin.length > 6)) {
        toast.error("Le code PIN doit contenir 4 à 6 chiffres");
        return;
      }
      
      if (editUser) {
        await axios.put(`${API}/caisse/users/${editUser.id}`, userForm);
        toast.success("Utilisateur modifié");
      } else {
        await axios.post(`${API}/caisse/users`, userForm);
        toast.success("Utilisateur créé");
      }
      setShowUserModal(false);
      setEditUser(null);
      setUserForm({ username: "", email: "", password: "", pin: "", role: "server", full_name: "" });
      fetchAllData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur");
    }
  };

  const deleteUser = async (userId) => {
    if (!confirm("Supprimer cet utilisateur ?")) return;
    try {
      await axios.delete(`${API}/caisse/users/${userId}`);
      toast.success("Utilisateur supprimé");
      fetchAllData();
    } catch (error) {
      toast.error("Erreur");
    }
  };

  // ============== RENDER LOGIN ==============
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
        <Card className="bg-slate-800/80 border-amber-500/30 w-full max-w-md backdrop-blur-sm shadow-2xl">
          <CardHeader className="text-center pb-2">
            <div className="w-24 h-24 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
              <Receipt className="w-12 h-12 text-white" />
            </div>
            <CardTitle className="text-3xl font-bold text-amber-500">CAISSE PRO</CardTitle>
            <p className="text-xl text-white font-semibold mt-1">Espace Maxo</p>
            <p className="text-slate-400 text-sm">Système de facturation</p>
          </CardHeader>
          <CardContent className="space-y-4 pt-6">
            {/* Toggle between PIN and Admin login */}
            <div className="flex gap-2 mb-4">
              <Button 
                variant={loginMode === "pin" ? "default" : "outline"}
                onClick={() => setLoginMode("pin")}
                className={loginMode === "pin" ? "flex-1 bg-amber-500 hover:bg-amber-600" : "flex-1 border-slate-600 text-slate-400"}
              >
                Agent (PIN)
              </Button>
              <Button 
                variant={loginMode === "admin" ? "default" : "outline"}
                onClick={() => setLoginMode("admin")}
                className={loginMode === "admin" ? "flex-1 bg-amber-500 hover:bg-amber-600" : "flex-1 border-slate-600 text-slate-400"}
              >
                Admin
              </Button>
            </div>

            {loginMode === "pin" ? (
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-slate-300">Code PIN (4-6 chiffres)</Label>
                  <Input
                    type="password"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={6}
                    value={loginForm.pin}
                    onChange={(e) => setLoginForm({ ...loginForm, pin: e.target.value.replace(/\D/g, '') })}
                    onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                    className="bg-slate-700/50 border-slate-600 text-white text-3xl py-8 text-center tracking-[0.5em] font-mono"
                    placeholder="••••••"
                  />
                </div>
                <p className="text-slate-500 text-xs text-center">Entrez votre code PIN personnel</p>
              </div>
            ) : (
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-slate-300">Mot de passe administrateur</Label>
                  <Input
                    type="password"
                    value={loginForm.password}
                    onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                    onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                    className="bg-slate-700/50 border-slate-600 text-white text-lg py-6"
                    placeholder="••••••••"
                  />
                </div>
              </div>
            )}

            <Button onClick={handleLogin} className="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-bold py-6 text-lg shadow-lg">
              Se connecter
            </Button>

            {/* Indicateur de connexion réseau */}
            {!navigator.onLine && (
              <div className="text-center text-amber-300 text-xs bg-amber-500/10 border border-amber-500/30 rounded p-2" data-testid="offline-banner">
                ⚠️ Tu es <strong>hors-ligne</strong>. Si tu t'es déjà connecté(e) sur cet appareil, ton code marchera quand même.
              </div>
            )}
            
            {/* Code oublié */}
            <div className="text-center pt-2 space-y-2">
              <button 
                onClick={() => setShowForgotCodeModal(true)}
                className="text-amber-400 hover:text-amber-300 text-sm underline"
              >
                Code et identifiant oublié ?
              </button>
              <div className="pt-3 border-t border-slate-700">
                <button
                  type="button"
                  onClick={() => setShowGuestModal(true)}
                  className="w-full bg-slate-700/60 hover:bg-slate-600/80 text-amber-300 text-sm font-semibold py-2.5 rounded-lg border border-amber-500/30 transition flex items-center justify-center gap-2"
                  data-testid="guest-access-btn"
                >
                  <KeyRound className="w-4 h-4" /> Accès Invité (code à usage unique)
                </button>
                <p className="text-slate-500 text-[10px] text-center mt-1.5">
                  Demande le code à l'Administrateur — validation en direct.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Modal Connexion Invité */}
        <GuestLoginModal
          open={showGuestModal}
          onOpenChange={setShowGuestModal}
          onApproved={(guestUser) => {
            setShowGuestModal(false);
            setIsAuthenticated(true);
            setCurrentUser(guestUser);
          }}
        />
        
        {/* Modal Code Oublié */}
        <ForgotCodeModal
          open={showForgotCodeModal}
          onOpenChange={setShowForgotCodeModal}
        />
      </div>
    );
  }

  // ============== MAIN RENDER ==============
  // Profile cuisinier → page dédiée
  if (currentUser?.role === "cuisinier") {
    return <CuisinePage currentUser={currentUser} onLogout={handleLogout} />;
  }
  // Profile coach_jeux → page dédiée
  if (currentUser?.role === "coach_jeux") {
    return <CoachJeuxPage currentUser={currentUser} onLogout={handleLogout} />;
  }
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 md:pb-0">
      {/* Sidebar verticale fixe (desktop ≥ md) */}
      {currentUser?.role === "admin" || currentUser?.role === "manager" || currentUser?.role === "server" ? (
        <CaisseVerticalHub
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          currentUser={currentUser}
          badges={{
            bons: effectiveCounts.invoices,
            achats: effectiveCounts.expenses,
            needs: effectiveCounts.needs,
            po: effectiveCounts.purchase_orders,
            stats: effectiveCounts.financial_points,
            tips: effectiveCounts.tips_today,
            reviews: effectiveCounts.reviews_unread,
            notes: effectiveCounts.notes,
          }}
          unreadNotesCount={unreadNotesCount}
          fieldStockPendingCount={fieldStockPendingCount}
          cuisineNeedsPending={cuisineNeedsPending}
          onOpenPalette={() => megaMenuRef.current?.openPalette?.()}
          onCollapseChange={setSidebarCollapsed}
        />
      ) : null}
      {/* Bannière rouge clignotante — Demandes Invité en attente (admin uniquement) */}
      <GuestRequestsBanner currentUser={currentUser} />
      {/* Overlay de verrouillage (z-index 9999, masque tout) — bypass pour invités */}
      {caisseLocked && isAuthenticated && !currentUser?.is_guest && (
        <LockScreen currentUser={currentUser} onUnlock={handleUnlock} />
      )}
      {/* Bottom Navigation mobile — désactivée : remplacée par CaisseTopNav en haut avec belles icônes illustrées */}
      {false && <AdminBottomNav
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        currentUser={currentUser}
        badges={{
          bons: effectiveCounts.invoices,
          stats: effectiveCounts.financial_points,
        }}
        onOpenMenu={() => setMobileMenuOpen(true)}
        onReversement={() => {
          setActiveTab("hebdo");
          setHebdoSubTab("reversement");
        }}
      />}

      {/* Page Hub Navigation mobile — plein écran avec grosses cartes */}
      <MobileMenuHub
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        currentUser={currentUser}
        badges={{
          bons: effectiveCounts.invoices,
          achats: effectiveCounts.expenses,
          needs: effectiveCounts.needs,
          po: effectiveCounts.purchase_orders,
          stats: effectiveCounts.financial_points,
          tips: effectiveCounts.tips_today,
          reviews: effectiveCounts.reviews_unread,
          notes: effectiveCounts.notes,
        }}
        unreadNotesCount={unreadNotesCount}
        fieldStockPendingCount={fieldStockPendingCount}
        cuisineNeedsPending={cuisineNeedsPending}
      />
      {/* Bandeau orange "Wi-Fi faible" — visible uniquement si latence > 1500ms x3 */}
      <WeakConnectionBanner />
      {/* Header */}
      <header className="bg-slate-800/90 border-b border-slate-700 sticky top-0 z-50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2 sm:py-3">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0">
              {/* Bouton Menu Mobile — toujours visible dans le header sticky */}
              <button
                type="button"
                onClick={() => setMobileMenuOpen(true)}
                className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-amber-500/15 hover:bg-amber-500/25 border border-amber-500/40 text-amber-300 flex-shrink-0 transition active:scale-95"
                aria-label="Ouvrir le menu"
                data-testid="header-mobile-menu-btn"
              >
                <Menu className="w-5 h-5" strokeWidth={2.4} />
              </button>
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-amber-500 to-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <Receipt className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              <div className="min-w-0 hidden sm:block">
                <h1 className="text-base sm:text-xl font-bold text-amber-500 truncate">CAISSE PRO</h1>
                <p className="text-slate-400 text-[10px] sm:text-xs truncate hidden xs:block">{format(new Date(), "EEEE d MMMM yyyy", { locale: fr })}</p>
              </div>
              {/* Real-time sync + offline indicator (Phase 1) — masqué sur mobile (≤ sm) pour libérer le header */}
              <div className="hidden sm:flex items-center gap-2 sm:gap-4 min-w-0">
                <OfflineIndicator />
                {/* Phase 3 — pool local de numéros de factures pré-alloués */}
                {(currentUser?.role === "admin" || currentUser?.role === "manager") && (
                  <OfflinePreallocBadge
                    user={{
                      name: currentUser?.full_name || currentUser?.username,
                      role: currentUser?.role,
                    }}
                  />
                )}
              </div>
              {/* Cloche unifiée — notifications du site public www.espacemaxo.com (Admin + Manager Ops) — masquée mobile */}
              {(currentUser?.role === "admin" || currentUser?.role === "manager") && (
                <div className="hidden sm:block">
                  <SiteNotificationsBell
                    actorName={currentUser?.full_name || currentUser?.username || currentUser?.role || "Utilisateur"}
                  />
                </div>
              )}
              {/* Badge si l'utilisateur s'est connecté en mode hors-ligne — caché sur mobile (≤ sm) */}
              {currentUser?._offline && (
                <span
                  className="hidden sm:inline-flex ml-1 items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-500/20 border border-amber-500/40 text-amber-200"
                  title="Tu t'es connecté(e) sans Internet. Les nouvelles données se synchroniseront dès le retour du réseau."
                  data-testid="offline-session-badge"
                >
                  ⚠️ Connecté hors-ligne
                </span>
              )}
              {/* Badge session invité (visible pour tous, surtout l'admin) — caché sur mobile (≤ sm) */}
              {currentUser?.is_guest && (
                <span
                  className="hidden sm:inline-flex ml-1 items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-rose-500/20 border border-rose-500/50 text-rose-200"
                  title="Session Invité — valide jusqu'à révocation ou fin de journée"
                  data-testid="guest-session-badge"
                >
                  <KeyRound className="w-3 h-3" /> INVITÉ
                </span>
              )}
              {/* Plats prêts depuis la cuisine — version compact mobile */}
              {readyNotif.unreadCount > 0 && (
                <button
                  type="button"
                  onClick={readyNotif.clear}
                  className="flex items-center gap-1 px-1.5 sm:px-2 py-1 rounded-md bg-emerald-500/20 border border-emerald-500/40 text-emerald-200 text-[11px] font-bold animate-pulse flex-shrink-0"
                  title="Plats prêts par la cuisine — cliquer pour effacer"
                  data-testid="ready-notif-badge"
                >
                  <Bell className="w-3.5 h-3.5" />
                  <span className="hidden sm:inline">Plats prêts</span>
                  <span className="bg-emerald-500 text-slate-900 text-[9px] px-1 rounded">{readyNotif.unreadCount}</span>
                </button>
              )}
            </div>
            
            <div className="flex items-center gap-1 sm:gap-4">
              {/* Notification Bell for Admin (Menu modifications) — caché sur mobile, dans le menu overflow */}
              {currentUser?.role === 'admin' && (
                <div className="relative hidden md:block">
                  <Button 
                    variant="ghost" 
                    onClick={() => setShowNotificationsPanel(!showNotificationsPanel)}
                    className="text-slate-400 hover:text-white hover:bg-slate-700/50 relative"
                  >
                    <Bell className="w-5 h-5" />
                  </Button>
                  
                  {/* Notifications Panel */}
                  {showNotificationsPanel && (
                    <div className="absolute right-0 top-12 w-80 sm:w-96 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-50 max-h-96 overflow-y-auto">
                      <div className="p-3 border-b border-slate-700 flex items-center justify-between">
                        <h3 className="text-white font-semibold flex items-center gap-2">
                          <Bell className="w-4 h-4" />
                          Modifications du Menu
                        </h3>
                        {unreadNotificationCount > 0 && (
                          <Button 
                            size="sm" 
                            variant="ghost" 
                            onClick={markAllNotificationsRead}
                            className="text-xs text-blue-400 hover:text-blue-300"
                          >
                            Tout marquer lu
                          </Button>
                        )}
                      </div>
                      <div className="p-2">
                        {menuNotifications.length === 0 ? (
                          <p className="text-slate-500 text-center py-4 text-sm">Aucune notification</p>
                        ) : (
                          menuNotifications.slice(0, 20).map(notif => (
                            <div 
                              key={notif.id}
                              onClick={() => markNotificationRead(notif.id)}
                              className={`p-3 rounded-lg mb-2 cursor-pointer transition-colors ${
                                notif.is_read ? 'bg-slate-700/30' : 'bg-blue-900/30 border border-blue-500/30'
                              }`}
                            >
                              <div className="flex items-start gap-2">
                                <div className={`w-2 h-2 rounded-full mt-1.5 ${
                                  notif.action === 'created' ? 'bg-green-400' :
                                  notif.action === 'updated' ? 'bg-blue-400' :
                                  'bg-red-400'
                                }`}></div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-white text-sm font-medium">
                                    {notif.action === 'created' && '➕ Nouveau produit'}
                                    {notif.action === 'updated' && '✏️ Produit modifié'}
                                    {notif.action === 'deleted' && '🗑️ Produit supprimé'}
                                  </p>
                                  <p className="text-slate-300 text-sm truncate">{notif.product_name}</p>
                                  <div className="flex items-center gap-2 mt-1 text-xs text-slate-400">
                                    <span>Par: {notif.modified_by}</span>
                                    {notif.action === 'updated' && notif.old_price !== notif.new_price && (
                                      <span className="text-amber-400">
                                        {formatPrice(notif.old_price)} → {formatPrice(notif.new_price)} F
                                      </span>
                                    )}
                                    {notif.action === 'created' && notif.new_price && (
                                      <span className="text-green-400">{formatPrice(notif.new_price)} F</span>
                                    )}
                                  </div>
                                  <p className="text-slate-500 text-xs mt-1">
                                    {new Date(notif.created_at).toLocaleString('fr-FR', {
                                      day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
                                    })}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Revision Notifications for Manager (Achats à réviser) — désactivé : la Responsable Op. & Log n'a plus accès à Achats (24/05/2026) */}
              {false && currentUser?.role === 'manager' && revisionExpensesCount > 0 && (
                <Button 
                  variant="ghost" 
                  onClick={() => setActiveTab('achats')}
                  className="text-orange-400 hover:text-orange-300 hover:bg-orange-500/20 relative"
                  title="Achats à réviser"
                >
                  <AlertTriangle className="w-5 h-5" />
                  <span className="absolute -top-1 -right-1 bg-orange-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold animate-pulse">
                    {revisionExpensesCount}
                  </span>
                </Button>
              )}

              {/* End of Service Button for Servers */}
              {currentUser?.role === 'server' && (
                <Button 
                  onClick={() => {
                    // Pre-load today's report so the modal shows the summary
                    const serverName = currentUser?.full_name || currentUser?.username;
                    if (serverName) fetchServerDailyReport(serverName, format(new Date(), "yyyy-MM-dd"));
                    setShowEndOfServiceModal(true);
                  }}
                  className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white text-sm"
                  data-testid="terminer-service-btn"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Terminer Service
                </Button>
              )}
              
              <div className="text-right hidden md:block">
                <p className="text-white font-medium flex items-center justify-end gap-2">
                  {currentUser?.full_name || currentUser?.username}
                </p>
                <Badge className={
                  currentUser?.role === 'admin' ? 'bg-amber-500/20 text-amber-400' : 
                  currentUser?.role === 'manager' ? 'bg-blue-500/20 text-blue-400' : 
                  currentUser?.role === 'cuisinier' ? 'bg-green-500/20 text-green-400' :
                  currentUser?.role === 'coach_jeux' ? 'bg-purple-500/20 text-purple-400' :
                  'bg-slate-500/20 text-slate-400'
                }>
                  {currentUser?.role === 'admin' ? 'Administrateur' : 
                   currentUser?.role === 'manager' ? 'Resp. Op.' : 
                   currentUser?.role === 'cuisinier' ? 'Cuisinier' :
                   currentUser?.role === 'coach_jeux' ? 'Coach Jeux' :
                   'Agent'}
                </Badge>
              </div>

              {/* NOTIFICATION CENTER — extracted component */}
              <NotificationBell
                effectiveCounts={effectiveCounts}
                effectiveTotal={effectiveTotal}
                notifLatest={notifLatest}
                showNotifCenter={showNotifCenter}
                setShowNotifCenter={setShowNotifCenter}
                onOpenNotif={openNotifAndNavigate}
                onMarkAllRead={markAllNotifsRead}
              />

              {/* KITCHEN TRACKER — Resp. Op. & Admin only — mobile: uniquement si urgent, sinon dans overflow */}
              {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
                <Button
                  variant="ghost"
                  onClick={() => setShowKitchenTracker(true)}
                  className={`text-amber-300 hover:text-amber-200 hover:bg-amber-500/10 relative ${kitchenUnreadCount > 0 ? "" : "hidden md:inline-flex"}`}
                  title="Suivi Cuisine — Temps réel"
                  data-testid="open-kitchen-tracker-btn"
                >
                  <ChefHat className="w-5 h-5" />
                </Button>
              )}

              {/* JEUX BONS — Resp. Op. & Admin only */}
              {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
                <Button
                  variant="ghost"
                  onClick={() => setShowJeuxBonsModal(true)}
                  className="relative h-9 flex items-center gap-1.5 text-purple-300 hover:text-purple-200 hover:bg-purple-500/10"
                  title="Bons Coach"
                  data-testid="open-jeux-bons-btn"
                >
                  <Gamepad2 className="w-4 h-4" strokeWidth={2.4} />
                  <span className="hidden sm:inline text-[12px] font-bold">Bons Coach</span>
                </Button>
              )}

              {/* 🆕 Petit mot admin sur les bons client (admin uniquement) */}
              <CustomerBonMessageButton
                isAdmin={currentUser?.role === 'admin'}
                adminName={currentUser?.full_name || currentUser?.username || 'Admin'}
                dataTestId="customer-bon-msg-btn"
              />

              {/* Share QR Code Button — caché mobile (accessible via menu/écran de partage dédié) */}
              <div className="hidden sm:block">
                <ShareButton onClick={() => setShowShareModal(true)} />
              </div>

              {/* Toggle ding + browser notifications (admin + manager) — caché mobile */}
              {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
                <Button
                  variant="ghost"
                  onClick={toggleNotifEnabled}
                  title={notifEnabled ? (notifPermission === 'granted' ? "Notifications activées" : "Cliquer pour autoriser les notifications") : "Notifications muettes — cliquer pour réactiver"}
                  className={`hidden sm:inline-flex ${notifEnabled ? "text-amber-300 hover:bg-amber-500/10" : "text-slate-500 hover:bg-slate-700/40"}`}
                  data-testid="notif-toggle-btn"
                >
                  {notifEnabled ? <Bell className="w-5 h-5" /> : <BellOff className="w-5 h-5" />}
                </Button>
              )}

              {/* Verrouiller — caché sur mobile (dans overflow) */}
              <Button
                variant="ghost"
                onClick={() => lockCaisse()}
                className="hidden md:inline-flex text-amber-300 hover:text-amber-200 hover:bg-amber-500/10"
                title="Verrouiller la Caisse (auto après 5 min d'inactivité)"
                data-testid="caisse-lock-btn"
              >
                <Lock className="w-5 h-5" />
              </Button>

              {/* Menu overflow MOBILE — regroupe Notifs admin, Cuisine, Verrouiller pour libérer la barre */}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="ghost"
                    className="md:hidden text-slate-300 hover:text-white hover:bg-slate-700/50 h-9 w-9 p-0 relative"
                    title="Plus d'actions"
                    data-testid="caisse-header-overflow"
                  >
                    <MoreVertical className="w-5 h-5" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-slate-800 border-slate-700 text-white min-w-[220px]">
                  {currentUser?.role === 'admin' && (
                    <DropdownMenuItem
                      onClick={() => setShowNotificationsPanel(true)}
                      className="cursor-pointer focus:bg-slate-700"
                      data-testid="overflow-admin-notif"
                    >
                      <Bell className="w-4 h-4 mr-2 text-slate-300" />
                      <span>Modifications menu</span>
                    </DropdownMenuItem>
                  )}
                  {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && kitchenUnreadCount === 0 && (
                    <DropdownMenuItem
                      onClick={() => setShowKitchenTracker(true)}
                      className="cursor-pointer focus:bg-slate-700"
                      data-testid="overflow-kitchen-tracker"
                    >
                      <ChefHat className="w-4 h-4 mr-2 text-amber-300" />
                      <span>Suivi cuisine</span>
                    </DropdownMenuItem>
                  )}
                  <DropdownMenuItem
                    onClick={() => lockCaisse()}
                    className="cursor-pointer focus:bg-slate-700"
                    data-testid="overflow-lock"
                  >
                    <Lock className="w-4 h-4 mr-2 text-amber-300" />
                    <span>Verrouiller la caisse</span>
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>

              {(currentUser?.role === "admin" || currentUser?.role === "manager") && (
                <Button
                  variant="ghost"
                  onClick={() => setDiscountAuthOpen(true)}
                  className="text-emerald-300 hover:text-emerald-200 hover:bg-emerald-500/10 relative"
                  title="Autorisation Remises"
                  data-testid="header-discount-auth-btn"
                >
                  <Percent className="w-5 h-5" />
                  {discountAuthActive && (
                    <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-emerald-400 ring-2 ring-slate-900 animate-pulse" />
                  )}
                </Button>
              )}

              <Button variant="ghost" onClick={handleLogout} className="text-red-400 hover:text-red-300 hover:bg-red-500/10">
                <LogOut className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* 🆕 (Fév 2026) Modal Autorisation Remises — Admin & Manager */}
      <Dialog open={discountAuthOpen} onOpenChange={setDiscountAuthOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto bg-slate-950 border-slate-700" data-testid="discount-auth-dialog">
          <DialogHeader>
            <DialogTitle className="text-white flex items-center gap-2">
              <Percent className="w-5 h-5 text-emerald-400" /> Autorisation Remises
            </DialogTitle>
            <DialogDescription className="text-slate-400 text-sm">
              {currentUser?.role === "admin"
                ? "Ouvrez une fenêtre d'autorisation pour permettre au Resp. Op. d'appliquer des réductions sur les prix de vente."
                : "État de votre autorisation en cours — demandez à l'administrateur d'ouvrir une fenêtre pour appliquer des réductions."}
            </DialogDescription>
          </DialogHeader>
          <DiscountAuthPanel currentUser={currentUser} />
        </DialogContent>
      </Dialog>

      {/* ===== TOP NAV MOBILE — Modules Caisse illustrés (remplace la bottom nav) ===== */}
      <CaisseTopNav
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        currentUser={currentUser}
        badges={{
          bons: effectiveCounts.invoices,
          stats: effectiveCounts.financial_points,
          po: effectiveCounts.purchase_orders,
        }}
        fieldStockPendingCount={fieldStockPendingCount}
        cuisineNeedsPending={cuisineNeedsPending}
        onOpenMenu={() => setMobileMenuOpen(true)}
        onReversement={() => {
          setActiveTab("hebdo");
          setHebdoSubTab("reversement");
        }}
      />

      {/* Cross-role banner removed — all notifications now consolidated in the Notifications bell menu */}

      <div className="max-w-7xl mx-auto px-4 py-4">
        {/* ==================== CUISINIER VIEW ==================== */}
        {currentUser?.role === 'cuisinier' ? (
          <div className="space-y-4">
            <Card className="bg-gradient-to-br from-green-900/30 to-emerald-900/20 border-green-500/50">
              <CardHeader className="pb-2">
                <CardTitle className="text-green-400 flex items-center gap-2">
                  <Printer className="w-6 h-6" />
                  BONS DE COMMANDE - CUISINE
                  <Badge className="bg-green-500/30 text-green-300 ml-2 text-lg px-3">
                    {invoices.filter(i => i.validation_status === 'pending' && i.items?.some(item => item.department === 'salle_jardin')).length}
                  </Badge>
                </CardTitle>
                <p className="text-slate-400 text-sm">Commandes contenant des plats à préparer</p>
              </CardHeader>
              <CardContent className="space-y-2">
                {invoices.filter(i => i.validation_status === 'pending' && i.items?.some(item => item.department === 'salle_jardin')).length === 0 ? (
                  <p className="text-slate-500 text-center py-8">Aucune commande cuisine en attente</p>
                ) : (
                  invoices.filter(i => i.validation_status === 'pending' && i.items?.some(item => item.department === 'salle_jardin')).map(invoice => {
                    const kitchenItems = invoice.items?.filter(item => item.department === 'salle_jardin') || [];
                    const totalKitchenItems = kitchenItems.reduce((sum, item) => sum + item.quantity, 0);
                    return (
                      <div key={invoice.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-green-900/20 rounded-lg p-4 border border-green-500/30">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="text-white font-bold text-lg">{invoice.invoice_number}</span>
                            {invoice.table_number && (
                              <Badge className="bg-amber-500/30 text-amber-300 text-lg px-3">Table {invoice.table_number}</Badge>
                            )}
                            <Badge className="bg-green-500/20 text-green-400">{totalKitchenItems} plat{totalKitchenItems > 1 ? 's' : ''}</Badge>
                          </div>
                          <div className="mt-2 space-y-1">
                            {kitchenItems.map((item, idx) => (
                              <div key={idx} className="flex items-center gap-2 text-white">
                                <span className="bg-green-600 text-white px-2 py-0.5 rounded font-bold text-sm">{item.quantity}x</span>
                                <span>{item.name}</span>
                              </div>
                            ))}
                          </div>
                          <p className="text-slate-400 text-sm mt-2">
                            Agent: {invoice.created_by} • {new Date(invoice.created_at).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                          </p>
                        </div>
                        <Button 
                          onClick={() => printKitchenOrder(invoice)}
                          className="bg-green-600 hover:bg-green-700 text-white"
                        >
                          <Printer className="w-4 h-4 mr-2" />
                          Imprimer
                        </Button>
                      </div>
                    );
                  })
                )}
              </CardContent>
            </Card>
          </div>
        ) : currentUser?.role === 'coach_jeux' ? (
          /* ==================== COACH JEUX VIEW ==================== */
          <div className="space-y-4">
            <Card className="bg-gradient-to-br from-purple-900/30 to-blue-900/20 border-purple-500/50">
              <CardHeader className="pb-2">
                <CardTitle className="text-purple-400 flex items-center gap-2">
                  <Gamepad2 className="w-6 h-6" />
                  BONS DE COMMANDE - JEUX
                  <Badge className="bg-purple-500/30 text-purple-300 ml-2 text-lg px-3">
                    {invoices.filter(i => i.validation_status === 'pending' && i.items?.some(item => item.department === 'jeux')).length}
                  </Badge>
                </CardTitle>
                <p className="text-slate-400 text-sm">Sessions de jeux à préparer</p>
              </CardHeader>
              <CardContent className="space-y-2">
                {invoices.filter(i => i.validation_status === 'pending' && i.items?.some(item => item.department === 'jeux')).length === 0 ? (
                  <p className="text-slate-500 text-center py-8">Aucune session de jeu en attente</p>
                ) : (
                  invoices.filter(i => i.validation_status === 'pending' && i.items?.some(item => item.department === 'jeux')).map(invoice => {
                    const gamesItems = invoice.items?.filter(item => item.department === 'jeux') || [];
                    const totalGamesItems = gamesItems.reduce((sum, item) => sum + item.quantity, 0);
                    return (
                      <div key={invoice.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-purple-900/20 rounded-lg p-4 border border-purple-500/30">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="text-white font-bold text-lg">{invoice.invoice_number}</span>
                            {invoice.table_number && (
                              <Badge className="bg-amber-500/30 text-amber-300 text-lg px-3">Table {invoice.table_number}</Badge>
                            )}
                            <Badge className="bg-purple-500/20 text-purple-400">{totalGamesItems} session{totalGamesItems > 1 ? 's' : ''}</Badge>
                          </div>
                          <div className="mt-2 space-y-1">
                            {gamesItems.map((item, idx) => (
                              <div key={idx} className="flex items-center gap-2 text-white">
                                <span className="bg-purple-600 text-white px-2 py-0.5 rounded font-bold text-sm">{item.quantity}x</span>
                                <span>{item.name}</span>
                              </div>
                            ))}
                          </div>
                          <p className="text-slate-400 text-sm mt-2">
                            Agent: {invoice.created_by} • {new Date(invoice.created_at).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                          </p>
                        </div>
                        <Button 
                          onClick={() => printGamesOrder(invoice)}
                          className="bg-purple-600 hover:bg-purple-700 text-white"
                        >
                          <Printer className="w-4 h-4 mr-2" />
                          Imprimer
                        </Button>
                      </div>
                    );
                  })
                )}
              </CardContent>
            </Card>
          </div>
        ) : (
        /* ==================== NORMAL TABS VIEW ==================== */
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          {/* Welcome banner Resp. Op. (Responsable Op. & Log) — affiché en haut de toutes les pages (24/05/2026) */}
          {currentUser?.role === 'manager' && (
            <RespOpWelcome
              currentUser={currentUser}
              tables={openTables}
              invoices={invoices}
              effectiveCounts={effectiveCounts}
              isJourneeOpen={dayOpening?.status === 'open'}
              onGoTo={(tab) => setActiveTab(tab)}
            />
          )}
          {/* Closure lock banner (admin only) — affiché si la journée du filtre est clôturée */}
          {currentUser?.role === 'admin' && (
            <ClosureLockBanner
              date={filterDate || undefined}
              onOpenPointCaisse={() => setActiveTab('point_caisse')}
            />
          )}
          {/* ===== ADMIN MEGA MENU (refonte 2026 — 6 familles + command palette) ===== */}
          <AdminMegaMenu
            ref={megaMenuRef}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            currentUser={currentUser}
            badges={{
              bons: effectiveCounts.invoices,
              achats: effectiveCounts.expenses,
              needs: effectiveCounts.needs,
              po: effectiveCounts.purchase_orders,
              stats: effectiveCounts.financial_points,
              tips: effectiveCounts.tips_today,
              reviews: effectiveCounts.reviews_unread,
              notes: effectiveCounts.notes,
            }}
            unreadNotesCount={unreadNotesCount}
            fieldStockPendingCount={fieldStockPendingCount}
            cuisineNeedsPending={cuisineNeedsPending}
          />

          {/* ==================== COMMANDE TAB (Creation only) ==================== */}

          {/* ==================== BONS DE COMMANDE TAB ==================== */}
          <TabsContent value="bons">
            <BonsTab
              currentUser={currentUser}
              invoices={invoices}
              products={products}
              cancellationRequests={cancellationRequests}
              modificationRequests={modificationRequests}
              filterDate={filterDate}
              setFilterDate={setFilterDate}
              approveCancellationRequest={approveCancellationRequest}
              rejectCancellationRequest={rejectCancellationRequest}
              approveModificationRequest={approveModificationRequest}
              rejectModificationRequest={rejectModificationRequest}
              printKitchenOrder={printKitchenOrder}
              printBarOrder={printBarOrder}
              printGamesOrder={printGamesOrder}
              setViewInvoice={setViewInvoice}
              startEditingInvoice={startEditingInvoice}
              requestModification={requestModification}
              requestCancellation={requestCancellation}
              validateInvoice={validateInvoice}
              deleteInvoice={deleteInvoice}
            />
          </TabsContent>

          {/* ==================== INVOICES TAB ==================== */}
          {/* ==================== FACTURES TAB (fusionné avec Commande) ==================== */}

          <TabsContent value="commande">
            <CommandeTab ctx={{
              currentUser,
              cancellationRequests, modificationRequests,
              activeTable, activeTableId,
              tableCoachPlayers, fetchTableCoachPlayers, transmitCoachPlayersOnTable,
              activeDepartment, setActiveDepartment,
              currentBill,
              customItem, setCustomItem,
              discount, setDiscount,
              notes, setNotes,
              paymentMethod, setPaymentMethod,
              productSearch, setProductSearch,
              selectedClient, setSelectedClient,
              expenses, expenseAnalyses,
              availableTableNumbers,
              catalog, openTables, clients,
              formatPrice,
              approveCancellationRequest, rejectCancellationRequest,
              approveModificationRequest, rejectModificationRequest,
              printTicket, cancelValidatedInvoice, requestCancellation,
              selectTable, addToBill, addCustomItem, clearBill,
              saveInvoice, updateQuantity, removeItem, applyItemDiscount,
              setShowNewTableModal, setShowFreeAccompModal, setViewInvoice,
              // Additional props needed for CommandeTab
              invoices,
              total,
              subtotal,
              discountAmount,
              totalByDepartment,
              DEPARTMENT_CONFIG,
              PAYMENT_METHODS,
              closeTable,
            }} />
          </TabsContent>

          <TabsContent value="invoices">
            <div className="space-y-4">
              {/* Régularisation rétroactive (Admin + Resp. Op.) */}
              {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
                <div className="flex items-center justify-end">
                  <Button
                    onClick={() => {
                      setRegularizationMode("create");
                      setRegularizationTargetInvoice(null);
                      setShowRegularizationModal(true);
                    }}
                    className="bg-amber-600 hover:bg-amber-700 text-white text-xs sm:text-sm"
                    data-testid="open-regularization-create"
                  >
                    <CalendarClock className="w-4 h-4 mr-1" />
                    Régulariser un bon (date passée)
                  </Button>
                </div>
              )}
              {/* Admin: EN ATTENTE section removed — notifications now consolidated in the top-right Notifications bell */}

              {/* Filter bar */}
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4 flex-wrap">
                  {/* Date picker — Admin only (la Responsable Op. & Log ne voit que les factures du jour) */}
                  {currentUser?.role === 'admin' && (
                    <div className="flex items-center gap-2">
                      <Calendar className="w-5 h-5 text-slate-400" />
                      <Input
                        type="date"
                        value={filterDate}
                        onChange={(e) => setFilterDate(e.target.value)}
                        className="bg-slate-800/50 border-slate-700 text-white w-auto"
                      />
                    </div>
                  )}
                  {currentUser?.role !== 'admin' && (
                    <div className="flex items-center gap-2">
                      <Calendar className="w-5 h-5 text-slate-400" />
                      <Badge className="bg-slate-700 text-slate-300">Aujourd'hui</Badge>
                    </div>
                  )}
                  <Select value={filterValidation} onValueChange={setFilterValidation}>
                    <SelectTrigger className="bg-slate-800/50 border-slate-700 text-white w-40">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-slate-800 border-slate-700">
                      <SelectItem value="all" className="text-white">Toutes</SelectItem>
                      <SelectItem value="validated" className="text-green-400">Validees</SelectItem>
                      <SelectItem value="cancelled" className="text-red-400">Annulees</SelectItem>
                    </SelectContent>
                  </Select>
                  <Badge className="bg-blue-500/20 text-blue-400">
                    {invoices.filter(i => i.validation_status !== 'pending' && (filterValidation === 'all' || i.validation_status === filterValidation)).length} facture(s)
                  </Badge>
                  {stats && (
                    <Badge className="bg-amber-500/20 text-amber-400">
                      CA: {formatPrice(stats.total_revenue)} F
                    </Badge>
                  )}
                </div>
                {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
                  <Button onClick={() => { setEditingInvoice(null); setActiveTab('bons'); }} className="bg-blue-600 hover:bg-blue-700" data-testid="new-invoice-btn">
                    <Plus className="w-4 h-4 mr-2" />Nouvelle Facture
                  </Button>
                )}
              </div>

              {invoices.filter(i => i.validation_status !== 'pending' && (filterValidation === 'all' || i.validation_status === filterValidation)).length === 0 ? (
                <Card className="bg-slate-800/50 border-slate-700">
                  <CardContent className="py-12 text-center">
                    <FileText className="w-12 h-12 text-slate-600 mx-auto mb-4" />
                    <p className="text-slate-400">Aucune facture pour cette date</p>
                  </CardContent>
                </Card>
              ) : (
                <div className="grid gap-3">
                  {invoices.filter(i => i.validation_status !== 'pending' && (filterValidation === 'all' || i.validation_status === filterValidation)).map((invoice) => (
                    <Card key={invoice.id} className={`bg-slate-800/50 ${invoice.validation_status === 'validated' ? 'border-green-500/30' : invoice.validation_status === 'cancelled' ? 'border-red-500/30' : 'border-yellow-500/30'}`}>
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <div className="flex items-center gap-3 mb-1 flex-wrap">
                              <span className="font-bold text-white">{invoice.invoice_number}</span>
                              <Badge className="bg-amber-500/20 text-amber-400">{formatPrice(invoice.total)} F</Badge>
                              <Badge className={invoice.payment_method === 'cash' ? 'bg-green-500/20 text-green-400' : invoice.payment_method === 'card' ? 'bg-blue-500/20 text-blue-400' : invoice.payment_method === 'mobile' ? 'bg-purple-500/20 text-purple-400' : invoice.payment_method === 'kkiapay' ? 'bg-pink-500/20 text-pink-400' : 'bg-slate-500/20 text-slate-400'}>
                                {PAYMENT_METHODS.find(p => p.value === invoice.payment_method)?.label}
                              </Badge>
                              {invoice.validation_status === 'validated' ? (
                                <Badge className="bg-green-500/20 text-green-400">✓ Validée</Badge>
                              ) : invoice.validation_status === 'cancelled' ? (
                                <Badge className="bg-red-500/20 text-red-400">✗ Annulée</Badge>
                              ) : (
                                <Badge className="bg-yellow-500/20 text-yellow-400">⏳ En attente</Badge>
                              )}
                              {invoice.is_regularized && (
                                <Badge
                                  className="bg-amber-500/30 text-amber-300 border border-amber-500/50"
                                  data-testid={`regul-badge-${invoice.id}`}
                                  title={`Régularisée — ${invoice.regularization_target_date || ''}\nMotif: ${invoice.regularization_reason || ''}`}
                                >
                                  <CalendarClock className="w-3 h-3 mr-1 inline" />
                                  Régularisée
                                </Badge>
                              )}
                            </div>
                            <p className="text-slate-400 text-sm">
                              {invoice.customer_name} • {format(new Date(invoice.created_at), "HH:mm")}
                              {invoice.created_by && ` • Agent: ${invoice.created_by}`}
                            </p>
                            {invoice.validated_by && (
                              <p className="text-green-400 text-xs mt-1">
                                Validé par: {invoice.validated_by}
                              </p>
                            )}
                            {invoice.modified_at && (
                              <div className="mt-1.5 inline-flex items-center gap-1.5 px-2 py-0.5 rounded bg-amber-500/15 border border-amber-500/30 text-amber-300 text-[10.5px] font-black uppercase tracking-wider" data-testid={`facture-modified-badge-${invoice.id}`} title={`Modifié le ${new Date(invoice.modified_at).toLocaleString('fr-FR')}`}>
                                <Edit2 className="w-2.5 h-2.5" strokeWidth={3} />
                                MODIFIÉ · {new Date(invoice.modified_at).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })}
                                {invoice.modified_by ? ` par ${invoice.modified_by}` : ""}
                              </div>
                            )}
                            {invoice.validation_status === 'cancelled' && (
                              <div className="mt-2 p-2 bg-red-900/30 rounded border border-red-500/30">
                                <p className="text-red-400 text-xs">
                                  <strong>Annulée par:</strong> {invoice.cancelled_by} le {invoice.cancelled_at ? format(new Date(invoice.cancelled_at), "dd/MM/yyyy HH:mm") : 'N/A'}
                                </p>
                                <p className="text-red-300 text-xs mt-1">
                                  <strong>Motif:</strong> {invoice.cancellation_reason || 'Non spécifié'}
                                </p>
                              </div>
                            )}
                            <div className="flex gap-2 mt-2 flex-wrap">
                              {invoice.totals_by_department?.salle_jardin > 0 && (
                                <Badge className="bg-green-500/20 text-green-400 text-xs">Salle&Jardin: {formatPrice(invoice.totals_by_department.salle_jardin)}</Badge>
                              )}
                              {invoice.totals_by_department?.jeux > 0 && (
                                <Badge className="bg-blue-500/20 text-blue-400 text-xs">Jeux: {formatPrice(invoice.totals_by_department.jeux)}</Badge>
                              )}
                              {invoice.totals_by_department?.bar > 0 && (
                                <Badge className="bg-orange-500/20 text-orange-400 text-xs">Bar: {formatPrice(invoice.totals_by_department.bar)}</Badge>
                              )}
                              {invoice.totals_by_department?.location > 0 && (
                                <Badge className="bg-purple-500/20 text-purple-400 text-xs">Location: {formatPrice(invoice.totals_by_department.location)}</Badge>
                              )}
                              {invoice.totals_by_department?.autres > 0 && (
                                <Badge className="bg-slate-500/20 text-slate-400 text-xs">Autres: {formatPrice(invoice.totals_by_department.autres)}</Badge>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <Button variant="ghost" size="sm" onClick={() => setViewInvoice(invoice)} className="text-slate-400 hover:text-white">
                              <Eye className="w-4 h-4" />
                            </Button>
                            {/* Print button - Manager/Admin only */}
                            {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
                              <Button variant="ghost" size="sm" onClick={() => printTicket(invoice)} className="text-slate-400 hover:text-white" title="Imprimer ticket">
                                <Printer className="w-4 h-4" />
                              </Button>
                            )}
                            {invoice.validation_status !== 'validated' && currentUser?.role === 'admin' && (
                              <Button variant="ghost" size="sm" onClick={() => validateInvoice(invoice.id)} className="text-green-400 hover:text-green-300" title="Valider">
                                <CheckCircle className="w-4 h-4" />
                              </Button>
                            )}
                            {currentUser?.role === 'admin' && (
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => {
                                  setRegularizationMode("update-date");
                                  setRegularizationTargetInvoice(invoice);
                                  setShowRegularizationModal(true);
                                }}
                                className="text-amber-300 hover:text-amber-200"
                                title="Modifier la date du bon (régularisation)"
                                data-testid={`open-regul-update-${invoice.id}`}
                              >
                                <CalendarClock className="w-4 h-4" />
                              </Button>
                            )}
                            {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => startEditingInvoice(invoice)}
                                className="text-amber-400 hover:text-amber-300"
                                title={invoice.modified_at ? `Modifié le ${new Date(invoice.modified_at).toLocaleString('fr-FR')} par ${invoice.modified_by || 'Admin'}` : "Modifier la facture (signalement automatique)"}
                                data-testid={`facture-edit-${invoice.id}`}
                              >
                                <Edit2 className="w-4 h-4" />
                              </Button>
                            )}
                            {currentUser?.role === 'admin' && (
                              <Button variant="ghost" size="sm" onClick={() => deleteInvoice(invoice.id)} className="text-red-400 hover:text-red-300">
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            )}
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </div>
          </TabsContent>

          {/* ==================== STATS TAB ==================== */}
          <TabsContent value="stats">
            <StatsTab
              filterMonth={filterMonth}
              setFilterMonth={setFilterMonth}
              monthlyStats={monthlyStats}
              rapportDate={rapportDate}
              setRapportDate={setRapportDate}
              rapportData={rapportData}
              fetchRapportData={fetchRapportData}
              signature={signature}
              setSignature={setSignature}
              generateRapportPDF={generateRapportPDF}
              sendRapportWhatsApp={sendRapportWhatsApp}
              viewServerDetail={viewServerDetail}
              currentUser={currentUser}
            />
          </TabsContent>

          {/* ==================== PRODUCTS TAB ==================== */}
          <TabsContent value="products">
            <ProductsTab
              catalog={catalog}
              departmentConfig={DEPARTMENT_CONFIG}
              canManage={currentUser?.role === 'manager' || currentUser?.role === 'admin'}
              isAdmin={currentUser?.role === 'admin'}
              currentUserName={currentUser?.full_name || currentUser?.username || ""}
              onAddProduct={() => {
                setEditProduct(null);
                setProductForm({ name: "", price: 0, department: "bar", unit: "unité", category: "" });
                setShowProductModal(true);
              }}
              onEditProduct={(product, dept) => {
                setEditProduct(product);
                setProductForm({ ...product, department: dept });
                setShowProductModal(true);
              }}
              onDeleteProduct={deleteProduct}
              onProductsRefresh={refreshCatalog}
              onLinkStock={(product) => {
                setLinkStockTarget(product);
                setShowLinkStockModal(true);
              }}
              onMultiLinkStock={() => setShowMultiLinkModal(true)}
            />
          </TabsContent>

          {/* ==================== CLIENTS TAB ==================== */}
          <TabsContent value="clients">
            <ClientsTab
              clients={clients}
              onAddClient={() => {
                setEditClient(null);
                setClientForm({ name: "", phone: "", email: "", notes: "" });
                setShowClientModal(true);
              }}
              onEditClient={(client) => {
                setEditClient(client);
                setClientForm(client);
                setShowClientModal(true);
              }}
              onDeleteClient={deleteClient}
            />
          </TabsContent>

          {/* ==================== USERS TAB ==================== */}
          {currentUser?.role === 'admin' && (
            <TabsContent value="users">
              <UsersTab
                users={users}
                currentUser={currentUser}
                onAddUser={() => {
                  setEditUser(null);
                  setUserForm({ username: "", email: "", password: "", pin: "", role: "server", full_name: "" });
                  setShowUserModal(true);
                }}
                onEditUser={(user) => {
                  setEditUser(user);
                  setUserForm({ ...user, password: "", pin: user.pin || "" });
                  setShowUserModal(true);
                }}
                onDeleteUser={deleteUser}
              />
            </TabsContent>
          )}

          {/* ==================== CODES INVITÉ TAB (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
            <TabsContent value="guest-codes">
              <GuestCodesManagerPanel />
            </TabsContent>
          )}

          {/* ==================== SALAIRES TAB (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
            <TabsContent value="salaries">
              <SalariesTab currentUser={currentUser} />
            </TabsContent>
          )}

          {/* ==================== VALID DEMANDS TAB (Manager + Admin) ==================== */}
          {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
            <TabsContent value="valid_demands">
              <ValidDemandsTab currentUser={currentUser} />
            </TabsContent>
          )}

          {/* ==================== AUDIT LOGS TAB (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
            <TabsContent value="audit">
              <AuditLogsTab currentUser={currentUser} />
            </TabsContent>
          )}

          {/* ==================== HISTORIQUE TAB ==================== */}

          {/* ==================== POINTS DES SERVEURS TAB (MANAGER ONLY) ==================== */}
          {currentUser?.role === 'manager' && (
          <TabsContent value="points_agents">
            <div className="space-y-4">
              {/* Header */}
              <div className="flex items-center justify-between flex-wrap gap-4">
                <h2 className="text-xl font-bold text-indigo-300 flex items-center gap-2">
                  <ClipboardList className="w-6 h-6" />
                  Points des Agents
                  {selectedReports.length > 0 && (
                    <Badge className="bg-red-500/20 text-red-400 ml-2">
                      {selectedReports.length} sélectionné{selectedReports.length > 1 ? 's' : ''}
                    </Badge>
                  )}
                </h2>
                <div className="flex items-center gap-3 flex-wrap">
                  {/* Select All / Deselect All */}
                  {serviceReports.length > 0 && (
                    <Button 
                      size="sm" 
                      variant="outline" 
                      onClick={toggleSelectAllReports}
                      className="border-slate-500/50 text-slate-400 hover:bg-slate-500/20"
                    >
                      {selectedReports.length === serviceReports.length ? 'Tout désélectionner' : 'Tout sélectionner'}
                    </Button>
                  )}
                  {/* Bulk Delete Button */}
                  {selectedReports.length > 0 && (
                    <Button 
                      size="sm" 
                      variant="outline" 
                      onClick={() => setShowBulkDeleteConfirm(true)}
                      className="border-red-500/50 text-red-400 hover:bg-red-500/20"
                    >
                      <Trash2 className="w-4 h-4 mr-1" />
                      Supprimer ({selectedReports.length})
                    </Button>
                  )}
                  {unreadServiceReportsCount > 0 && (
                    <Button 
                      size="sm" 
                      variant="outline" 
                      onClick={markAllServiceReportsRead}
                      className="border-blue-500/50 text-blue-400 hover:bg-blue-500/20"
                    >
                      Tout marquer lu ({unreadServiceReportsCount})
                    </Button>
                  )}
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={fetchServiceReports}
                    className="border-indigo-500/50 text-indigo-400 hover:bg-indigo-500/20"
                  >
                    <RefreshCw className="w-4 h-4 mr-1" />
                    Actualiser
                  </Button>
                </div>
              </div>

              {/* Bulk Delete Confirmation */}
              {showBulkDeleteConfirm && (
                <Card className="bg-red-900/20 border-red-500/50">
                  <CardContent className="p-4">
                    <div className="flex items-center gap-3 mb-3">
                      <AlertTriangle className="w-5 h-5 text-red-400" />
                      <span className="text-red-300 font-medium">
                        Supprimer {selectedReports.length} point{selectedReports.length > 1 ? 's' : ''} ?
                      </span>
                    </div>
                    <div className="flex gap-2 items-center">
                      <Input
                        type="password"
                        value={bulkDeleteCode}
                        onChange={(e) => setBulkDeleteCode(e.target.value)}
                        placeholder="Code de suppression (4 chiffres)"
                        className="bg-slate-800 border-slate-600 text-white flex-1 max-w-xs"
                        maxLength={4}
                      />
                      <Button 
                        onClick={handleBulkDeleteReports}
                        className="bg-red-600 hover:bg-red-700"
                      >
                        Confirmer
                      </Button>
                      <Button 
                        onClick={() => { setShowBulkDeleteConfirm(false); setBulkDeleteCode(""); }}
                        variant="outline"
                        className="border-slate-500"
                      >
                        Annuler
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Service Reports Grid */}
              {serviceReports.length === 0 ? (
                <Card className="bg-slate-800/50 border-slate-700">
                  <CardContent className="py-12 text-center">
                    <ClipboardList className="w-12 h-12 text-slate-600 mx-auto mb-4" />
                    <p className="text-slate-400">Aucun point de agent reçu</p>
                  </CardContent>
                </Card>
              ) : (
                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                  {serviceReports.map(report => (
                    <Card 
                      key={report.id}
                      className={`transition-all hover:scale-[1.02] ${
                        selectedReports.includes(report.id)
                          ? 'bg-red-900/20 border-red-500/50'
                          : report.is_read 
                            ? 'bg-slate-800/50 border-slate-700 hover:border-slate-600' 
                            : 'bg-indigo-900/30 border-indigo-500/50 hover:border-indigo-400'
                      }`}
                    >
                      <CardContent className="p-4">
                        {/* Selection Checkbox + Header */}
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-2">
                            {/* Checkbox */}
                            <div 
                              onClick={(e) => { e.stopPropagation(); toggleReportSelection(report.id); }}
                              className={`w-5 h-5 rounded border-2 cursor-pointer flex items-center justify-center transition-all ${
                                selectedReports.includes(report.id)
                                  ? 'bg-red-500 border-red-500'
                                  : 'border-slate-500 hover:border-slate-400'
                              }`}
                            >
                              {selectedReports.includes(report.id) && (
                                <CheckCircle className="w-4 h-4 text-white" />
                              )}
                            </div>
                            {!report.is_read && (
                              <div className="w-2 h-2 rounded-full bg-indigo-400 animate-pulse"></div>
                            )}
                            <p className="text-white font-semibold flex items-center gap-2">
                              <User className="w-4 h-4 text-indigo-400" />
                              {report.server_name}
                            </p>
                          </div>
                          <Badge className={`text-xs ${
                            report.status === 'validated' ? 'bg-green-500/20 text-green-400' :
                            report.status === 'rejected' ? 'bg-red-500/20 text-red-400' :
                            report.status === 'revision_requested' ? 'bg-orange-500/20 text-orange-400' :
                            'bg-slate-500/20 text-slate-400'
                          }`}>
                            {report.status === 'validated' ? 'Validé' :
                             report.status === 'rejected' ? 'Rejeté' :
                             report.status === 'revision_requested' ? 'À réviser' :
                             'En attente'}
                          </Badge>
                        </div>
                        
                        {/* Clickable content area */}
                        <div 
                          onClick={() => openServerReportDetail(report)}
                          className="cursor-pointer"
                        >
                          <div className="grid grid-cols-3 gap-2 mb-3">
                            <div className="bg-slate-700/50 rounded p-2 text-center">
                              <p className="text-indigo-400 font-bold text-lg">{report.total_invoices}</p>
                              <p className="text-slate-500 text-xs">Commandes</p>
                            </div>
                            <div className="bg-slate-700/50 rounded p-2 text-center">
                              <p className="text-green-400 font-bold text-lg">{report.validated_invoices}</p>
                              <p className="text-slate-500 text-xs">Validées</p>
                            </div>
                            <div className="bg-slate-700/50 rounded p-2 text-center">
                              <p className="text-amber-400 font-bold text-lg">{formatPrice(report.total_sales)}</p>
                              <p className="text-slate-500 text-xs">CA (F)</p>
                            </div>
                          </div>

                          {report.observation && (
                            <div className="p-2 bg-slate-700/30 rounded text-xs mb-2">
                              <p className="text-slate-400 font-medium mb-1">Observation:</p>
                              <p className="text-slate-300 italic line-clamp-2">"{report.observation}"</p>
                            </div>
                          )}
                          
                          <div className="flex items-center justify-between text-xs text-slate-500">
                            <span className="flex items-center gap-1">
                              <Calendar className="w-3 h-3" />
                              {new Date(report.created_at).toLocaleString('fr-FR', {
                                day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
                              })}
                            </span>
                            <span className="text-indigo-400 flex items-center gap-1">
                              <Eye className="w-3 h-3" />
                              Voir détails
                            </span>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
            </div>
          </TabsContent>
          )}

          {/* ==================== SERVER DAILY REPORT TAB ==================== */}
          {currentUser?.role === 'server' && (
          <TabsContent value="mon_point">
            <div className="space-y-4">
              {/* Header with date selector */}
              <div className="flex items-center justify-between flex-wrap gap-4">
                <h2 className="text-xl font-bold text-indigo-300 flex items-center gap-2">
                  <ClipboardList className="w-6 h-6" />
                  Mon Point Journalier
                </h2>
                <div className="flex items-center gap-3">
                  <Input
                    type="date"
                    value={serverReportDate}
                    onChange={(e) => setServerReportDate(e.target.value)}
                    className="bg-slate-800/50 border-slate-700 text-white w-auto"
                  />
                  <Button 
                    onClick={() => fetchServerDailyReport(currentUser?.full_name || currentUser?.username, serverReportDate)}
                    className="bg-indigo-600 hover:bg-indigo-700"
                  >
                    <RefreshCw className="w-4 h-4 mr-2" />
                    Actualiser
                  </Button>
                </div>
              </div>

              {serverDailyReport ? (
                <>
                  {/* Summary Cards */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <Card className="bg-gradient-to-br from-indigo-900/30 to-purple-900/20 border-indigo-500/50">
                      <CardContent className="p-4 text-center">
                        <Receipt className="w-8 h-8 text-indigo-400 mx-auto mb-2" />
                        <p className="text-3xl font-bold text-indigo-400">{serverDailyReport.total_invoices}</p>
                        <p className="text-slate-400 text-sm">Commandes créées</p>
                      </CardContent>
                    </Card>
                    <Card className="bg-gradient-to-br from-green-900/30 to-emerald-900/20 border-green-500/50">
                      <CardContent className="p-4 text-center">
                        <CheckCircle className="w-8 h-8 text-green-400 mx-auto mb-2" />
                        <p className="text-3xl font-bold text-green-400">{serverDailyReport.validated_count}</p>
                        <p className="text-slate-400 text-sm">Factures validées</p>
                      </CardContent>
                    </Card>
                    <Card className="bg-gradient-to-br from-amber-900/30 to-orange-900/20 border-amber-500/50">
                      <CardContent className="p-4 text-center">
                        <Clock className="w-8 h-8 text-amber-400 mx-auto mb-2" />
                        <p className="text-3xl font-bold text-amber-400">{serverDailyReport.pending_count}</p>
                        <p className="text-slate-400 text-sm">En attente</p>
                      </CardContent>
                    </Card>
                    <Card className="bg-gradient-to-br from-emerald-900/30 to-teal-900/20 border-emerald-500/50">
                      <CardContent className="p-4 text-center">
                        <DollarSign className="w-8 h-8 text-emerald-400 mx-auto mb-2" />
                        <p className="text-3xl font-bold text-emerald-400">{formatPrice(serverDailyReport.total_sales)} F</p>
                        <p className="text-slate-400 text-sm">Total validé</p>
                      </CardContent>
                    </Card>
                  </div>

                  {/* Breakdown by Department */}
                  {serverDailyReport.department_breakdown && Object.keys(serverDailyReport.department_breakdown).length > 0 && (
                    <Card className="bg-slate-800/50 border-slate-700">
                      <CardHeader className="pb-2">
                        <CardTitle className="text-slate-300 flex items-center gap-2">
                          <BarChart3 className="w-5 h-5" />
                          Répartition par Département
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                          {Object.entries(serverDailyReport.department_breakdown).map(([dept, data]) => {
                            const deptConfig = DEPARTMENT_CONFIG[dept];
                            return (
                              <div key={dept} className={`p-3 rounded-lg ${deptConfig?.bgColor || 'bg-slate-700/30'} border ${deptConfig?.borderColor || 'border-slate-600'}`}>
                                <p className={`font-medium ${deptConfig?.color || 'text-slate-300'}`}>{deptConfig?.label || dept}</p>
                                <p className="text-white text-lg font-bold">{formatPrice(data.total)} F</p>
                                <p className="text-slate-400 text-xs">{data.count} article(s)</p>
                              </div>
                            );
                          })}
                        </div>
                      </CardContent>
                    </Card>
                  )}

                  {/* Breakdown by Payment Method */}
                  {serverDailyReport.payment_methods && Object.keys(serverDailyReport.payment_methods).length > 0 && (
                    <Card className="bg-slate-800/50 border-slate-700">
                      <CardHeader className="pb-2">
                        <CardTitle className="text-slate-300 flex items-center gap-2">
                          <Wallet className="w-5 h-5" />
                          Modes de Paiement
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                          {Object.entries(serverDailyReport.payment_methods).map(([method, data]) => (
                            <div key={method} className="p-3 rounded-lg bg-slate-700/30 border border-slate-600">
                              <p className="text-slate-300 font-medium capitalize">
                                {method === 'cash' ? '💵 Espèces' : 
                                 method === 'card' ? '💳 Carte' : 
                                 method === 'mobile_money' ? '📱 Mobile Money' : 
                                 method === 'mobile' ? '📱 Mobile Money' :
                                 method === 'kkiapay' ? '🅺 KKiapay' :
                                 method === 'cheque' ? '📝 Chèque' : method}
                              </p>
                              <p className="text-white text-lg font-bold">{formatPrice(data.total)} F</p>
                              <p className="text-slate-400 text-xs">{data.count} transaction(s)</p>
                            </div>
                          ))}
                        </div>
                      </CardContent>
                    </Card>
                  )}

                  {/* Invoice List */}
                  <Card className="bg-slate-800/50 border-slate-700">
                    <CardHeader className="pb-2">
                      <CardTitle className="text-slate-300 flex items-center gap-2">
                        <FileText className="w-5 h-5" />
                        Mes Factures du Jour
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      {serverDailyReport.invoices?.length === 0 ? (
                        <p className="text-slate-500 text-center py-8">Aucune facture pour cette date</p>
                      ) : (
                        <div className="space-y-2">
                          {serverDailyReport.invoices?.map((invoice) => (
                            <div key={invoice.id} className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg">
                              <div className="flex items-center gap-3">
                                <span className="text-white font-medium">{invoice.invoice_number}</span>
                                <Badge className={
                                  invoice.validation_status === 'validated' ? 'bg-green-500/20 text-green-400' :
                                  invoice.validation_status === 'pending' ? 'bg-amber-500/20 text-amber-400' :
                                  'bg-slate-500/20 text-slate-400'
                                }>
                                  {invoice.validation_status === 'validated' ? '✓ Validée' : 
                                   invoice.validation_status === 'pending' ? '⏳ En attente' : invoice.validation_status}
                                </Badge>
                                {invoice.table_number && (
                                  <Badge className="bg-slate-600/50 text-slate-300">Table {invoice.table_number}</Badge>
                                )}
                              </div>
                              <div className="flex items-center gap-3">
                                <span className="text-amber-400 font-bold">{formatPrice(invoice.total)} F</span>
                                <span className="text-slate-500 text-sm">
                                  {new Date(invoice.created_at).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </CardContent>
                  </Card>
                </>
              ) : (
                <Card className="bg-slate-800/30 border-slate-700">
                  <CardContent className="py-12 text-center">
                    <ClipboardList className="w-12 h-12 text-slate-600 mx-auto mb-4" />
                    <p className="text-slate-500">Chargement de votre point journalier...</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </TabsContent>
          )}

          {/* ==================== TABLES TAB (Manager/Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="tables">
            <TablesTab 
              tablesStatus={tablesStatus}
              fetchTablesStatus={fetchTablesStatus}
              stopTableService={stopTableService}
              formatPrice={formatPrice}
              openTables={openTables}
              kitchenStatusByTable={kitchenStatusByTable}
              currentUser={currentUser}
              onPrintClientReceipt={printClientReceiptAndCreateInvoice}
              onTakeOrder={(tableNumber) => {
                // Navigate to commande tab
                setActiveTab("commande");
                // If a specific table number is provided, we could select it
                // For now, just switch to the commande tab
              }}
            />
          </TabsContent>
          )}

          {/* ==================== ACHATS/DÉPENSES TAB (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
          <TabsContent value="achats">
            <AchatsTab ctx={{
              currentUser,
              expenses,
              shoppingList,
              achatsSubView, setAchatsSubView,
              showAllExpenses, setShowAllExpenses,
              expenseRatioAlert,
              expenseAnalyses,
              formatPrice,
              setShowExpenseModal,
              setShowShoppingListModal,
              setExpenseToAssign,
              setShowWeekAssignModal,
              printExpensesTicket,
              printAllExpensesList,
              printAllApprovedExpenses,
              printApprovedExpensesDetailed,
              printCompletedExpensesTicket,
              printAllCompletedExpenses,
              printSingleExpenseTicket,
              printExpensePDF,
              openExpenseForEdit,
              deleteExpense,
              updateExpense,
              openReviseModal,
              convertExpenseToPO,
              availableAccounts,
              allocateExpenseToAccount,
              fetchExpenses,
              receiveExpenseStock,
            }} />
          </TabsContent>
          )}

          {/* ==================== POINT HEBDOMADAIRE TAB ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="hebdo">
            <Tabs value={hebdoSubTab} onValueChange={setHebdoSubTab} className="w-full">
              <TabsList className="bg-slate-800/50 border border-slate-700 mb-4 flex-wrap h-auto p-1 gap-1">
                <TabsTrigger
                  value="reversement"
                  className="data-[state=active]:bg-amber-600 data-[state=active]:text-white px-3 py-2 text-sm font-medium gap-2"
                  data-testid="tab-reversement"
                >
                  <Coins className="w-4 h-4" />
                  <span>Reversement</span>
                  <span className="hidden sm:inline text-[10px] opacity-70 ml-1">· Billettage + clôture</span>
                </TabsTrigger>
                {currentUser?.role === 'admin' && (
                  <TabsTrigger
                    value="point-history"
                    className="data-[state=active]:bg-slate-600 data-[state=active]:text-white px-3 py-2 text-sm font-medium gap-2"
                    data-testid="tab-point-history"
                  >
                    <History className="w-4 h-4" />
                    <span>Historique</span>
                    <span className="hidden sm:inline text-[10px] opacity-70 ml-1">· Archives</span>
                  </TabsTrigger>
                )}
              </TabsList>

              {/* Sous-menu unique "Reversement" — billettage global + formulaire unifié + récap Momo journalier */}
              <TabsContent value="reversement">
                <div className="space-y-4">
                  {/* Billettage GLOBAL — inchangé */}
                  <div className="flex items-center justify-end gap-2 mb-1">
                    <Label className="text-xs text-slate-400">Date du billettage&nbsp;:</Label>
                    {currentUser?.role === 'admin' ? (
                      <Input
                        type="date"
                        value={billettageDate}
                        onChange={(e) => setBillettageDate(e.target.value)}
                        className="bg-slate-800 border-slate-700 text-white h-8 w-[160px]"
                        data-testid="billettage-date-picker"
                      />
                    ) : (
                      <Badge className="bg-slate-700 text-slate-300 h-8 px-3 flex items-center">Aujourd'hui</Badge>
                    )}
                  </div>
                  <BillettageGlobalCard date={billettageDate} currentUser={currentUser} />

                  {/* Formulaire de reversement unique (catégorie "bar" utilisée par défaut côté DB pour conserver la compat) */}
                  <PointFinancierTab
                    currentUser={currentUser}
                    fixedCategory="bar"
                    onGotoHebdo={() => {}}
                    hideBillettage={true}
                  />

                  {/* Récap Momo journalier (Admin uniquement) */}
                  {currentUser?.role === 'admin' && (
                    <MomoDailyRecap currentUser={currentUser} />
                  )}
                </div>
              </TabsContent>

              {currentUser?.role === 'admin' && (
              <TabsContent value="point-history">
                <PointsHistoryTab currentUser={currentUser} />
              </TabsContent>
              )}
            </Tabs>
          </TabsContent>
          )}

          {/* ==================== LOCATIONS TAB (Manager/Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="locations">
            <LocationsTab 
              currentUser={currentUser}
              formatPrice={formatPrice}
            />
          </TabsContent>
          )}

          {/* ==================== PLANNING HEBDO TAB (Manager/Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="planning">
            <WeeklyScheduleTab currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== PROFORMA TAB (Manager/Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="proforma">
            <ProformaTab 
              currentUser={currentUser}
              formatPrice={formatPrice}
              catalog={catalog}
            />
          </TabsContent>
          )}

          {/* ==================== INSTRUCTIONS TAB (Manager/Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="instructions">
            <InstructionsTab 
              currentUser={currentUser}
              formatPrice={formatPrice}
              onNotesRead={() => setUnreadNotesCount(0)}
            />
          </TabsContent>
          )}

          {/* ==================== ABONNEMENTS TAB (Manager & Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="subscriptions">
            <SubscriptionsTab currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== ACTIVITE & HISTORIQUE TAB ==================== */}
          <TabsContent value="activite">
            <ActiviteTab
              invoices={invoices}
              expenses={expenses}
              historyInvoices={historyInvoices}
              historyDate={historyDate}
              setHistoryDate={setHistoryDate}
            />
          </TabsContent>

          {/* ==================== POINT DE LA CAISSE TAB (Admin + Responsable Op. & Log) — remplace Analytics ==================== */}
          {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
          <TabsContent value="point_caisse">
            <PointCaisseTab currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== JOURNÉE TAB (Ouverture / Fermeture / Historique) ==================== */}
          {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
          <TabsContent value="journee">
            <JourneeTab currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== APPRO MANAGER TAB (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
          <TabsContent value="courses">
            <CoursesTab currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== PREVISIONS TAB (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
          <TabsContent value="forecasts">
            <JournalTab />
          </TabsContent>
          )}

          {/* ==================== LISTE DE BESOINS (Manager & Admin) ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="needs">
            <NeedsTab currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== POINT DE STOCK TERRAIN — Resp. Op. + Admin ==================== */}
          {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
          <TabsContent value="field_stock">
            <FieldStockReportModal inline currentUser={currentUser} />
          </TabsContent>
          )}

          {/* ==================== COMPTE COURANT (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
          <TabsContent value="current-accounts">
            <CurrentAccountsTab />
          </TabsContent>
          )}

          {/* ==================== POURBOIRES (Admin + Manager + Server) ==================== */}
          <TabsContent value="tips">
            <TipsTab currentUser={currentUser} />
          </TabsContent>

          {/* ==================== NOTIFICATIONS (Admin + Manager) ==================== */}
          {(currentUser?.role === 'admin' || currentUser?.role === 'manager') && (
            <TabsContent value="notifications">
              <NotificationsTab
                effectiveCounts={effectiveCounts}
                effectiveTotal={effectiveTotal}
                notifLatest={notifLatest}
                onOpenNotif={openNotifAndNavigate}
                onMarkAllRead={markAllNotifsRead}
              />
            </TabsContent>
          )}

          {/* ==================== AVIS CLIENTS (Admin only) ==================== */}
          {currentUser?.role === 'admin' && (
            <TabsContent value="customer-reviews">
              <CustomerReviewsTab currentUser={currentUser} />
            </TabsContent>
          )}
          {currentUser?.role === 'admin' && (
            <TabsContent value="site-notifications">
              <SiteNotificationsPanel
                actorName={currentUser?.full_name || currentUser?.username || "Admin"}
              />
            </TabsContent>
          )}
        </Tabs>
        )}
      </div>

      {/* ==================== MODALS ==================== */}

      {/* Payment Method Selection Modal for Bon-Client validation */}
      <PaymentMethodModal
        open={showPaymentMethodModal}
        onOpenChange={(open) => {
          if (!open) {
            setShowPaymentMethodModal(false);
            setPendingValidationInvoice(null);
          }
        }}
        pendingValidationInvoice={pendingValidationInvoice}
        invoiceDate={invoiceDate}
        setInvoiceDate={setInvoiceDate}
        selectedPaymentMethod={selectedPaymentMethod}
        setSelectedPaymentMethod={setSelectedPaymentMethod}
        onCancel={() => {
          setShowPaymentMethodModal(false);
          setPendingValidationInvoice(null);
        }}
        onConfirm={confirmValidateInvoice}
        formatPrice={formatPrice}
      />
      
      {/* View Invoice Modal */}
      <ViewInvoiceModal
        invoice={viewInvoice}
        onClose={() => setViewInvoice(null)}
        currentUser={currentUser}
        formatPrice={formatPrice}
        onPrint={printTicket}
        onDownloadPDF={downloadPDF}
        onValidate={validateInvoice}
      />

      {/* Product Modal */}
      <ProductModal
        open={showProductModal}
        onOpenChange={setShowProductModal}
        API={API}
        currentUser={currentUser}
        editProduct={editProduct}
        productLabels={productLabels}
        productForm={productForm}
        setProductForm={setProductForm}
        stockSuggestions={stockSuggestions}
        setStockSuggestions={setStockSuggestions}
        onOpenLabelsEditor={openLabelsEditor}
        onSave={saveProduct}
      />

      {/* Modal d'édition des libellés du modal "Ajouter un produit" (Admin uniquement) */}
      <LabelsEditorModal
        open={showLabelsEditor}
        onOpenChange={setShowLabelsEditor}
        productLabels={productLabels}
        labelsForm={labelsForm}
        setLabelsForm={setLabelsForm}
        savingLabels={savingLabels}
        onSave={saveLabels}
        onReset={resetLabels}
      />

      {/* Link Stock Modal */}
      <LinkStockModal
        open={showLinkStockModal}
        onClose={() => { setShowLinkStockModal(false); setLinkStockTarget(null); }}
        caisseProduct={linkStockTarget}
        onLinked={async () => {
          try {
            const res = await axios.get(`${API}/caisse/products`);
            const grouped = { bar: [], jardin: [], jeux: [] };
            (res.data || []).forEach(p => { if (grouped[p.department]) grouped[p.department].push(p); });
            setCatalog(grouped);
          } catch (e) { /* silent */ }
        }}
      />

      {/* Multi-Link Stock Modal (lier plusieurs produits caisse au même produit stock) */}
      <MultiLinkStockModal
        open={showMultiLinkModal}
        onClose={() => setShowMultiLinkModal(false)}
        caisseProducts={Object.values(catalog || {}).flat().filter(Boolean)}
        onDone={async () => {
          try {
            const res = await axios.get(`${API}/caisse/products`);
            const grouped = { bar: [], jardin: [], jeux: [] };
            (res.data || []).forEach(p => { if (grouped[p.department]) grouped[p.department].push(p); });
            setCatalog(grouped);
          } catch (e) { /* silent */ }
        }}
      />

      {/* Client Modal */}
      <ClientModal
        open={showClientModal}
        onOpenChange={setShowClientModal}
        editClient={editClient}
        clientForm={clientForm}
        setClientForm={setClientForm}
        onSave={saveClient}
      />

      {/* User Modal */}
      <UserModal
        open={showUserModal}
        onOpenChange={setShowUserModal}
        editUser={editUser}
        userForm={userForm}
        setUserForm={setUserForm}
        onSave={saveUser}
      />

      {/* Mobile Payment Options Modal */}
      <MobilePaymentModal
        open={showMobilePaymentModal}
        onOpenChange={setShowMobilePaymentModal}
        pendingInvoiceData={pendingInvoiceData}
        selectedClient={selectedClient}
        formatPrice={formatPrice}
        onKkiapay={handleKkiapayPayment}
        onWallet={handleWalletPayment}
        onPayLater={handlePayLater}
      />

      {/* New Table Modal */}
      <NewTableModal
        open={showNewTableModal}
        onOpenChange={setShowNewTableModal}
        availableTableNumbers={availableTableNumbers}
        onCreate={createNewTable}
      />

      {/* Invoice Edit Modal */}
      <EditingInvoiceModal
        editingInvoice={editingInvoice}
        onClose={() => setEditingInvoice(null)}
        DEPARTMENT_CONFIG={DEPARTMENT_CONFIG}
        editingDepartment={editingDepartment}
        setEditingDepartment={setEditingDepartment}
        catalog={catalog}
        editingItems={editingItems}
        customItem={customItem}
        setCustomItem={setCustomItem}
        currentUser={currentUser}
        formatPrice={formatPrice}
        onAddProduct={addProductToEditing}
        onUpdateQty={updateEditingItemQuantity}
        onRemoveItem={removeEditingItem}
        onSave={saveModifiedInvoice}
      />

      {/* Expense Modal */}
      <ExpenseModal
        open={showExpenseModal}
        onOpenChange={setShowExpenseModal}
        editingExpense={editingExpense}
        expenseForm={expenseForm}
        setExpenseForm={setExpenseForm}
        commonItems={commonItems}
        setCommonItems={setCommonItems}
        commonNewItem={commonNewItem}
        setCommonNewItem={setCommonNewItem}
        availableAccounts={availableAccounts}
        expenseSubmitLoading={expenseSubmitLoading}
        EXPENSE_TYPES={EXPENSE_TYPES}
        DESTINATIONS={DESTINATIONS}
        PREDEFINED_PAYMENTS={PREDEFINED_PAYMENTS}
        PAYMENT_GROUPS={PAYMENT_GROUPS}
        formatPrice={formatPrice}
        getCommonTotal={getCommonTotal}
        addCommonItem={addCommonItem}
        removeCommonItem={removeCommonItem}
        createExpense={createExpense}
        updateExpense={updateExpense}
        onClose={() => setEditingExpense(null)}
      />

      {/* Shopping List Modal */}
      <ShoppingListModal
        open={showShoppingListModal}
        onOpenChange={setShowShoppingListModal}
        shoppingList={shoppingList}
        setShoppingList={setShoppingList}
        shoppingListSupplier={shoppingListSupplier}
        setShoppingListSupplier={setShoppingListSupplier}
        shoppingListDate={shoppingListDate}
        setShoppingListDate={setShoppingListDate}
        newListItem={newListItem}
        setNewListItem={setNewListItem}
        formatPrice={formatPrice}
        getShoppingListTotal={getShoppingListTotal}
        addToShoppingList={addToShoppingList}
        removeFromShoppingList={removeFromShoppingList}
        submitShoppingList={submitShoppingList}
      />

      {/* ===== Admin Revise Modal (modify items + supplier before resending to manager) ===== */}
      <Dialog open={showReviseModal} onOpenChange={(open) => { if (!open) { setShowReviseModal(false); setRevisingExpense(null); } }}>
        <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-amber-300 flex items-center gap-2">
              <Edit2 className="w-5 h-5" />
              Modifier avant renvoi — {revisingExpense?.description || ""}
            </DialogTitle>
            <DialogDescription className="text-slate-400 text-xs">
              Ajustez les articles, quantités, prix et le fournisseur. La responsable op. & log pourra revoir et resoumettre.
            </DialogDescription>
          </DialogHeader>
          {revisingExpense && (
            <div className="space-y-4">
              <div>
                <Label className="text-slate-300 text-sm">Fournisseur</Label>
                <Input value={reviseSupplier} onChange={(e) => setReviseSupplier(e.target.value)}
                  placeholder="Nom du fournisseur"
                  className="bg-slate-700/50 border-slate-600 text-white"
                  data-testid="revise-supplier-input" />
              </div>

              {/* Existing items editable inline */}
              <Card className="bg-slate-700/30 border-slate-600">
                <CardHeader className="pb-2">
                  <CardTitle className="text-slate-300 text-sm">Articles ({reviseItems.length})</CardTitle>
                </CardHeader>
                <CardContent className="space-y-2 max-h-[260px] overflow-y-auto">
                  {reviseItems.map((it, idx) => (
                    <div key={it._k} className="flex items-center gap-2 bg-slate-600/30 rounded p-2 flex-wrap">
                      <span className="text-slate-400 text-xs font-mono w-5">{idx + 1}.</span>
                      <Select value={it.category} onValueChange={(v) => updateReviseItem(it._k, { category: v })}>
                        <SelectTrigger className="w-[110px] bg-slate-700/50 border-slate-600 text-white h-8 text-xs"><SelectValue /></SelectTrigger>
                        <SelectContent className="bg-slate-800 border-slate-700">
                          <SelectItem value="cuisine">🍳 Cuisine</SelectItem>
                          <SelectItem value="bar">🍹 Bar</SelectItem>
                          <SelectItem value="paiement">💳 Paiement</SelectItem>
                          <SelectItem value="autres">📦 Autres</SelectItem>
                        </SelectContent>
                      </Select>
                      <Input value={it.description} onChange={(e) => updateReviseItem(it._k, { description: e.target.value })}
                        className="flex-1 min-w-[120px] bg-slate-700/50 border-slate-600 text-white h-8 text-xs" />
                      <Input type="number" step="any" value={it.quantity || 1}
                        onChange={(e) => updateReviseItem(it._k, { quantity: parseFloat(e.target.value.replace(',', '.')) || 1 })}
                        className="w-[60px] bg-slate-700/50 border-slate-600 text-white h-8 text-xs" />
                      <Input type="number" value={it.unit_price || 0}
                        onChange={(e) => updateReviseItem(it._k, { unit_price: parseFloat(e.target.value) || 0 })}
                        className="w-[90px] bg-slate-700/50 border-slate-600 text-white h-8 text-xs" />
                      <span className="text-amber-300 text-xs w-20 text-right">= {formatPrice(it.amount)} F</span>
                      <Button size="sm" variant="ghost" onClick={() => removeReviseItem(it._k)}
                        className="text-red-400 hover:text-red-300 hover:bg-red-500/20 h-7 w-7 p-0">
                        <Trash2 className="w-3 h-3" />
                      </Button>
                    </div>
                  ))}
                </CardContent>
              </Card>

              {/* Add new article */}
              <Card className="bg-amber-900/20 border-amber-500/30">
                <CardHeader className="pb-2">
                  <CardTitle className="text-amber-300 text-sm flex items-center gap-2">
                    <Plus className="w-4 h-4" /> Ajouter un article
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-wrap gap-2">
                    <Select value={reviseNewItem.category} onValueChange={(v) => setReviseNewItem({...reviseNewItem, category: v})}>
                      <SelectTrigger className="w-[120px] bg-slate-700/50 border-slate-600 text-white"><SelectValue /></SelectTrigger>
                      <SelectContent className="bg-slate-800 border-slate-700">
                        <SelectItem value="cuisine">🍳 Cuisine</SelectItem>
                        <SelectItem value="bar">🍹 Bar</SelectItem>
                        <SelectItem value="paiement">💳 Paiement</SelectItem>
                        <SelectItem value="autres">📦 Autres</SelectItem>
                      </SelectContent>
                    </Select>
                    <Input value={reviseNewItem.description} onChange={(e) => setReviseNewItem({...reviseNewItem, description: e.target.value})}
                      placeholder="Description" className="flex-1 min-w-[150px] bg-slate-700/50 border-slate-600 text-white"
                      data-testid="revise-new-desc" />
                    <Input type="number" step="any" value={reviseNewItem.quantity || ""} onChange={(e) => setReviseNewItem({...reviseNewItem, quantity: parseFloat(e.target.value.replace(',', '.')) || 1})}
                      placeholder="Qté" className="w-[70px] bg-slate-700/50 border-slate-600 text-white" />
                    <Input type="number" value={reviseNewItem.unit_price || ""} onChange={(e) => setReviseNewItem({...reviseNewItem, unit_price: parseFloat(e.target.value) || 0})}
                      placeholder="PU" className="w-[100px] bg-slate-700/50 border-slate-600 text-white" />
                    <Button onClick={addReviseItem} className="bg-amber-600 hover:bg-amber-700" data-testid="revise-add-item-btn">
                      <Plus className="w-4 h-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>

              <div>
                <Label className="text-slate-300 text-sm">Note à la responsable op. & log</Label>
                <Textarea value={reviseNote} onChange={(e) => setReviseNote(e.target.value)}
                  placeholder="Ex : j'ai ajusté les quantités, merci de vérifier..."
                  className="bg-slate-700/50 border-slate-600 text-white"
                  data-testid="revise-note-input" />
              </div>

              <div className="bg-amber-900/20 rounded-lg p-3 flex justify-between items-center">
                <span className="text-slate-300">Nouveau total :</span>
                <span className="text-xl font-bold text-amber-300">{formatPrice(getReviseTotal())} F</span>
              </div>

              <div className="flex gap-2 justify-end pt-2 flex-wrap">
                <Button variant="outline" onClick={() => setShowReviseModal(false)} className="border-slate-600 text-slate-300">Annuler</Button>
                <Button onClick={() => submitRevision(false)} className="bg-amber-600 hover:bg-amber-700" data-testid="submit-revision-btn">
                  <Edit2 className="w-4 h-4 mr-2" /> Renvoyer à la responsable op. & log
                </Button>
                <Button onClick={() => submitRevision(true)} className="bg-green-600 hover:bg-green-700" data-testid="submit-revise-approve-btn">
                  <CheckCircle className="w-4 h-4 mr-2" /> Approuver directement
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Week Assignment Modal for Expenses */}
      <Dialog open={showWeekAssignModal} onOpenChange={(open) => {
        setShowWeekAssignModal(open);
        if (!open) setExpenseToAssign(null);
      }}>
        <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-cyan-400">
              <Calendar className="w-5 h-5" />
              Rattacher à une semaine
            </DialogTitle>
          </DialogHeader>
          {expenseToAssign && (
            <div className="space-y-4 py-4">
              <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700">
                <p className="text-slate-400 text-sm">Dépense sélectionnée:</p>
                <p className="text-white font-medium">{expenseToAssign.description}</p>
                <p className="text-amber-400 font-bold">{formatPrice(expenseToAssign.amount)} F</p>
              </div>
              
              <div>
                <Label className="text-slate-400 text-sm mb-2 block">Sélectionner la semaine</Label>
                <div className="space-y-2 max-h-60 overflow-y-auto">
                  {/* Generate last 8 weeks */}
                  {Array.from({ length: 8 }, (_, i) => {
                    const weekStart = new Date();
                    weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1 - (i * 7)); // Monday
                    const weekEnd = new Date(weekStart);
                    weekEnd.setDate(weekEnd.getDate() + 6); // Sunday
                    const weekStartStr = format(weekStart, "yyyy-MM-dd");
                    const isCurrentWeek = i === 0;
                    const isSelected = expenseToAssign.assigned_week === weekStartStr;
                    
                    return (
                      <Button
                        key={weekStartStr}
                        variant={isSelected ? "default" : "outline"}
                        className={`w-full justify-start ${
                          isSelected 
                            ? 'bg-cyan-600 text-white' 
                            : 'border-slate-600 text-slate-300 hover:bg-slate-700'
                        }`}
                        onClick={async () => {
                          await assignExpenseToWeek(expenseToAssign.id, weekStartStr);
                          setShowWeekAssignModal(false);
                          setExpenseToAssign(null);
                        }}
                      >
                        <Calendar className="w-4 h-4 mr-2" />
                        {format(weekStart, "dd/MM")} - {format(weekEnd, "dd/MM/yyyy")}
                        {isCurrentWeek && (
                          <Badge className="ml-2 bg-cyan-500/30 text-cyan-300 text-xs">Cette semaine</Badge>
                        )}
                      </Button>
                    );
                  })}
                </div>
              </div>
              
              {expenseToAssign.assigned_week && (
                <Button
                  variant="outline"
                  className="w-full border-red-500/50 text-red-400 hover:bg-red-500/20"
                  onClick={async () => {
                    await assignExpenseToWeek(expenseToAssign.id, null);
                    setShowWeekAssignModal(false);
                    setExpenseToAssign(null);
                  }}
                >
                  <X className="w-4 h-4 mr-2" />
                  Retirer le rattachement
                </Button>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* End of Service Modal (for Servers) */}
      <Dialog open={showEndOfServiceModal} onOpenChange={setShowEndOfServiceModal}>
        <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-xl">
              <ClipboardList className="w-6 h-6 text-indigo-400" />
              Terminer Mon Service
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            {/* Summary Preview */}
            {serverDailyReport ? (
              <div className="bg-slate-900/50 rounded-lg p-4 border border-slate-700">
                <h4 className="text-sm font-medium text-slate-400 mb-3">Résumé de votre journée</h4>
                <div className="grid grid-cols-3 gap-3 text-center">
                  <div className="bg-indigo-900/30 rounded-lg p-2">
                    <p className="text-2xl font-bold text-indigo-400">{serverDailyReport.total_invoices}</p>
                    <p className="text-xs text-slate-500">Commandes</p>
                  </div>
                  <div className="bg-green-900/30 rounded-lg p-2">
                    <p className="text-2xl font-bold text-green-400">{serverDailyReport.validated_count}</p>
                    <p className="text-xs text-slate-500">Validées</p>
                  </div>
                  <div className="bg-amber-900/30 rounded-lg p-2">
                    <p className="text-2xl font-bold text-amber-400">{formatPrice(serverDailyReport.total_sales)} F</p>
                    <p className="text-xs text-slate-500">Total</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-slate-900/30 rounded-lg p-3 border border-slate-700 text-center text-slate-400 text-xs">
                Chargement du résumé… (vous pouvez quand même envoyer votre point)
              </div>
            )}

            {/* Observation Field */}
            <div>
              <Label className="text-slate-300 text-sm mb-2 block">
                Observation (optionnel)
              </Label>
              <Textarea
                value={endOfServiceObservation}
                onChange={(e) => setEndOfServiceObservation(e.target.value)}
                placeholder="Ex: Retard livraison fournisseur, problème caisse, incident client..."
                className="bg-slate-900/50 border-slate-700 text-white placeholder:text-slate-500 min-h-[100px]"
              />
              <p className="text-xs text-slate-500 mt-1">
                Cette observation sera envoyée à la responsable op. & log avec votre point journalier
              </p>
            </div>
          </div>
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={() => setShowEndOfServiceModal(false)}
              className="flex-1 border-slate-600 text-slate-300 hover:bg-slate-700"
            >
              Annuler
            </Button>
            <Button
              onClick={submitEndOfService}
              disabled={isSubmittingEndOfService}
              className="flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700"
              data-testid="envoyer-point-btn"
            >
              {isSubmittingEndOfService ? (
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Send className="w-4 h-4 mr-2" />
              )}
              Envoyer le Point
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Free Accompaniment Modal */}
      <FreeAccompModal
        open={showFreeAccompModal}
        onOpenChange={setShowFreeAccompModal}
        accompagnements={DEFAULT_CATALOG.accompagnements}
        formatPrice={formatPrice}
        onAdd={addFreeAccompaniment}
      />

      {/* Server Report Detail Modal (for Manager viewing server's point) */}
      <Dialog open={!!viewingServerReport} onOpenChange={(open) => { if (!open) { setViewingServerReport(null); setViewingServerDetailedReport(null); setReportComparison(null); setValidationComment(""); } }}>
        <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-3 text-xl">
              <div className="p-2 bg-indigo-900/50 rounded-lg">
                <User className="w-6 h-6 text-indigo-400" />
              </div>
              <div className="flex-1">
                <span className="text-white">Point de {viewingServerReport?.server_name}</span>
                <p className="text-sm text-slate-400 font-normal mt-0.5">
                  {viewingServerReport?.date && new Date(viewingServerReport.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              </div>
              {/* Status Badge - Always show, default to pending if no status */}
              <Badge className={
                viewingServerReport?.status === 'validated' ? 'bg-green-500/20 text-green-400' :
                viewingServerReport?.status === 'revision_requested' ? 'bg-orange-500/20 text-orange-400' :
                viewingServerReport?.status === 'rejected' ? 'bg-red-500/20 text-red-400' :
                'bg-amber-500/20 text-amber-400'
              }>
                {viewingServerReport?.status === 'validated' ? 'Validé' :
                 viewingServerReport?.status === 'revision_requested' ? 'Révision demandée' :
                 viewingServerReport?.status === 'rejected' ? 'Rejeté' :
                 'En attente'}
              </Badge>
            </DialogTitle>
          </DialogHeader>
          
          {loadingServerDetail ? (
            <div className="py-12 text-center">
              <RefreshCw className="w-8 h-8 text-indigo-400 mx-auto animate-spin mb-3" />
              <p className="text-slate-400">Chargement du rapport détaillé...</p>
            </div>
          ) : viewingServerDetailedReport ? (
            <div className="space-y-4 py-4">
              
              {/* COMPARISON SECTION - Declared vs Actual */}
              {reportComparison && (
                <Card className={`border-2 ${reportComparison.discrepancy?.has_discrepancy ? 'border-orange-500/50 bg-orange-900/10' : 'border-green-500/50 bg-green-900/10'}`}>
                  <CardHeader className="pb-2">
                    <CardTitle className="text-white flex items-center gap-2 text-base">
                      <BarChart3 className="w-5 h-5" />
                      Comparaison Déclaré vs Réel
                      {reportComparison.discrepancy?.has_discrepancy ? (
                        <Badge className="bg-orange-500/20 text-orange-400 ml-2">Écarts détectés</Badge>
                      ) : (
                        <Badge className="bg-green-500/20 text-green-400 ml-2">Conforme</Badge>
                      )}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-slate-600">
                            <th className="text-left py-2 text-slate-400"></th>
                            <th className="text-center py-2 text-slate-400">Déclaré</th>
                            <th className="text-center py-2 text-slate-400">Réel (Système)</th>
                            <th className="text-center py-2 text-slate-400">Écart</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b border-slate-700">
                            <td className="py-3 text-slate-300">Commandes créées</td>
                            <td className="py-3 text-center text-white font-medium">{reportComparison.declared?.total_invoices}</td>
                            <td className="py-3 text-center text-white font-medium">{reportComparison.actual?.total_invoices}</td>
                            <td className={`py-3 text-center font-bold ${reportComparison.discrepancy?.invoices === 0 ? 'text-green-400' : reportComparison.discrepancy?.invoices > 0 ? 'text-blue-400' : 'text-red-400'}`}>
                              {reportComparison.discrepancy?.invoices > 0 ? '+' : ''}{reportComparison.discrepancy?.invoices}
                            </td>
                          </tr>
                          <tr className="border-b border-slate-700">
                            <td className="py-3 text-slate-300">Factures validées</td>
                            <td className="py-3 text-center text-white font-medium">{reportComparison.declared?.validated_invoices}</td>
                            <td className="py-3 text-center text-white font-medium">{reportComparison.actual?.validated_invoices}</td>
                            <td className={`py-3 text-center font-bold ${reportComparison.actual?.validated_invoices === reportComparison.declared?.validated_invoices ? 'text-green-400' : 'text-orange-400'}`}>
                              {reportComparison.actual?.validated_invoices - reportComparison.declared?.validated_invoices > 0 ? '+' : ''}
                              {reportComparison.actual?.validated_invoices - reportComparison.declared?.validated_invoices}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-3 text-slate-300 font-medium">Total des ventes</td>
                            <td className="py-3 text-center text-amber-400 font-bold">{formatPrice(reportComparison.declared?.total_sales)} F</td>
                            <td className="py-3 text-center text-amber-400 font-bold">{formatPrice(reportComparison.actual?.total_sales)} F</td>
                            <td className={`py-3 text-center font-bold ${Math.abs(reportComparison.discrepancy?.sales) < 1 ? 'text-green-400' : reportComparison.discrepancy?.sales > 0 ? 'text-blue-400' : 'text-red-400'}`}>
                              {reportComparison.discrepancy?.sales > 0 ? '+' : ''}{formatPrice(reportComparison.discrepancy?.sales)} F
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {reportComparison.discrepancy?.has_discrepancy && (
                      <div className="mt-3 p-3 bg-orange-500/10 rounded-lg border border-orange-500/30">
                        <p className="text-orange-400 text-sm flex items-center gap-2">
                          <AlertTriangle className="w-4 h-4" />
                          Des écarts ont été détectés entre les chiffres déclarés et les données du système.
                        </p>
                      </div>
                    )}
                  </CardContent>
                </Card>
              )}

              {/* Summary Cards */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <Card className="bg-gradient-to-br from-indigo-900/30 to-purple-900/20 border-indigo-500/50">
                  <CardContent className="p-4 text-center">
                    <Receipt className="w-6 h-6 text-indigo-400 mx-auto mb-1" />
                    <p className="text-2xl font-bold text-indigo-400">{viewingServerDetailedReport.total_invoices}</p>
                    <p className="text-slate-400 text-xs">Commandes créées</p>
                  </CardContent>
                </Card>
                <Card className="bg-gradient-to-br from-green-900/30 to-emerald-900/20 border-green-500/50">
                  <CardContent className="p-4 text-center">
                    <CheckCircle className="w-6 h-6 text-green-400 mx-auto mb-1" />
                    <p className="text-2xl font-bold text-green-400">{viewingServerDetailedReport.validated_count}</p>
                    <p className="text-slate-400 text-xs">Factures validées</p>
                  </CardContent>
                </Card>
                <Card className="bg-gradient-to-br from-amber-900/30 to-orange-900/20 border-amber-500/50">
                  <CardContent className="p-4 text-center">
                    <Clock className="w-6 h-6 text-amber-400 mx-auto mb-1" />
                    <p className="text-2xl font-bold text-amber-400">{viewingServerDetailedReport.pending_count}</p>
                    <p className="text-slate-400 text-xs">En attente</p>
                  </CardContent>
                </Card>
                <Card className="bg-gradient-to-br from-emerald-900/30 to-teal-900/20 border-emerald-500/50">
                  <CardContent className="p-4 text-center">
                    <DollarSign className="w-6 h-6 text-emerald-400 mx-auto mb-1" />
                    <p className="text-2xl font-bold text-emerald-400">{formatPrice(viewingServerDetailedReport.total_sales)} F</p>
                    <p className="text-slate-400 text-xs">Total validé</p>
                  </CardContent>
                </Card>
              </div>

              {/* Observation from Server */}
              {viewingServerReport?.observation && (
                <Card className="bg-slate-900/50 border-indigo-500/30">
                  <CardContent className="p-4">
                    <div className="flex items-start gap-3">
                      <MessageSquare className="w-5 h-5 text-indigo-400 mt-0.5" />
                      <div>
                        <p className="text-indigo-400 font-medium text-sm mb-1">Observation du agent</p>
                        <p className="text-white italic">"{viewingServerReport.observation}"</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Breakdown by Department */}
              {viewingServerDetailedReport.department_breakdown && Object.keys(viewingServerDetailedReport.department_breakdown).length > 0 && (
                <Card className="bg-slate-800/50 border-slate-700">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-slate-300 flex items-center gap-2 text-base">
                      <BarChart3 className="w-5 h-5" />
                      Répartition par Département
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      {Object.entries(viewingServerDetailedReport.department_breakdown).map(([dept, data]) => {
                        const deptConfig = DEPARTMENT_CONFIG[dept];
                        return (
                          <div key={dept} className={`p-3 rounded-lg ${deptConfig?.bgColor || 'bg-slate-700/30'} border ${deptConfig?.borderColor || 'border-slate-600'}`}>
                            <p className={`font-medium text-sm ${deptConfig?.color || 'text-slate-300'}`}>{deptConfig?.label || dept}</p>
                            <p className="text-white text-lg font-bold">{formatPrice(data.total)} F</p>
                            <p className="text-slate-400 text-xs">{data.count} article(s)</p>
                          </div>
                        );
                      })}
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Breakdown by Payment Method */}
              {viewingServerDetailedReport.payment_methods && Object.keys(viewingServerDetailedReport.payment_methods).length > 0 && (
                <Card className="bg-slate-800/50 border-slate-700">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-slate-300 flex items-center gap-2 text-base">
                      <Wallet className="w-5 h-5" />
                      Modes de Paiement
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      {Object.entries(viewingServerDetailedReport.payment_methods).map(([method, data]) => (
                        <div key={method} className="p-3 rounded-lg bg-slate-700/30 border border-slate-600">
                          <p className="text-slate-300 font-medium capitalize text-sm">
                            {method === 'cash' || method === 'especes' ? 'Espèces' : 
                             method === 'card' || method === 'carte' ? 'Carte' : 
                             method === 'mobile_money' ? 'Mobile Money' : 
                             method === 'mobile' ? 'Mobile Money' :
                             method === 'kkiapay' ? 'KKiapay' :
                             method === 'cheque' ? 'Chèque' : method}
                          </p>
                          <p className="text-white text-lg font-bold">{formatPrice(data.total)} F</p>
                          <p className="text-slate-400 text-xs">{data.count} transaction(s)</p>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Invoice List */}
              <Card className="bg-slate-800/50 border-slate-700">
                <CardHeader className="pb-2">
                  <CardTitle className="text-slate-300 flex items-center gap-2 text-base">
                    <FileText className="w-5 h-5" />
                    Factures du Jour ({viewingServerDetailedReport.invoices?.length || 0})
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {viewingServerDetailedReport.invoices?.length === 0 ? (
                    <p className="text-slate-500 text-center py-6">Aucune facture pour cette date</p>
                  ) : (
                    <div className="space-y-2 max-h-48 overflow-y-auto">
                      {viewingServerDetailedReport.invoices?.map((invoice) => (
                        <div key={invoice.id} className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg">
                          <div className="flex items-center gap-3 flex-wrap">
                            <span className="text-white font-medium">{invoice.invoice_number}</span>
                            <Badge className={
                              invoice.validation_status === 'validated' ? 'bg-green-500/20 text-green-400' :
                              invoice.validation_status === 'pending' ? 'bg-amber-500/20 text-amber-400' :
                              'bg-slate-500/20 text-slate-400'
                            }>
                              {invoice.validation_status === 'validated' ? 'Validée' : 
                               invoice.validation_status === 'pending' ? 'En attente' : invoice.validation_status}
                            </Badge>
                            {invoice.table_number && (
                              <Badge className="bg-slate-600/50 text-slate-300">Table {invoice.table_number}</Badge>
                            )}
                            {/* Payment Method Badge */}
                            {invoice.payment_method && invoice.validation_status === 'validated' && (
                              <Badge className={
                                invoice.payment_method === 'cash' ? 'bg-green-600/30 text-green-300' :
                                invoice.payment_method === 'mobile' ? 'bg-orange-600/30 text-orange-300' :
                                invoice.payment_method === 'card' ? 'bg-blue-600/30 text-blue-300' :
                                invoice.payment_method === 'kkiapay' ? 'bg-pink-600/30 text-pink-300' :
                                'bg-slate-600/30 text-slate-300'
                              }>
                                {invoice.payment_method === 'cash' ? '💵 Espèces' : 
                                 invoice.payment_method === 'mobile' ? '📱 Mobile' : 
                                 invoice.payment_method === 'card' ? '💳 Carte' :
                                 invoice.payment_method === 'kkiapay' ? '🅺 KKiapay' : invoice.payment_method}
                              </Badge>
                            )}
                          </div>
                          <div className="flex items-center gap-3">
                            <span className="text-amber-400 font-bold">{formatPrice(invoice.total)} F</span>
                            <span className="text-slate-500 text-sm">
                              {new Date(invoice.created_at).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* VALIDATION SECTION - Only for manager/admin and pending reports */}
              {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (!viewingServerReport?.status || viewingServerReport?.status === 'pending') && (
                <Card className="bg-slate-900/50 border-slate-600">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-slate-300 flex items-center gap-2 text-base">
                      <CheckCircle className="w-5 h-5" />
                      Valider ce Point
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <Label className="text-slate-400 text-sm">Commentaire (optionnel)</Label>
                      <Textarea
                        value={validationComment}
                        onChange={(e) => setValidationComment(e.target.value)}
                        placeholder="Ajouter un commentaire pour le agent..."
                        className="bg-slate-800 border-slate-600 text-white mt-1"
                        rows={2}
                      />
                    </div>
                    <div className="flex gap-3">
                      <Button 
                        onClick={() => handleReportValidation(viewingServerReport.id, 'validate', validationComment)}
                        className="flex-1 bg-green-600 hover:bg-green-700"
                      >
                        <CheckCircle className="w-4 h-4 mr-2" />
                        Valider
                      </Button>
                      <Button 
                        onClick={() => handleReportValidation(viewingServerReport.id, 'request_revision', validationComment)}
                        variant="outline"
                        className="flex-1 border-orange-500 text-orange-400 hover:bg-orange-500/20"
                      >
                        <RefreshCw className="w-4 h-4 mr-2" />
                        Réviser
                      </Button>
                      <Button 
                        onClick={() => handleReportValidation(viewingServerReport.id, 'reject', validationComment)}
                        variant="outline"
                        className="flex-1 border-red-500 text-red-400 hover:bg-red-500/20"
                      >
                        <X className="w-4 h-4 mr-2" />
                        Rejeter
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* DELETE SECTION - For manager with code verification */}
              {currentUser?.role === 'manager' && (
                <Card className="bg-slate-900/50 border-slate-600">
                  <CardContent className="p-4">
                    {!showDeleteConfirm ? (
                      <Button 
                        onClick={() => setShowDeleteConfirm(true)}
                        variant="outline"
                        className="w-full border-red-500/50 text-red-400 hover:bg-red-500/20"
                      >
                        <Trash2 className="w-4 h-4 mr-2" />
                        Supprimer ce point
                      </Button>
                    ) : (
                      <div className="space-y-3">
                        <div className="flex items-center gap-2 text-red-400 text-sm">
                          <AlertTriangle className="w-4 h-4" />
                          <span>Entrez le code de suppression pour confirmer</span>
                        </div>
                        <div className="flex gap-2">
                          <Input
                            type="password"
                            value={deleteReportCode}
                            onChange={(e) => setDeleteReportCode(e.target.value)}
                            placeholder="Code à 4 chiffres"
                            className="bg-slate-800 border-slate-600 text-white flex-1"
                            maxLength={4}
                          />
                          <Button 
                            onClick={() => handleDeleteServerReport(viewingServerReport.id)}
                            className="bg-red-600 hover:bg-red-700"
                          >
                            Confirmer
                          </Button>
                          <Button 
                            onClick={() => { setShowDeleteConfirm(false); setDeleteReportCode(""); }}
                            variant="outline"
                            className="border-slate-500"
                          >
                            Annuler
                          </Button>
                        </div>
                      </div>
                    )}
                  </CardContent>
                </Card>
              )}

              {/* Already validated info */}
              {viewingServerReport?.status && viewingServerReport.status !== 'pending' && (
                <Card className={`border ${
                  viewingServerReport.status === 'validated' ? 'bg-green-900/20 border-green-500/50' :
                  viewingServerReport.status === 'revision_requested' ? 'bg-orange-900/20 border-orange-500/50' :
                  'bg-red-900/20 border-red-500/50'
                }`}>
                  <CardContent className="p-4">
                    <div className="flex items-center gap-3">
                      {viewingServerReport.status === 'validated' ? (
                        <CheckCircle className="w-5 h-5 text-green-400" />
                      ) : viewingServerReport.status === 'revision_requested' ? (
                        <RefreshCw className="w-5 h-5 text-orange-400" />
                      ) : (
                        <X className="w-5 h-5 text-red-400" />
                      )}
                      <div>
                        <p className={`font-medium ${
                          viewingServerReport.status === 'validated' ? 'text-green-400' :
                          viewingServerReport.status === 'revision_requested' ? 'text-orange-400' :
                          'text-red-400'
                        }`}>
                          {viewingServerReport.status === 'validated' ? 'Point validé' :
                           viewingServerReport.status === 'revision_requested' ? 'Révision demandée' :
                           'Point rejeté'}
                        </p>
                        <p className="text-slate-400 text-sm">
                          Par {viewingServerReport.validated_by} le {viewingServerReport.validated_at && new Date(viewingServerReport.validated_at).toLocaleString('fr-FR')}
                        </p>
                        {viewingServerReport.validation_comment && (
                          <p className="text-slate-300 text-sm mt-1 italic">"{viewingServerReport.validation_comment}"</p>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Timestamp */}
              <p className="text-slate-500 text-xs text-center">
                Point envoyé le {viewingServerReport?.created_at && new Date(viewingServerReport.created_at).toLocaleString('fr-FR', { 
                  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' 
                })}
              </p>
            </div>
          ) : (
            <div className="py-12 text-center">
              <AlertCircle className="w-8 h-8 text-red-400 mx-auto mb-3" />
              <p className="text-slate-400">Impossible de charger le rapport détaillé</p>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Share Modal with QR Code */}
      <ShareModal open={showShareModal} onOpenChange={setShowShareModal} />

      {/* Kitchen Tracker Modal — Resp. Op. & Admin */}
      {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
        <KitchenTrackerModal
          open={showKitchenTracker}
          onOpenChange={setShowKitchenTracker}
          currentUser={currentUser}
        />
      )}

      {/* Jeux Bons Modal — Resp. Op. & Admin */}
      {(currentUser?.role === 'manager' || currentUser?.role === 'admin') && (
        <JeuxBonsModal
          open={showJeuxBonsModal}
          onOpenChange={setShowJeuxBonsModal}
          currentUser={currentUser}
          openTables={openTables}
        />
      )}

      {/* Régularisation rétroactive de bons */}
      <RegularizationModal
        open={showRegularizationModal}
        onClose={() => setShowRegularizationModal(false)}
        mode={regularizationMode}
        currentUser={currentUser}
        existingInvoice={regularizationTargetInvoice}
        products={products}
        onSuccess={() => { fetchAllData?.(); }}
      />
    </div>
  );
};

export default CaissePage;
